import type { Dict } from '../types';

export const en: Dict = {
  "collab.contentUpdate.available": "Updates on another device",
  "collab.contentUpdate.updating": "Syncing…",
  "collab.contentUpdate.askAgain": "Restore update prompts",
  "collab.contentUpdate.title": "Updates on another device",
  "collab.contentUpdate.description": "Sync the latest content from another device to this device? This replaces local project content. Pages can be restored from local version history; images and other files may not be recoverable.",
  "collab.contentUpdate.dontPrompt": "Do not prompt for this project for 24 hours",
  "collab.contentUpdate.later": "Not now",
  "collab.contentUpdate.replace": "Sync and overwrite",
  "collab.contentUpdate.failed": "Update failed. Please try again.",
  "collab.contentUpdate.busy": "Generation or upload is in progress. Try again afterward.",
  "collab.contentUpdate.unsupported": "Cloud replacement is not supported for imported folders.",
  "fileViewer.versions.sourceSync": "Synced",
  'billing.wallet': 'Wallet balance',
  'billing.codingPlanDesignPlan': 'Design Plan',
  'billing.codingPlanPeriodHours': '{count} hours',
  'billing.codingPlanPeriodDays': '{count} days',
  'billing.codingPlanRemainingPercent': '{percent}% left',
  "campaign.testReplay": "Reopen test activity",
  'invite.header.eyebrow': "Team invitation",
  'invite.loading': "Loading invitation…",
  'invite.landing.title': "Join the team",
  'invite.landing.subtitle': "You’ve been invited to collaborate in OpenDesign.",
  'invite.landing.roleLabel': "Role",
  'invite.landing.invitedEmail': "Invited email",
  'invite.landing.expires': "Expires",
  'invite.role.admin': "Admin",
  'invite.role.member': "Member",
  'invite.role.admin.desc': "Can manage members, seats, and all project settings.",
  'invite.role.member.desc': "Can create your own projects, and view and comment on shared team projects.",
  'invite.accept.cta': "Accept invitation",
  'invite.accountMismatch.title': "You’re signed in as a different account",
  'invite.accountMismatch.body': "This invitation was sent to a different email address. You can continue with your current account, or switch accounts.",
  'invite.accountMismatch.continue': "Continue with current account",
  'invite.accountMismatch.switch': "Switch account",
  'invite.accepting.title': "Joining the team…",
  'invite.accepting.body': "Setting up your membership.",
  'invite.success.title': "You’re in",
  'invite.success.body': "Opening OpenDesign so you can start collaborating.",
  'invite.success.roleReceipt': "Joined as",
  'invite.success.enter': "Enter workspace",
  'invite.open.cta': "Open OpenDesign",
  'invite.open.opening': "Opening OpenDesign…",
  'invite.open.retry': "Already installed? Try opening again",
  'invite.notInstalled.title': "Didn’t open automatically?",
  'invite.notInstalled.body': "You may not have OpenDesign installed yet. Install it, then reopen this link to finish joining.",
  'invite.notInstalled.download': "Download OpenDesign",
  'invite.error.title': "Can’t accept this invitation",
  'invite.error.invite_expired': "This invitation has expired. Ask an admin to send a new one.",
  'invite.error.invite_consumed': "This invitation has already been used.",
  'invite.error.workspace_seat_limit_reached': "The team has no seats left. Ask an admin to free up a seat or add more.",
  'invite.error.workspace_subscription_locked': "The team’s subscription is inactive, so new members can’t join right now.",
  'invite.error.workspace_not_found': "This workspace no longer exists.",
  'invite.error.workspace_forbidden': "Your account isn’t allowed to accept this invitation.",
  'invite.error.invite_unavailable': "This invitation is no longer available.",
  'invite.error.generic': "Something went wrong. Please try again.",
  'invite.error.retry': "Try again",
  "workspaceInvite.dialogAria": "Invite members",
  "workspaceInvite.title": "Invite members to your team",
  "workspaceInvite.freePlanBody": "The free plan includes 1 seat. Inviting teammates will guide you to upgrade to Teams.",
  "workspaceInvite.teamPlanBody": "Invite teammates to share projects, design systems, and plugins together.",
  "workspaceInvite.seatsExhaustedBody": "This workspace has no seats left. Add seats to invite teammates.",
  "workspaceInvite.seatsExhaustedAction": "View seats and plan",
  "workspaceInvite.emailLabel": "Invite members by email",
  "workspaceInvite.roleLabel": "Assign role",
  "workspaceInvite.defaultRoleLabel": "Default role",
  "workspaceInvite.emailPlaceholder": "Enter email address…",
  "workspaceInvite.removeRow": "Remove",
  "workspaceInvite.addMember": "Add member",
  "workspaceInvite.visibilityQuestion": "Will team members see my designs?",
  "workspaceInvite.visibilityAnswer": "Team members can see designs you share to the team space. Private designs kept in Personal projects are not visible to others.",
  "workspaceInvite.sent": "Invitation sent",
  "workspaceInvite.sending": "Inviting…",
  "workspaceInvite.confirm": "Confirm and invite",
  "workspaceInvite.submitFailed": "Failed to send invitation. Try again later.",
  "workspaceInvite.errorAlreadyMember": "This email is already a team member.",
  "workspaceInvite.errorPendingInvite": "This email already has a pending invitation.",
  "workspaceInvite.errorNoSession": "Sign in to your Vela account before inviting members.",
  "workspaceInvite.errorNoWorkspace": "There's no team workspace to invite members to yet.",
  "workspaceInvite.errorUnreachable": "The invitation couldn't be delivered. Please try again later.",
  'chat.amrCard.switchTitle': 'Model call failed — this run is paused',
  'chat.amrCard.switchBody': 'Switch to OpenDesign Cloud — no API key setup needed. After you sign in, authorize, and top up, this run retries automatically.',
  'chat.amrCard.chipOfficial': 'Official hosting',
  'chat.amrCard.chipNoKey': 'No API key',
  'chat.amrCard.chipAutoRetry': 'Auto-retry after sign-in',
  'chat.amrCard.switchCta': 'Switch to OpenDesign Cloud',
  "chat.amrCard.switchedResend": "Switched to OpenDesign Cloud. Please resend your task.",
  'chat.amrError.authMessage': 'Your OpenDesign Cloud account isn\'t authorized yet. Authorize it and this run retries automatically.',
  'chat.amrError.balanceMessage': 'Your OpenDesign Cloud allowance has run out. Top up to keep this run going.',
  'chat.amrError.authorizeCta': 'Authorize & retry',
  'chat.amrError.rechargeCta': 'Top up',
  'chat.amrBalanceGate.title': 'Insufficient allowance',
  'chat.amrBalanceGate.message': 'Your allowance is insufficient. Top up or upgrade your plan, then try again.',
  'chat.amrBalanceGate.benefitsTitle': 'What you get with OpenDesign Cloud',
  'chat.amrBalanceGate.benefit1': 'No API keys — top models included',
  'chat.amrBalanceGate.benefit2': 'SOTA design agent built in, zero setup',
  'chat.amrBalanceGate.benefit3': 'Official service you can rely on',
  'chat.amrBalanceGate.benefit4': 'Always improving: one-click publishing, multimodal generation, teams, and more',
  'chat.amrBalanceGate.laterCta': 'Not now',
  'chat.amrBalanceGate.plansCta': 'Upgrade plan',
  'chat.amrBalanceGate.signedOutTitle': 'Open Design is not signed in',
  'chat.amrBalanceGate.signedOutMessage': 'Sign in to see your projects and continue the conversation.',
  'chat.amrBalanceGate.signInCta': 'Sign in',
  'chat.amrBalanceGate.watchingWallet': 'We\'ll continue automatically once your allowance updates.',
  'chat.amrArtifactUpgrade.title': 'Keep refining with stronger models',
  'chat.amrArtifactUpgrade.message': 'Unlock advanced models, more parallel tasks, and more monthly credits.',
  'chat.amrArtifactUpgrade.benefit1': 'More advanced models, including Fable 5 and GPT-5.6',
  'chat.amrArtifactUpgrade.benefit2': 'Run up to 10× more tasks concurrently',
  'chat.amrArtifactUpgrade.benefit3': 'Up to 300× more monthly credits',
  'chat.amrArtifactUpgrade.benefit4': 'Priority queue at peak times for faster generations',
  'chat.amrArtifactUpgrade.promoBanner': 'Limited time: save up to 67% on plans',
  'chat.amrArtifactUpgrade.countdownLabel': 'Offer ends in',
  'chat.amrArtifactUpgrade.plansCta': 'Upgrade now, up to 67% off',
  'chat.amrArtifactUpgrade.homePlansCta': 'Save 67%',
  'chat.amrArtifactUpgrade.laterCta': 'Continue with Free and send',
  'chat.amrArtifactUpgrade.homeTitle': 'Your artifact is ready. Take the next idea further.',
  'chat.amrArtifactUpgrade.homeMessage': 'Upgrade for stronger models, more parallel tasks, and more monthly credits.',
  'chat.amrArtifactUpgrade.homeArtifactCta': 'View work',
  'chat.antigravityError.launchTerminalCta': 'Sign in via terminal',
  'chat.antigravityError.launchSwitchModelCta': 'Switch model in terminal',
  'chat.connectionDropped': 'Check that your network connection is working, then try again.',
  'chat.runError.title.authRequired': 'Authorization required',
  'chat.runError.title.balance': 'Insufficient allowance',
  'chat.runError.title.connectionDropped': 'Network connection lost',
  'chat.runError.title.signInRequired.other': '{agent} is not signed in',
  'chat.runError.title.signInRequired.amr': 'Open Design is not signed in',
  'chat.runError.title.rateLimited': 'Model service is busy',
  'chat.runError.title.modelWindowLimit': 'High demand right now',
  'chat.runError.title.membershipConcurrencyLimit': 'Concurrent task limit reached',
  'chat.runError.title.strategyTaskHalted': "Task halted by quality gate",
  "chat.runError.title.agentReplyIncomplete": "The task could not be completed",
  'chat.runError.title.noDeliverable': "Nothing came out this round",
  'chat.runError.title.clarificationRepeated': "The agent asked another question",
  "chat.runError.title.regionNotSupported": "This service is currently unavailable in your region",
  'chat.runError.title.clientEnvironment': 'Network environment problem',
  "chat.runError.title.certificateFailure": "Unable to connect securely to the service",
  "chat.runError.certificateFailureMessage": "The service connection failed security verification. Please try a different network.",
  "chat.runError.title.proxyConfiguration": "Unable to connect to the proxy",
  "chat.runError.proxyConfigurationMessage": "The configured proxy cannot be reached. Please make sure the proxy is running and configured correctly, then try again.",
  "chat.runError.title.networkConfiguration": "Unable to connect to the service",
  "chat.runError.networkConfigurationMessage": "The service is temporarily unreachable. Please check your network connection and try again.",
  "chat.runError.title.hostPolicyBlock": "Program launch blocked",
  "chat.runError.hostPolicyBlockMessage": "Windows blocked the program from starting. Please check your system security settings.",
  "chat.runError.title.localStorageFailure": "Unable to save the file",
  "chat.runError.localStorageFailureMessage": "The file could not be written to disk. Please make sure there is enough free space, then try again.",
  "chat.runError.title.tierUpgradeRequired": "Your current plan does not support this task",
  "chat.runError.tierUpgradeRequiredMessage": "Your current plan cannot continue this task. Please upgrade your plan and try again.",
  "chat.runError.title.generic": "The task could not be completed",
  'chat.runError.title.artifactMissing': "No files to preview",
  'chat.runError.artifactMissingMessage': "This task produced no files to preview. Add what you want generated and try again.",
  'chat.runError.signInMessage.amr': 'Sign in to see your projects and continue the conversation.',
  'chat.runError.signInMessage.other': 'Sign in to {agent} first, then try again.',
  'chat.runError.agentFallback': 'the agent',
  'chat.runError.sourceLabel': 'Error details',
  'chat.runError.sourceExpandAria': 'Expand error source',
  'chat.runError.sourceCollapseAria': 'Collapse error source',
  'chat.runError.title.cliMissing': '{agent} not detected',
  'chat.runError.title.promptTooLarge': 'Conversation too long',
  'chat.runError.title.modelUnavailable': "This model is unavailable",
  'chat.runError.title.modelCapabilityUnsupported': "This model doesn’t support this task",
  'chat.runError.title.upstreamUnavailable': 'Model service unavailable',
  "chat.runError.title.toolLoop": "The task cannot continue",
  'chat.runError.title.outputInvalid': 'No valid reply generated',
  'chat.runError.title.runtimeConfig': "Open Design error",
  'chat.runError.title.apiKeyInvalid': 'Incomplete model settings',
  'chat.runError.cliMissingMessage': 'Check that {agent} is installed on this computer, then try again.',
  "chat.runError.promptTooLargeMessage": "The current context exceeds the length the model can handle. Please start a new conversation and try again.",
  'chat.runError.modelUnavailableMessage': "Please pick another available model and try again.",
  'chat.runError.modelCapabilityUnsupportedMessage': "This model doesn’t support the capabilities this task needs. Switch models and try again.",
  'chat.runError.rateLimitedMessage': 'There are a lot of requests to this model service right now and the provider\'s rate limit has been reached. Try again later, or try switching to another model.',
  'chat.runError.modelWindowLimitMessage': 'High demand right now — please try again after {retryAt}. This request was not charged.',
  'chat.runError.modelWindowLimitMessageNoTime': 'High demand right now — please try again shortly. This request was not charged.',
  'chat.runError.membershipConcurrencyLimitMessage': 'Your membership\'s concurrent task limit is full. Wait until {retryAt}, then retry, or switch to another agent. Immediate retries will not help.',
  'chat.runError.membershipConcurrencyLimitMessageNoTime': 'Your membership\'s concurrent task limit is full. Wait for another task to finish, then retry, or switch to another agent. Immediate retries will not help.',
  'chat.runError.upstreamUnavailableMessage': 'The current model is temporarily unavailable. Try again later, or switch models.',
  "chat.runError.toolLoopMessage": "The AI got stuck on the same step and could not continue after several attempts. Please retry, or switch models and try again.",
  'chat.runError.outputInvalidMessage': 'Try generating again, or switch models and retry. If this keeps happening, contact support.',
  'chat.runError.runtimeConfigMessage': 'Try generating again, or switch models and retry. If this keeps happening, contact support.',
  'chat.runError.apiKeyInvalidMessage': 'The API key is misconfigured. Re-enter it, then try again.',
  'chat.runError.title.quotaExhausted': "Quota exhausted",
  'chat.runError.title.timedOut': "Reply timed out",
  "chat.runError.title.emptyOutput": "Unable to generate content",
  "chat.runError.title.sessionExpired": "Unable to resume the previous task",
  'chat.runError.title.gitBashMissing': "Git Bash missing",
  "chat.runError.title.cpuUnsupported": "This device cannot run the program",
  "chat.runError.title.osUnsupported": "Windows version too old",
  'chat.runError.title.cliSessionRefused': "Agent version incompatible",
  'chat.runError.quotaExhaustedMessage': "Your model service's quota or billing limit is used up, so retrying won't help. Top up with your provider, or switch to another model or service.",
  'chat.runError.workspaceCreditsMessage': "Your workspace is out of allowance. Top up (or ask your workspace owner to increase the allowance), or switch to another model or service.",
  'chat.runError.timedOutMessage': "No new reply from the AI for a long time, so this run has stopped. Please try again later.",
  'chat.runError.inactivityTimeoutMessage': "No new reply from the AI for a long time, so this run has stopped. Please try again later.",
  "chat.runError.emptyOutputMessage": "The AI could not generate content. Please start the task again, or switch models and try again.",
  "chat.runError.sessionExpiredMessage": "The previous task can no longer continue. Please start the task again.",
  'chat.runError.gitBashMissingMessage': "Git Bash is required to run this agent on Windows but wasn't found. Install Git for Windows, then retry.",
  "chat.runError.cpuUnsupportedMessage": "This computer's processor does not support the features required by the program. Please use a device that meets the system requirements.",
  "chat.runError.osUnsupportedMessage": "This version of Windows is too old to run the AMR runtime. Update to Windows 10 version 1809 (build 17763) or later, then try again.",
  'chat.runError.title.agentCrashed': 'Task interrupted unexpectedly',
  "chat.runError.agentCrashedMessage": "Try generating again, or switch models and retry. If this keeps happening, contact support.",
  'chat.runError.title.accountSuspended': 'Account suspended',
  "chat.runError.accountSuspendedMessage": "To find out why or request reinstatement, contact support.",
  "chat.runError.fallbackMessage": "This task failed to run. Please retry. If it fails again, please contact support.",
  "chat.runError.cliSessionRefusedMessage": "Open Design does not currently support this agent version. Please switch to a supported version and try again.",
  'chat.runError.strategyTaskStateMismatchMessage': "This task was already halted by the strategy quality gate, so this round of the form can't continue. Retry the request or start a new one.",
  "chat.runError.agentReplyIncompleteMessage": "This task failed to run. Please retry. If it fails again, please contact support.",
  'chat.runError.noDeliverableMessage': "The agent finished, but there is no openable file in the project yet, so the task could not be recorded as delivered. Nothing you sent was lost — retry, or add a line about what you want and send again.",
  'chat.runError.clarificationRepeatedMessage': "The agent asked for more detail a second time, but a task has room for only one round of questions, so it stopped here. Your answers are still in the conversation — retrying starts the request over, and folding the extra detail into it usually settles things in one round.",
  "chat.runError.regionNotSupportedMessage": "The provider does not currently offer service in your region. The current task cannot continue.",
  'chat.runError.clientEnvironmentMessage': 'Looks like the request went through a proxy or a corporate network, and {agent} rejected it ({cause}). Try a different network route, or adjust the proxy in Settings.',
  'chat.runError.clientEnvironmentCause.certificate': 'certificate verification failed',
  'chat.runError.clientEnvironmentCause.proxy': 'proxy configuration problem',
  'chat.runError.clientEnvironmentCause.network': 'network unreachable',
  'chat.runError.clientEnvironmentCause.hostPolicy': 'blocked by a system policy',
  'chat.runError.clientEnvironmentCause.localStorage': 'local storage read/write failed',
  'common.cancel': 'Cancel',
  'chat.selectFromLibrary': 'Import from library',
  'chat.importFigma': 'Import from Figma',
  'chat.plus.group.files': 'Files',
  'chat.plus.group.code': 'Code',
  'chat.plus.group.designs': 'Designs',
  'chat.plus.group.other': 'Other',
  'chat.plus.attachFiles': 'Attach files',
  'chat.plus.referenceProject': 'Reference another project',
  'chat.plus.linkLocalCode': 'Link local code',
  'chat.plus.uploadFig': 'Upload .fig file',
  'chat.plus.learnHow': 'Learn how',
  'chat.plus.designSystem': 'Design system',
  'chat.plus.skills': 'Skills',
  'chat.plus.noSkills': 'No skills available',
  'chat.plus.connectors': 'Connectors',
  'chat.plus.plugins': 'Plugins',
  'chat.plus.mcp': 'MCP',
  'chat.referenceProject.title': 'Reference another project',
  'chat.referenceProject.search': 'Search projects…',
  'chat.referenceProject.empty': 'No projects match “{query}”',
  'chat.referenceProject.emptyAll': 'No other projects yet',
  'chat.referenceProject.loadFailed': 'Could not load projects. Check that the daemon is running and try again.',
  'chat.referenceProject.confirm': 'Reference project',
  'chat.contextPrompt.referenceProject': 'Use the OpenDesign project “{name}” as reference context. Its local path is: {path}. Before designing or modifying anything, search and read this directory when useful.',
  'chat.contextPrompt.localCode': 'Use the local code folder “{name}” as code reference. Its absolute path is: {path}. Read relevant files when useful and stay consistent with the existing implementation.',
  'chat.figmaHelp.title': 'How to download a .fig file',
  'chat.figmaHelp.intro': 'From the Figma web or desktop app:',
  'chat.figmaHelp.step1': 'Open the file in Figma.',
  'chat.figmaHelp.step2': 'Go to File → Save local copy... (web: main menu → File).',
  'chat.figmaHelp.step3': 'Figma downloads a .fig file. Drop it onto the composer or upload it.',
  'chat.figmaHelp.note': 'The .fig file is parsed locally and is not uploaded to Figma.',
  'designFiles.library.label': 'Import from library',
  'designFiles.library.title': 'Import from library',
  'libraryPicker.title': 'Import from library',
  'libraryPicker.searchPlaceholder': 'Search library…',
  'libraryPicker.empty': 'No assets in your library yet',
  'libraryPicker.allKinds': 'All',
  'libraryPicker.add': 'Import',
  'libraryPicker.loading': 'Loading…',
  'common.save': 'Save',
  'common.close': 'Close',
  'common.clear': 'Clear',
  'common.delete': 'Delete',
  'common.rename': 'Rename',
  'common.edit': 'Edit',
  'common.preview': 'Preview',
  'common.share': 'Share',
  'common.search': 'Search',
  'common.searchEllipsis': 'Search…',
  'common.loading': 'Loading…',
  'common.all': 'All',
  'common.none': 'None',
  'common.default': 'Default',
  'common.installed': 'installed',
  'common.notInstalled': 'not installed',
  'common.active': 'active',
  'common.inactive': 'inactive',
  'common.offline': 'offline',
  'common.selected': 'selected',
  'common.create': 'Create',
  'common.openPreview': 'Open preview',
  'common.exitFullscreen': 'Exit fullscreen',
  'common.fullscreen': 'Fullscreen',
  'common.openInNewTab': 'Open in new tab',
  'common.exportPdf': 'Export as PDF',
  'common.exportZip': 'Download as .zip',
  'common.exportHtml': 'Export as standalone HTML',
  'common.exportImage': 'Export as image',
  'common.exportImageFailed': 'Image capture failed. Please try again or use your browser\'s screenshot tool.',
  'common.justNow': 'just now',
  'common.minutesAgo': '{n}m ago',
  'common.hoursAgo': '{n}h ago',
  'common.daysAgo': '{n}d ago',
  'common.weeksAgo': '{n}w ago',
  'common.now': 'now',
  'common.minutesShort': '{n}m',
  'common.hoursShort': '{n}h',
  'common.daysShort': '{n}d',
  'common.untitled': 'Untitled',
  'designBrowser.savePageBrief': 'Save Page Brief',
  'designBrowser.viewport.desktop': 'Desktop',
  'designBrowser.viewport.desktopTitle': 'Use the full browser tab size',
  'designBrowser.viewport.tablet': 'Tablet',
  'designBrowser.viewport.tabletTitle': 'Preview at 820px wide',
  'designBrowser.viewport.mobile': 'Mobile',
  'designBrowser.viewport.mobileTitle': 'Preview at 390px wide',
  'designBrowser.menu': 'Browser menu',
  'designBrowser.copyScreenshot': 'Copy Screenshot',
  'designBrowser.hardReload': 'Hard Reload',
  'designBrowser.copyUrl': 'Copy URL',
  'designBrowser.openExternal': 'Open in Browser',
  'designBrowser.downloadPage': 'Download Page',
  'designBrowser.downloadPageBusy': 'Downloading page...',
  'designBrowser.clearHistory': 'Clear Browsing History',
  'designBrowser.clearCookies': 'Clear Cookies',
  'designBrowser.clearAllData': 'Clear All Data',
  'designBrowser.status.noUrlToCopy': 'No URL to copy.',
  'designBrowser.status.urlCopied': 'URL copied.',
  'designBrowser.status.openHttpFirst': 'Open an http or https page first.',
  'designBrowser.status.openBeforeScreenshot': 'Open a page before taking a screenshot.',
  'designBrowser.status.screenshotSaved': 'Screenshot saved.',
  'designBrowser.addImageToChatButton': 'Add to Chat',
  'designBrowser.status.imageAddedToChat': 'Image added to chat.',
  'designBrowser.status.screenshotFailed': 'Screenshot failed.',
  'designBrowser.status.openBeforeBrief': 'Open a page before saving a brief.',
  'designBrowser.status.briefSaveFailed': 'Page brief save failed.',
  'designBrowser.status.openBeforeDownload': 'Open a page before saving a snapshot.',
  'designBrowser.status.pageSnapshotStarted': 'Saving page snapshot...',
  'designBrowser.status.pageSnapshotUnsupported': 'This page cannot be archived.',
  'designBrowser.status.pageSnapshotFailed': 'Page snapshot save failed.',
  'designBrowser.status.pageSnapshotSaved': 'Saved page snapshot (HTML + CSS).',
  'designBrowser.status.viewDesignFiles': 'View Design Files',
  'designBrowser.status.downloadAssistHint': 'When the page is ready, click Download Page. Return to chat after it is saved.',
  'designBrowser.status.desktopDataUnavailable': 'Desktop browser data is unavailable here.',
  'designBrowser.status.browserDataCleared': 'Browser data cleared.',
  'designBrowser.status.browserDataClearFailed': 'Browser data clear failed.',
  'designBrowser.status.historyCleared': 'History cleared.',
  'plugins.availableDetails.provenance': 'Provenance',
  'plugins.availableDetails.provenanceLine': 'from {source} · {trust} · {resolved}',
  'plugins.availableDetails.provenanceLineWithIntegrity': 'from {source} · {trust} · {resolved} · {integrity}',
  'plugins.availableDetails.install': 'Install',
  'plugins.availableDetails.version': 'Version',
  'plugins.availableDetails.pluginVersion': 'Plugin version',
  'plugins.availableDetails.copyInstallCommand': 'Copy install command',
  'plugins.availableDetails.copied': 'Copied',
  'plugins.availableDetails.deprecatedPrefix': 'Deprecated: {message}',
  'plugins.availableDetails.deprecatedFallback': 'This version has been marked deprecated.',
  'plugins.availableDetails.yanked': 'Yanked.',
  'plugins.availableDetails.yankedWithReason': 'Yanked: {reason}',
  'plugins.availableDetails.versionDeprecatedSuffix': ' (deprecated)',
  'plugins.availableDetails.versionYankedSuffix': ' (yanked)',
  'plugins.availableDetails.ref': 'Ref',
  'plugins.availableDetails.integrity': 'Integrity',
  'plugins.availableDetails.permissions': 'Permissions',
  'plugins.availableDetails.capabilitySummary': 'Capability summary',
  'plugins.actions.copyInstallCommand': 'Copy install command',
  'plugins.actions.copyPluginId': 'Copy plugin ID',
  'plugins.actions.copyReadmeBadge': 'Copy README badge',
  'plugins.actions.openSourceGithub': 'Open source on GitHub',
  'plugins.actions.openSource': 'Open source',
  'plugins.actions.openHomepage': 'Open homepage',
  'plugins.actions.openMarketplace': 'Open in marketplace',
  'app.brand': 'OpenDesign',
  'app.brandPill': 'Research Preview',
  'app.brandSubtitle': 'by Nexu Labs',
  'app.welcomeLoading': 'Loading workspace…',
  'settings.welcomeKicker': '',
  'settings.welcomeTitle': 'Welcome to OpenDesign',
  'settings.welcomeSubtitle': '',
  'settings.onboardingCreateTitle': 'Start from a brief',
  'settings.onboardingCreateBody': 'Describe the site, app, deck, image, or video you want. OpenDesign will create a project and keep the work editable.',
  'settings.onboardingMemoryTitle': 'Save working context',
  'settings.onboardingMemoryBody': 'Add preferences, project facts, and recurring rules so future chats pick up the right context.',
  'settings.onboardingMemoryCalloutTitle': 'Saved to your Memory',
  'settings.onboardingMemoryCalloutBody': 'These answers seed your Memory profile. OpenDesign reuses it on every task — and keeps learning as you work.',
  'settings.onboardingMemoryBenefitIntent': 'Understands what you mean from a short request',
  'settings.onboardingMemoryBenefitFewerQuestions': 'Skips repeat setup questions',
  'settings.onboardingMemoryBenefitPersonalized': 'Tailors output to your role, audience, and taste',
  'settings.onboardingSystemsTitle': 'Bring your design system',
  'settings.onboardingSystemsBody': 'Pick or create a brand system so generated work follows real colors, typography, and product language.',
  'settings.onboardingExecutionTitle': 'Choose your model source',
  'settings.onboardingExecutionBody': 'Use the OpenDesign hosted service, connect a local coding agent, or bring your own model key.',
  'settings.onboardingAmrCloudBenefitOfficial': 'Officially recommended',
  'settings.onboardingAmrCloudBenefitReady': 'No deploy needed',
  'settings.onboardingAmrCloudBenefitModels': 'Access Claude, GPT, Fable 5, and 5.6 sol with a limited-time discount and high concurrency.',
  'settings.onboardingAmrCloudBenefitPricing': 'SOTA Harness',
  'settings.onboardingAmrCloudUpcomingLabel': 'Coming soon',
  'settings.onboardingAmrCloudUpcomingImageVideo': 'Image & video',
  'settings.onboardingAmrCloudUpcomingSkills': 'Massive skills',
  'settings.onboardingAmrCloudUpcomingRouting': 'Smart routing',
  'settings.onboardingAmrModelSourceLabel': 'OpenDesign Hosted',
  'settings.onboardingAmrCloudAuthorizeAction': 'Authorize',
  'settings.onboardingAmrCloudAuthorizedAction': 'Authorized',
  'settings.onboardingStepConnect': 'Connect',
  'settings.onboardingStepDesignSystem': 'Build design system',
  'settings.onboardingStepProfile': 'About you',
  'settings.onboardingStepNewsletter': 'Stay updated',
  'settings.onboardingNewsletterTitle': 'Stay in the loop',
  'settings.onboardingNewsletterBody': 'Get product updates, new templates, design-system drops, and ambassador work in your inbox. Optional — you can skip this.',
  'settings.onboardingConnectTitle': 'Choose a runtime',
  'settings.onboardingConnectBody': '',
  'settings.onboardingCloudTitle': 'Welcome to OpenDesign',
  'settings.onboardingCloudBody': 'Turn your ideas into designs.',
  'settings.onboardingCloudSignIn': 'Sign in / Sign up',
  'settings.onboardingFreeCredits': 'Free Credits',
  'settings.onboardingFreeCreditsHint': 'New users get free starter credits to try DeepSeek V4.1 Flash.',
  'settings.onboardingOwnAi': 'Or use your own AI',
  'settings.onboardingLocalAi': 'Local AI',
  'settings.onboardingApiKey': 'API Key',
  'settings.onboardingCloudContinue': 'Continue (signed in)',
  'settings.onboardingCloudAlternative': 'Use a local CLI or your own API key',
  'settings.onboardingCloudRights': 'All rights reserved.',
  'settings.onboardingCloudOr': 'or',
  'settings.onboardingGateTooltipNoRuntime': 'The next steps run on AI — pick a runtime to continue.',
  'settings.onboardingGateTooltipAmr': 'The next steps run on AI — sign in to OpenDesign Cloud to continue.',
  'settings.onboardingGateTooltipLocal': 'The next steps run on AI — select an available local CLI to continue.',
  'settings.onboardingGateTooltipByok': 'The next steps run on AI — add and test your model key to continue.',
  'settings.onboardingRecommended': 'Recommended',
  'settings.onboardingAmrCloudOfficialBadge': 'Official',
  'settings.onboardingLocalTitle': 'Local Agent',
  'settings.onboardingLocalBody': 'Use Claude Code, Codex, Cursor, OpenCode, Kimi, Qwen, Hermes, Kiro, and more.',
  'settings.onboardingLocalAction': 'Open CLI settings',
  'settings.onboardingCliScanHint': 'This usually takes 5-10 seconds.',
  'settings.onboardingByokTitle': 'Bring Your Own Key',
  'settings.onboardingByokBody': 'Connect your preferred model provider securely with your own API key.',
  'settings.onboardingByokAction': 'Open BYOK settings',
  'settings.onboardingDesignTitle': 'Design system',
  'settings.onboardingDesignBody': 'Generate once, reuse everywhere.',
  'settings.onboardingDesignIntroGenerateTitle': 'Generate from existing work',
  'settings.onboardingDesignIntroGenerateBody': 'Upload your design system from GitHub or local code repositories, Figma files, images, and other content assets.',
  'settings.onboardingDesignIntroReuseTitle': 'Reuse in future work',
  'settings.onboardingDesignIntroReuseBody': 'Future prototypes, slides, and other content can reference your existing fonts, spacing, logo style, and color tone.',
  'settings.onboardingDesignIntroSkipTitle': 'Optional for now',
  'settings.onboardingDesignIntroSkipBody': 'Skip this step if you want to start without generating a design system.',
  'settings.onboardingGithubTitle': 'Import from GitHub',
  'settings.onboardingGithubBody': 'Use a frontend repository.',
  'settings.onboardingUploadTitle': 'Upload local files',
  'settings.onboardingUploadBody': 'Add project files, screenshots, CSS, docs, or assets.',
  'settings.onboardingPromptTitle': 'Generate from prompt',
  'settings.onboardingPromptBody': 'Describe the product or brand.',
  'settings.onboardingProfileTitle': 'About you',
  'settings.onboardingProfileBody': 'Optional details for better defaults.',
  'settings.onboardingRoleLabel': 'Your role',
  'settings.onboardingOrgSizeLabel': 'Organization size',
  'settings.onboardingUseCaseLabel': 'Use case',
  'settings.onboardingSourceLabel': 'Where did you hear about us?',
  'settings.onboardingSourceX': '🐦 X / Twitter',
  'settings.onboardingSourceGithub': '🐙 GitHub',
  'settings.onboardingSourceYoutube': '▶️ YouTube',
  'settings.onboardingSourceTiktok': '🎵 TikTok',
  'settings.onboardingSourceReddit': '👽 Reddit',
  'settings.onboardingSourceLinkedin': '💼 LinkedIn',
  'settings.onboardingSourceMetaSocial': '📸 Instagram / Threads / Facebook',
  'settings.onboardingSourceSearch': '🔍 Search (Google / Bing)',
  'settings.onboardingSourceAiTool': '🤖 AI tool (ChatGPT / Perplexity)',
  'settings.onboardingSourceFriend': '👥 Friend or colleague',
  'settings.onboardingSourceCommunity': '💬 Discord / community',
  'settings.onboardingSourceEmail': '✉️ Email / Newsletter',
  'settings.onboardingSourceBlog': '📝 Blog / article',
  'settings.onboardingSourceOther': '✨ Other',
  'settings.onboardingSourceOtherPlaceholder': 'Tell us where (optional)',
  'settings.onboardingSelectPlaceholder': 'Select one',
  'settings.onboardingSelectMultiplePlaceholder': 'Select one or more',
  'settings.onboardingOrgSolo': 'Solo / personal (1)',
  'settings.onboardingOrgTeam': 'Small team (2-10)',
  'settings.onboardingOrgStartup': 'Startup / SMB (11-50)',
  'settings.onboardingOrgGrowth': 'Growth company (51-200)',
  'settings.onboardingOrgMidMarket': 'Mid-market (201-1000)',
  'settings.onboardingOrgEnterprise': 'Enterprise (1000+)',
  'settings.onboardingRolePm': '📋 Product manager',
  'settings.onboardingRoleDesigner': '🎨 Designer',
  'settings.onboardingRoleEngineer': '💻 Engineer',
  'settings.onboardingRoleMarketing': '📣 Marketing',
  'settings.onboardingRoleAgency': '📣 Marketing agency',
  'settings.onboardingRoleGrowth': '📈 Growth',
  'settings.onboardingRoleOps': '⚙️ Operations',
  'settings.onboardingRoleFounder': '🚀 Founder / executive',
  'settings.onboardingRoleStudent': '🎓 Student / educator',
  'settings.onboardingRoleOther': '✨ Other',
  'settings.onboardingUseProduct': '🎨 Product design',
  'settings.onboardingUseDesignSystem': '🧩 Design system',
  'settings.onboardingUsePrototype': '📱 Prototype / app UI',
  'settings.onboardingUseLanding': '🌐 Landing pages',
  'settings.onboardingUseAds': '📣 Ads / social content',
  'settings.onboardingUseDashboard': '📊 Dashboards / internal tools',
  'settings.onboardingUseDeck': '🖥️ Presentation / deck',
  'settings.onboardingUseMarketing': '📈 Marketing / growth',
  'settings.onboardingUseEngineering': '🤝 Engineering handoff',
  'settings.onboardingUseAgency': '💼 Agency / client work',
  'settings.onboardingBack': 'Back',
  'settings.onboardingContinue': 'Continue',
  'settings.onboardingFinish': 'Finish setup',
  'settings.kicker': 'Settings',
  'settings.title': 'Models & providers',
  'settings.subtitle': 'Choose Local CLI or BYOK.',
  'settings.general': 'General',
  'settings.generalHint': 'Language, appearance, notifications, project locations, privacy, and app details.',
  'settings.modeAria': 'Execution mode',
  'settings.protocolAria': 'API protocol',
  'settings.modeDaemon': 'Local CLI',
  'settings.modeDaemonHelp': 'Run via a code-agent CLI on your machine',
  'settings.modeDaemonOffline': 'Daemon is not running',
  'settings.modeDaemonOfflineMeta': 'daemon offline',
  'settings.modeDaemonInstalledMeta': '{count} installed',
  'settings.modeApi': 'API provider',
  'settings.cloudCalloutTitle': 'Use OpenDesign Cloud',
  'settings.cloudCalloutBody': 'Sign in to the cloud version to enable team spaces, shared projects, member permissions, and the audit dashboard.',
  'settings.cloudCalloutButton': 'Sign in / Register',
  'settings.modeApiMeta': 'API providers',
  'settings.byokNoFileToolsNotice': 'BYOK can\'t read, write, or edit project files. Use Local CLI when you need code changes.',
  'settings.byokDraftNotice': 'Complete the required fields to save this provider. Your current setup will remain active.',
  'settings.codeAgent': 'Code agent',
  'settings.codeAgentHint': 'Choose which CLI runs your prompts.',
  'settings.rescan': '↻ Rescan',
  'settings.rescanTitle': 'Re-scan PATH',
  'settings.rescanRunning': 'Scanning...',
  'settings.rescanSuccess': 'Scan complete. {count} available.',
  'settings.designSystemRenameFailed': 'Rename failed. Check that the daemon is running and try again.',
  'settings.rescanFailed': 'Scan failed. Check the daemon and try again.',
  'settings.test': 'Test',
  'settings.testTitle': 'Send a tiny test prompt to verify the connection',
  'settings.testRunning': 'Testing connection…',
  'settings.byokReadyToTest': 'Ready to test',
  'settings.testCancel': 'Cancel',
  'settings.testRetry': 'Retry test',
  'settings.required': 'required',
  'settings.testMissingFields': 'Fill {fields} to test the connection.',
  'settings.testSuccessApi': 'Connected. Replied in {ms} ms — \'{sample}\'',
  'settings.testSuccessCli': '{agentName} replied in {ms} ms — \'{sample}\'',
  'settings.testAuthFailed': 'Authentication failed. Check your API key.',
  'settings.testForbidden': 'Access forbidden. Verify your account, region, or organization.',
  'settings.testNotFoundModel': 'Model \'{model}\' not found on this endpoint.',
  'settings.testInvalidModelId': 'Model id \'{model}\' is invalid. Custom ids must start with a letter or number and contain no spaces.',
  'settings.testInvalidBaseUrl': 'Base URL is invalid or unreachable.',
  'settings.testRateLimited': 'Provider rate-limited the test. Configuration looks valid.',
  'settings.testUpstream': 'Provider returned {status}. Try again in a moment.',
  'settings.testTimeout': 'Test timed out after {ms} ms.',
  'settings.testAgentMissing': '{agentName} is not installed or not in PATH.',
  'settings.testAgentSpawn': 'Could not start {agentName}: {detail}.',
  'settings.testUnknown': 'Test failed: {detail}',
  'settings.agentInstall.install': 'Install',
  'settings.agentInstall.docs': 'View docs',
  'settings.agentInstall.pathHint': 'If you installed a CLI with npm or Homebrew and it still shows as not installed, ensure the tool\'s bin directory is on the PATH the OpenDesign daemon inherits (Terminal vs GUI apps can differ on macOS). See QUICKSTART.md (section "Local agent CLI and PATH").',
  'settings.agentInstall.stepOpenLinks': 'Open Install or Docs for your preferred agent.',
  'settings.agentInstall.stepAuth': 'Authenticate with the vendor CLI (sign in or add API credentials) before returning to OpenDesign.',
  'settings.agentInstall.stepRescan': 'Click Rescan in this section.',
  'settings.agentInstall.stepSelect': 'Select the agent card once it appears as installed.',
  'settings.noAgentsDetected': 'No agents detected yet. Install one of Claude Code, Codex, Devin for Terminal, OpenCode, Cursor Agent, Qwen, or GitHub Copilot CLI, then click Rescan.',
  'settings.agentInstalledGroup': 'Installed CLIs ({count})',
  'settings.agentInstallGroup': 'Available CLIs ({count})',
  'settings.agentAuthRequired': 'Authentication required',
  'settings.agentAuthUnknown': 'Auth status unknown',
  'settings.amrCloud': 'OpenDesign Cloud',
  'settings.amrAuthorize': 'Authorize',
  'settings.amrBenefitOfficial': 'Official',
  'settings.amrBenefitLowerPrice': 'Lower cost',
  'settings.amrBenefitManyModels': 'Many models',
  'settings.amrPromoBonus': 'Limited bonus: +100%',
  'settings.amrSignInToContinue': 'Sign in to continue',
  'settings.amrSignIn': 'Sign in',
  'settings.amrSignedIn': 'Signed in',
  'settings.amrWalletBalance': 'Wallet balance',
  'settings.amrWalletUnavailable': 'Balance temporarily unavailable',
  'settings.amrWalletUpdatedAt': 'Updated {time}',
  'settings.amrWalletCached': 'cached',
  'settings.amrWalletRefresh': 'Refresh',
  'settings.amrWalletRefreshTitle': 'Refresh OpenDesign Cloud wallet balance',
  'settings.amrNotSignedIn': 'Not signed in',
  'settings.amrSigningIn': 'Signing in…',
  'settings.amrActivationHint': 'Sign-in page didn\'t open? Tap the button below to reopen it.',
  'settings.amrActivationBrowserFailedTitle': 'Couldn’t open the sign-in page',
  'settings.amrActivationBrowserFailedDescription': 'Your browser didn’t open automatically. Please try signing in again.',
  'settings.amrActivationOpen': 'Open sign-in page',
  'settings.amrCancelSignIn': 'Cancel sign-in',
  'settings.onboardingActivationPrompt': 'Sign-in page didn\'t open?',
  'settings.onboardingActivationBrowserFailed': 'Couldn\'t open your browser.',
  'settings.onboardingActivationReopen': 'Reopen',
  'settings.amrAccountStatus': 'OpenDesign Cloud account status',
  'settings.amrConsole': 'Manage',
  'settings.amrBalance': 'Allowance',
  'settings.amrPlan': 'Plan',
  'settings.amrUpgrade': 'Upgrade',
  'settings.amrModelUpgradeHint': 'Upgrade to use',
  'settings.amrLoginErrorCompact': 'Sign-in failed.',
  'settings.advanced': 'Advanced',
  'settings.amrLogin': 'Sign in',
  'settings.amrLogout': 'Sign out',
  'settings.amrLoggingIn': 'Signing in…',
  'settings.amrLoggingOut': 'Signing out…',
  'settings.amrLoggedInAs': 'Signed in as {email}',
  'settings.amrLoggedInWithPlan': 'Signed in as {email} · {plan}',
  'settings.amrLoggedInPill': 'Signed in',
  'settings.amrNotLoggedIn': 'Not signed in',
  'settings.apiSection': 'Anthropic API',
  'settings.quickFillProvider': 'Quick fill provider',
  'settings.providerPreset': 'Provider preset',
  'settings.protocolGroupProtocols': 'Protocols',
  'settings.protocolGroupGateways': 'Gateways',
  'settings.customProvider': 'Custom provider',
  'settings.apiKey': 'API key',
  'settings.apiKeyGetLink': 'Get key ↗',
  'settings.showKey': 'Show key',
  'settings.hideKey': 'Hide key',
  'settings.show': 'Show',
  'settings.hide': 'Hide',
  'settings.model': 'Model',
  'settings.apiKeyInvalid': 'Invalid API key.',
  'settings.apiKeyCleaned': 'Removed extra whitespace from the API key.',
  'settings.modelsLoadedFromAccount': '✓ Loaded {count} models from your account.',
  'settings.modelsLoadedCount': '✓ Loaded {count} models.',
  'settings.modelSourceAccount': 'From your account',
  'settings.modelSourceSuggested': 'Suggested',
  'modelCapability.standard': 'Standard',
  'modelCapability.advanced': 'Advanced',
  'modelCapability.bestQuality': 'Best Quality',
  'modelCapability.standardDescription': 'Solid quality for regular tasks.',
  'modelCapability.advancedDescription': 'Stronger quality for more demanding tasks.',
  'modelCapability.bestQualityDescription': 'Best output quality for the most demanding work.',
  'modelCost.upToHalf': 'Low cost',
  'modelCost.halfToOne': 'Medium cost',
  'modelCost.oneToFour': 'High cost',
  'modelCost.overFour': 'Highest cost',
  'settings.fetchModels': 'Fetch models',
  'settings.fetchModelsTitle': 'Fetch available models from this provider',
  'settings.fetchModelsRunning': 'Fetching models…',
  'settings.fetchModelsMissingFields': 'Fill {fields} to fetch models.',
  'settings.fetchModelsInvalidBaseUrl': 'Enter a valid Base URL to fetch models.',
  'settings.fetchModelsUnsupportedAzure': 'Azure OpenAI uses deployment names, so model discovery is not available here.',
  'settings.fetchModelsUnsupportedOllama': 'Ollama Cloud model discovery is not available yet. Choose or type a model.',
  'settings.fetchModelsSuccess': 'Fetched {count} models.',
  'settings.fetchModelsEmpty': 'No compatible text models were returned.',
  'settings.fetchModelsUnsupported': 'Model discovery is not available for this protocol.',
  'settings.fetchModelsFailed': 'Could not fetch models: {detail}',
  'settings.suggestedModelsHint': 'These are suggested models for this protocol. Your provider may support different models.',
  'settings.baseUrl': 'Base URL',
  'settings.baseUrlInvalid': 'Use a public http:// or https:// URL.',
  'settings.baseUrlCustomize': 'Customize URL',
  'settings.baseUrlDefaultHint': 'Change this only if you use a proxy or compatible gateway.',
  'settings.azureBaseUrlPlaceholder': 'Paste Azure endpoint URL',
  'settings.azureBaseUrlHint': 'Find this in Azure portal → your resource → Endpoint.',
  'settings.azureDeploymentModel': 'Deployment name',
  'settings.azureCustomDeploymentName': 'Custom deployment name',
  'settings.azureDeploymentModelHint': 'For Azure OpenAI, this field is used as the deployment name in /openai/deployments/<model>. Enter the deployment name you created in Azure.',
  'settings.azureModelFetchHint': 'Enter the deployment name from your Azure resource. Azure deployments can’t be fetched automatically.',
  'settings.apiVersion': 'API version',
  'settings.byokImageModel': 'Image generation model',
  'settings.byokVideoModel': 'Video generation model',
  'settings.byokVideoI2vHint': 'Image-to-video model: a reference image is required (the newest project image is used automatically if you don’t pick one)',
  'settings.byokSpeechModel': 'Speech model',
  'settings.byokSpeechVoice': 'Speech voice',
  'settings.byokModelDefaultOption': 'Default',
  'settings.maxTokens': 'Max tokens (optional)',
  'settings.maxTokensHint': 'Maximum response length. Leave blank to use the model default.',
  'settings.apiHint': 'Stored locally on this device.',
  'settings.skipForNow': 'Skip for now',
  'settings.getStarted': 'Get started',
  'settings.envConfigure': 'Models & providers',
  'settings.localCli': 'Local CLI',
  'settings.dshSetupTitle': 'Connect DeepSeek Harness',
  'settings.dshSetupDescription': 'OpenDesign will install its connection component through the dsh CLI on this computer.',
  'settings.dshSetupNote': 'Only the OpenDesign profile component is installed. DeepSeek Harness remains user-installed and user-managed.',
  'settings.dshSetupConfirm': 'Install and select',
  'settings.dshSetupInstalling': 'Installing…',
  'settings.dshSetupRequired': 'Connection setup required',
  'settings.anthropicApi': 'Anthropic API',
  'settings.noAgentSelected': 'no agent selected',
  'settings.language': 'Language',
  'settings.languageHint': 'Switch the interface language. Saved to this browser.',
  'settings.agentModelHead': 'Model for:',
  'settings.modelPicker': 'Model',
  'settings.modelSourceLive': 'Synced from CLI',
  'settings.modelUsesCliDefault': 'CLI default',
  'settings.modelSourceFallback': 'Built-in list',
  'settings.reasoningPicker': 'Reasoning effort',
  'settings.serviceTierPicker': 'Service tier',
  'settings.modelPickerHint': 'Default uses the CLI’s own config. Custom… lets you type any model id.',
  'settings.modelPickerLiveHint': 'Model list comes from this CLI. Default uses the CLI\'s own config.',
  'settings.modelPickerLiveCatalogOnlyHint': 'Model list comes from this CLI.',
  'settings.modelPickerFallbackHint': 'Showing built-in defaults. Click Rescan to pull live models from the CLI.',
  'settings.cliEnvTitle': 'Advanced: proxy & custom paths',
  'settings.cliEnvHint': 'Use these to override the selected CLI environment: API keys, proxy base URLs, custom homes, or non-standard binary paths. Without a base URL, the CLI uses its default endpoint. Secrets stay in local app config and only the selected CLI sees them.',
  'settings.cliEnvClaudeConfigDir': 'Claude Code config directory',
  'settings.cliEnvClaudeBaseUrl': 'Claude proxy base URL',
  'settings.cliEnvClaudeApiKey': 'Claude CLI API key',
  'settings.cliEnvCodexHome': 'Codex home',
  'settings.cliEnvCodexBin': 'Codex executable path',
  'settings.cliEnvCodexBaseUrl': 'Codex/OpenAI proxy base URL',
  'settings.cliEnvCodexApiKey': 'Codex/OpenAI CLI API key',
  'settings.modelCustom': 'Custom (type below)…',
  'settings.modelCustomLabel': 'Custom model id',
  'settings.modelCustomPlaceholder': 'e.g. anthropic/claude-sonnet-4-6',
  'settings.onboardingModelUseCustom': 'Use "{query}"',
  'settings.mediaProviders': 'Media providers',
  'settings.mediaProvidersHint': 'Connect providers for image, video, audio, and search.',
  'settings.mcpServerTitle': 'OpenDesign MCP',
  'settings.mcpServerHint': 'Expose OpenDesign as an MCP server for your coding agent.',
  'settings.externalMcpTitle': 'External MCP',
  'settings.externalMcpHint': 'Add MCP tools from external services (Higgsfield, GitHub, …).',
  'settings.mediaProviderApiKey': 'API key',
  'settings.mediaProviderBaseUrl': 'Base URL',
  'settings.mediaProviderConfigured': 'Configured',
  'settings.mediaProviderUnset': 'Unset',
  'settings.mediaProviderClear': 'Clear configuration',
  'settings.mediaProviderClearConfirm': 'Clear saved {name} settings? You\'ll need to enter them again to use {name}.',
  'settings.mediaProviderPlaceholder': 'Paste API key',
  'settings.mediaProviderBaseUrlPlaceholder': 'Override default base URL',
  'settings.mediaProviderReload': 'Refresh providers',
  'settings.mediaProviderReloadError': 'Could not refresh provider settings.',
  'settings.mediaProviderReloadSuccess': 'Provider settings refreshed.',
  'settings.mediaProviderLoadError': 'Could not load provider settings. Using locally saved settings for now.',
  'settings.mediaProviderComingSoonHint': 'These providers are planned but are not yet available to configure.',
  'settings.privacy': 'Privacy',
  'settings.privacyHint': 'What data is shared with the OpenDesign team',
  'settings.privacyConsentKicker': 'Help us improve OpenDesign',
  'settings.privacyConsentLead': 'Sharing usage data helps us understand how OpenDesign performs in real workflows, so we can improve the parts that matter most to your experience.',
  'settings.privacyConsentFooter': 'You can change these any time in Settings → Privacy.',
  'settings.privacyConsentShare': 'Share',
  'settings.privacyConsentDecline': 'Don\'t share',
  'settings.privacyConsentAccept': 'I get it',
  'settings.privacyConsentBannerFooter': 'Data sharing is on by default. You can turn it off any time in Settings → Privacy.',
  'settings.privacyConsentPolicyLink': 'Read the privacy policy',
  'settings.privacyMetrics': 'Anonymous metrics',
  'settings.privacyMetricsHint': 'Run counts, token usage, error rate, and duration as basic usage metrics.',
  'settings.privacyContent': 'Conversation and tool content',
  'settings.privacyContentHint': 'After secrets and other sensitive information are stripped, we use prompts, assistant responses, tool input/output, and context needed for quality review.',
  'settings.privacyInstallationId': 'Anonymous ID',
  'settings.privacyOptedOut': 'opted out',
  'settings.privacyDataDeletion': 'Delete my data',
  'settings.privacyDataDeletionHint': 'Rotates your anonymous ID and stops sending. Existing traces age out under our retention policy.',
  'settings.about': 'About',
  'settings.aboutHint': 'Version and runtime details',
  'settings.appVersion': 'Version',
  'settings.appChannel': 'Channel',
  'settings.appRuntime': 'Runtime',
  'settings.appPlatform': 'Platform',
  'settings.appArchitecture': 'Architecture',
  'settings.runtimePackaged': 'Packaged app',
  'settings.runtimeDevelopment': 'Development',
  'settings.versionUnavailable': 'Version details are unavailable while the daemon is offline.',
  "settings.allowSilentUpdates": "Allow automatic install of future in-app updates",
  "settings.allowSilentUpdatesDesc": "When an in-app update is ready, install it automatically the next time OpenDesign starts. Does not upgrade the current session. Installer updates still ask first.",
  'settings.installLatest': 'Install latest',
  'settings.alreadyLatest': 'You\'re on the latest version',
  'settings.updateCheck': 'Check for updates',
  'settings.updateNow': 'Update now',
  'settings.updateRecheck': 'Check again',
  'settings.updateRetry': 'Retry',
  'settings.updateViewReleases': 'View release notes',
  'settings.updateActionFailed': 'Could not complete the update action.',
  'settings.updateQuitFailed': 'The installer opened, but OpenDesign could not quit automatically.',
  'settings.updateStatusNotChecked': 'Not checked yet',
  'settings.updateStatusDevelopment': 'Development builds do not support in-app updates.',
  'settings.updateStatusUnsupported': 'This environment does not support in-app updates.',
  'settings.updateStatusChecking': 'Checking for updates...',
  'settings.updateStatusUpToDate': 'You are already on the latest version.',
  'settings.updateStatusAvailable': 'New version {version} found. Preparing download.',
  'settings.updateStatusAvailableUnknown': 'New version found. Preparing download.',
  'settings.updateStatusDownloading': 'Downloading update...',
  'settings.updateStatusDownloadingPercent': 'Downloading update {percent}%.',
  'settings.updateStatusReady': 'Version {version} is ready to install.',
  'settings.updateStatusReadyUnknown': 'An update is ready to install.',
  'settings.updateStatusInstalling': 'Installing update...',
  'settings.updateStatusFailed': 'Check failed. Please retry.',
  'settings.mcpTitle': 'Connect OpenDesign to your coding agent',
  'settings.mcpHint': 'Use MCP to give supported agents access to your projects and design context.',
  'settings.mcpDaemonError': 'Couldn\'t reach the local daemon to resolve install paths ({error}). Make sure OpenDesign is running, then reopen this panel.',
  'settings.mcpBuildDaemon': 'Build the daemon first.',
  'settings.mcpNodeMissing': 'Node binary is missing.',
  'settings.mcpBuildHint': 'apps/daemon/dist/cli.js is missing. Run `pnpm --filter @open-design/daemon build` and refresh.',
  'settings.mcpMethodCli': 'Setup command',
  'settings.mcpInstructionCli': 'Run this command in your terminal:',
  'settings.mcpMethodToml': 'TOML config',
  'settings.mcpInstructionCodex': 'Append this table to {path}. The same config is shared between the Codex CLI and the Codex IDE extension.',
  'settings.mcpMethodOneClick': 'One-click install',
  'settings.mcpInstructionCursor': 'Click "Install in Cursor" to install with an approval dialog, or merge this JSON into {path}.',
  'settings.mcpDeeplinkInstallCursor': 'Install in Cursor',
  'settings.mcpMethodJson': 'JSON config',
  'settings.mcpInstructionKiro': 'Open {path} and merge this JSON. For workspace-level config, use .kiro/settings/mcp.json.',
  'settings.mcpInstructionCopilot': 'Open the Command Palette ({shortcut}), run "MCP: Open User Configuration", and merge this JSON. Copilot Chat must be in Agent mode for tools to show up.',
  'settings.mcpInstructionAntigravity': 'In Antigravity: Agent panel "..." menu → MCP Servers → Manage MCP Servers → View raw config. Merge this JSON.',
  'settings.mcpInstructionZed': 'Open Zed Settings ({shortcut}) and merge this into the top-level object. Zed uses "context_servers", not "mcpServers".',
  'settings.mcpInstructionWindsurf': 'Open {path} (or use the MCPs icon in Cascade → Configure) and merge:',
  'settings.mcpCopyAria': 'Copy setup command',
  'settings.mcpResolvingFailed': '# resolving paths failed, see the error above',
  'settings.mcpLoadingPaths': '# loading install paths from the local daemon…',
  'settings.mcpCopied': 'Copied',
  'settings.mcpCopy': 'Copy command',
  'settings.mcpCursorApproval': 'Cursor pops an approval dialog before writing the config.',
  'settings.mcpCodexOneClickInstall': 'Install in Codex',
  'settings.mcpCodexOneClickUninstall': 'Remove from Codex',
  'settings.mcpCodexOneClickUnavailable': 'Codex CLI not found on PATH — install Codex or paste the snippet manually.',
  'settings.mcpCodexInstallSuccess': 'Installed. Restart Codex to load the new server.',
  'settings.mcpCodexUninstallSuccess': 'Removed from Codex.',
  'settings.mcpCodexBusy': 'Working…',
  'settings.mcpCodexInstallError': 'Operation failed: {error}',
  'settings.mcpRestartNote': 'Restart your coding agent after adding the server.',
  'settings.mcpRestartDetail': 'Most editors only load MCP servers at startup. In Cursor / VS Code / Antigravity / Windsurf you can run `Developer: Reload Window` from the command palette instead of a full restart. Zed and Claude Code need a quit and reopen.',
  'settings.mcpCapabilitiesTitle': 'What your agent can do',
  'settings.mcpCapabilityRead': 'Read or search any file in a project.',
  'settings.mcpCapabilityPull': 'Collect a design’s files, styles, components, and fonts as context.',
  'settings.mcpCapabilityDefault': 'Use the project and file currently open in OpenDesign as context.',
  'settings.mcpRunningNote': 'Keep OpenDesign running. Restart your coding agent after setup.',
  'entry.tabDesigns': 'Designs',
  'entry.tabTemplates': 'Templates',
  'entry.tabDesignSystems': 'Design systems',
  'entry.tabConnectors': 'Connectors',
  'entry.openSettingsTitle': 'Settings',
  'entry.openSettingsAria': 'Open settings',
  'entry.discordLabel': 'Join Discord',
  'entry.discordAria': 'Join our Discord for free credits',
  'entry.discordAriaWithOnline': 'Join the OpenDesign Discord - {online}',
  'entry.discordOnlineLabel': '{count} online',
  'entry.xAria': 'Follow @OpenDesignHQ for updates',
  'entry.mailAria': 'Questions? Email our team',
  'entry.accountSettings': 'Settings',
  'chat.collapsePane': 'Collapse the conversation pane',
  'collabPresence.ariaOne': '1 collaborator online',
  'collabPresence.aria': '{count} collaborators online',
  'collabPresence.ariaWithSelfOne': '1 collaborator online, including you',
  'collabPresence.ariaWithSelf': '{count} collaborators online, including you',
  'collabPresence.moreOnline': '{count} more online',
  'collabPresence.dialogTitle': 'Online collaborators',
  'collabPresence.onlineCount': '{count} online',
  'collabPresence.selfBadge': 'You',
  'collabPresence.roleOwner': 'Owner',
  'collabPresence.roleAdmin': 'Admin',
  'collabPresence.roleMember': 'Member',
  'collabPresence.viewingFileSelf': 'You are viewing {file}',
  'collabPresence.viewingFileOther': 'Viewing {file}',
  'collabPresence.viewingProjectSelf': 'You are viewing this project',
  'collabPresence.viewingProjectOther': 'Viewing this project',
  'entry.followXLabel': 'Follow @OpenDesignHQ on X',
  'entry.followThreadsLabel': 'Follow OpenDesign on Threads',
  'entry.youtubeLabel': 'OpenDesign on YouTube',
  'entry.followInstagramLabel': 'Follow @opendesign.ai on Instagram',
  'entry.followLinkedinLabel': 'Follow OpenDesign on LinkedIn',
  'entry.followXiaohongshuLabel': 'Follow OpenDesign on Xiaohongshu',
  'entry.resizeAria': 'Resize sidebar',
  'entry.loadingWorkspace': 'Loading workspace…',
  'entry.useEverywhereTitle': 'Use everywhere',
  'entry.useEverywhereAria': 'Open the Use Everywhere guide (CLI, MCP, HTTP, Skills)',
  'entry.workspaceTeamsLabel': 'Teams',
  'workspaceSwitcher.invite': 'Invite colleague',
  'workspaceSwitcher.createTeam': 'New team',
  "workspaceSwitcher.draftsTooltip": "All projects",
  "workspaceSwitcher.allProjectsTooltip": "Team projects",
  "entry.primaryNavAria": "Primary",
  "entry.billingTierTeam": "Teams",
  "entry.billingTierFree": "Free",
  "entry.billingTierPro": "Pro",
  "entry.billingTierPlus": "Plus",
  "entry.billingTierMax": "Max",
  "entry.billingTierGo": "Go",
  "entry.billingFamilyCreator": "Creator",
  "entry.creditsAria": "{tier} · allowance remaining",
  "entry.creditsAriaWithBalance": "{tier} · {balance} allowance remaining",
  "entry.creditsGrantTip": "Team allowance is granted by subscription. Usage is available in billing.",
  "entry.creditsUpgrade": "Upgrade",
  "entry.creditsManage": "Manage",
  "entry.creditsOpening": "Opening...",
  "entry.creditsRemaining": "Allowance remaining",
  "entry.credits": "Allowance",
  "entry.creditsUsage": "View usage",
  "entry.creditsMemberNoticeTitle": "Need more allowance?",
  "entry.creditsMemberNoticeBody": "You are currently a Member and cannot top up yourself. Ask a team Admin to increase the allowance when you need more.",
  "entry.creditsMemberNoticeAction": "Ask Admin to increase allowance",
  "entry.accountToggleTheme": "Toggle theme",
  "entry.accountSwitchLanguage": "Switch language",
  "entry.accountLanguageMeta": "中文 / English",
  "entry.accountGithubHelp": "Get help",
  "entry.accountFeatureRequest": "Submit feature request",
  "entry.accountBilling": "Billing",
  "entry.accountAddAccount": "Add account",
  "entry.accountSignOut": "Sign out",
  "signOut.confirmTitle": "Sign out",
  "signOut.confirmMessage": "Are you sure you want to sign out?",
  "signOut.confirmAction": "Sign out",
  "entry.navRecents": "Home",
  "entry.navDashboard": "Dashboard",
  "entry.blankDraftsTitle": "Start a private draft",
  "entry.blankDraftsDescription": "Create a project here first. It stays private until you move it into the team space.",
  "entry.projectsLoadFailed": "Could not load projects. Please try again.",
  "entry.blankAllProjectsTitle": "No team projects yet",
  "entry.blankAllProjectsDescription": "Projects shared to the team will appear here for everyone in the workspace.",
  "entry.blankCreate": "New project",
  'entry.workspaceTeamsTitle': 'Workspace for Teams — tell us what your team needs',
  'entry.workspaceTeamsAria': 'Open the Workspace for Teams page',
  'entry.navExpand': 'Expand sidebar',
  'entry.navCollapse': 'Collapse sidebar',
  'entry.navNewProject': 'New project',
  'entry.navHome': 'Home',
  'entry.navProjects': 'Projects',
  'entry.navTasks': 'Automations',
  'entry.navPlugins': 'Plugins',
  'entry.navDesignSystems': 'Design systems',
  'entry.navBrands': 'Design System',
  'entry.navIntegrations': 'Integrations',
  'entry.navMembers': 'Members',
  'entry.navWorkspaceSettings': 'Workspace settings',
  'entry.navDrafts': 'All projects',
  'entry.navAllProjects': 'Team projects',
  'entry.draftsDescription': 'Projects you created, visible only to you',
  'entry.allProjectsDescription': 'Projects owned by everyone on the team',
  'entry.navBoard': 'Board',
  'entry.navTeamSection': 'Team',
  'entry.teamSlotNote': 'This space is provided by the team service. Integration is in progress.',
  "entry.cloudCalloutTitle": "OpenDesign Cloud",
  'entry.cloudRecovering': 'Account connection interrupted. Recovering automatically…',
  'entry.authExpiredBody': 'Open Design is not signed in\nSign in to see your projects and continue the conversation.',
  'home.createFailed': 'Failed to start the run. Try again.',
  'home.daemonRecovering': 'Local connection lost\nCan’t reach the Open Design service on this computer right now. Please restart the app.',
  'home.createTimedOut': 'Project setup timed out before it could start. Try sending again.',
  'home.amrGateUnavailable': 'Couldn\'t confirm your OpenDesign Cloud balance. Try sending again.',
  'home.bundledScenarioMissing': 'Bundled scenario "{scenarioId}" is not installed. Reinstall the daemon to restore the default plugin set.',
  "entry.cloudCalloutBody": "Sign in to use OpenDesign Cloud and collaborate in the cloud",
  "entry.cloudCreditsTitle": "Get free credits",
  "entry.cloudCreditsBody": "Sign up to design with top AI models for free",
  "entry.cloudCreditsCta": "Sign up / Sign in",
  "entry.localAccountName": "Local mode",
  "entry.cloudCalloutDismissAria": "Dismiss OpenDesign Cloud note",
  'entry.workspaceLockedNote': 'This workspace is locked. Restore billing to resume editing shared projects.',
  'entry.workspaceLockedRecover': 'Restore access',
  'messageCenter.openAria': 'Open message center',
  'messageCenter.unreadCount': '{count} unread',
  'messageCenter.title': 'Message center',
  'messageCenter.subtitle': 'OpenDesign updates, platform announcements, and account notices.',
  'messageCenter.filterAll': 'All',
  'messageCenter.filterUnread': 'Unread',
  'messageCenter.filterRead': 'Read',
  'messageCenter.markAllRead': 'Mark all read',
  'messageCenter.emptyAllTitle': 'No messages yet',
  'messageCenter.emptyUnreadTitle': 'All caught up',
  'messageCenter.emptyReadTitle': 'No read messages',
  'messageCenter.archive': 'Archive',
  'messageCenter.unarchive': 'Move back to inbox',
  'messageCenter.archivedTitle': 'Archived',
  'messageCenter.emptyArchivedTitle': 'Nothing archived',
  'messageCenter.emptyBody': 'New platform messages will appear here.',
  'messageCenter.close': 'Close message center',
  'messageCenter.desktopSettings': 'Desktop notification settings',
  'messageCenter.desktopSettingsHint': 'Task completion sounds and system notifications stay in Settings.',
  'goPlanSunset.closeAria': 'Close announcement',
  'goPlanSunset.title': 'Notice: Go subscriptions are ending',
  'goPlanSunset.subtitle': 'We’ve heard your feedback and recognize that Go’s allowance rules and product experience need improvement. We’re sorry.',
  'goPlanSunset.decisionsAria': 'What’s changing',
  'goPlanSunset.decisionsIntro': 'What’s changing',
  'goPlanSunset.decisionStopSales': 'New Go subscriptions end today',
  'goPlanSunset.decisionRefund': 'Existing subscribers will receive full refunds by August 31; Go access ends after refund',
  'goPlanSunset.decisionUnaffected': 'Other plans are unaffected',
  'goPlanSunset.closing': 'Refunds return to the original payment method; timing depends on the provider. Thank you for your feedback and support.',
  'goPlanSunset.dismissError': 'Could not confirm. Please try again.',
  'goPlanSunset.viewSubscriptions': 'View other plans',
  'goPlanSunset.confirming': 'Confirming…',
  'goPlanSunset.acknowledge': 'Got it',
  'workspaceTabs.project': 'Project',
  'workspaceTabs.pluginDetails': 'Plugin details',
  'workspaceTabs.marketplace': 'Marketplace',
  'homeHero.title': 'Let’s create {word}',
  'homeHero.titleWords': 'prototypes,slide decks,documents',
  'homeHero.subtitle': 'Good work starts here',
  'homeHero.startWithTemplate': 'Start with a template…',
  'homeHero.startBlankProject': 'start a blank project',
  'homeHero.templatePicker.label': 'Creation type',
  'homeHero.templatePicker.searchPlaceholder': 'Search templates',
  'homeHero.templatePicker.projectTypes': 'Project types',
  'homeHero.subtitlePrefix': 'The source-available Claude Design alternative.',
  'homeHero.placeholder': 'Describe what you want to generate…',
  'homeHero.placeholderActive': 'Edit the example query or write your own…',
  'homeHero.carousel.hint': 'Attach a file, link your design system, or describe what you want to make',
  'homeHero.carousel.onePageBrief': 'Draft a one-page project brief',
  'homeHero.carousel.notesToDeck': 'Turn my notes into a presentation',
  'homeHero.carousel.signupFlow': 'Mock up a signup flow',
  'homeHero.carousel.improveBrief': 'Improve an existing project brief',
  'homeHero.carousel.loadingAnimation': 'Create a loading animation',
  'homeHero.carousel.teamUpdateSlides': 'Design slides for a team update',
  'homeHero.carousel.ordersDashboard': 'Prototype a dashboard for tracking orders',
  'homeHero.carousel.productDetail': 'Lay out a product detail page',
  'homeHero.carousel.caseStudy': 'Outline a case study',
  'homeHero.carousel.landingIntro': 'Design a short intro for a landing page',
  'homeHero.carousel.pitchDeck': 'Make a pitch deck for a new product',
  'homeHero.carousel.appIdea': 'Describe an app idea',
  'homeHero.carousel.landingLayout': 'Sketch a landing page layout',
  'homeHero.skills': 'Skills',
  'homeHero.addMenu': 'Add context',
  'homeHero.addPlugin': 'Add plugin',
  'homeHero.addConnectors': 'Add connectors',
  'homeHero.addMcp': 'Add MCP server',
  'homeHero.noPlugins': 'No installed plugins',
  'homeHero.noMcp': 'No MCP servers',
  'homeHero.noConnectors': 'No connected connectors',
  'homeHero.applying': 'Applying…',
  'homeHero.pluginTitle': 'Plugin: {title}',
  'homeHero.pluginPrefix': 'Plugin: {title}',
  'homeHero.skillPrefix': 'Skill: {title}',
  'homeHero.removePlugin': 'Remove plugin',
  'homeHero.removePluginAria': 'Remove plugin {title}',
  'homeHero.clearActivePlugin': 'Clear active plugin',
  'homeHero.clearActiveSkill': 'Clear active skill',
  'homeHero.contextItemsResolved': '{n} context items resolved',
  'homeHero.attachmentsScrollPrev': 'Scroll attachments left',
  'homeHero.attachmentsScrollNext': 'Scroll attachments right',
  'homeHero.removeFile': 'Remove file',
  'homeHero.contextSearchResults': 'Context search results',
  'homeHero.contextSurfaces': 'Context surfaces',
  'homeHero.loadingContext': 'Loading context…',
  'homeHero.noResults': 'No results for "{query}".',
  'homeHero.searchPrompt': 'Search files, plugins, skills, MCP servers, and connectors.',
  'homeHero.parameters': '{n} parameters',
  'homeHero.details': 'Details',
  'homeHero.toRun': 'to run',
  'homeHero.forNewLine': 'for new line',
  'homeHero.run': 'Run',
  'homeHero.typeSomethingToRun': 'Type something to run',
  'homeHero.promptExamples': 'Examples',
  'homeHero.footer.designSystem': 'Style',
  'homeHero.footer.autoDesignSystem': 'Auto',
  'homeHero.footer.autoDesignSystemSummary': 'Automatically matches the best design system and visual style for the current prompt.',
  'homeHero.footer.ratio': 'Ratio',
  'homeHero.footer.duration': 'Duration',
  'homeHero.footer.resolution': 'Resolution',
  'homeHero.footer.speakerNotes': 'Notes',
  'homeHero.footer.noSpeakerNotes': 'No notes',
  'homeHero.footer.availableCount': '{n} available',
  'homeHero.footer.noMatches': 'No matches',
  'homeHero.moreShortcuts': 'More',
  'homeHero.railAria': 'Pick a project category or starter shortcut',
  'homeHero.subTypeAria': 'Pick a sub-type',
  'homeHero.subTypeMore': 'More',
  'homeHero.confirmReplaceTitle': 'Replace current prompt?',
  'homeHero.confirmReplaceBody': 'Using {title} will replace the text currently in the input.',
  'homeHero.confirmReplace': 'Replace',
  'homeHero.chip.prototype': 'Prototype',
  'homeHero.chip.webClone': 'Website clone',
  'homeHero.chip.liveArtifact': 'Live artifact',
  'homeHero.chip.deck': 'Slide deck',
  'homeHero.chip.image': 'Image',
  'homeHero.chip.video': 'Video',
  "homeHero.chip.motionDesign": "Motion design",
  "homeHero.chip.motionDesignDesc": "Motion graphics, art and product films",
  "homeHero.chip.motionDesignHint": "Describe your idea, visual style and duration to create a motion film.",
  'homeHero.chip.hyperframes': 'HyperFrames',
  'homeHero.chip.webgl': 'WebGL',
  'homeHero.chip.webglDesc': 'Shaders, 3D & generative GPU visuals',
  'homeHero.chip.worker': 'Worker visualizer',
  'homeHero.chip.workerDesc': 'Off-thread sims, particles & data viz',
  'homeHero.chip.audio': 'Audio',
  'homeHero.chip.createBrandKit': 'Create Design System',
  'homeHero.chip.createPlugin': 'Create plugin',
  'homeHero.chip.figma': 'From Figma',
  'homeHero.chip.folder': 'From folder',
  'homeHero.chip.template': 'From template',
  'homeHero.chip.liveArtifactHint': 'Build an interactive HTML/CSS/JS artifact you can preview live.',
  'homeHero.chip.hyperframesHint': 'Author HTML-based motion: captions, audio-reactive visuals, scene transitions.',
  'homeHero.chip.createBrandKitHint': 'Extract a design system from a website, then apply it in any chat.',
  'homeHero.chip.createPluginHint': 'Author a reusable OpenDesign plugin and add it to My plugins.',
  'homeHero.chip.figmaHint': 'Migrate a Figma frame into the active design system.',
  'homeHero.chip.folderHint': 'Import an existing local folder and continue editing.',
  'homeHero.chip.templateHint': 'Start from a bundled template.',
  'homeHero.chip.wireframe': 'Wireframe',
  'homeHero.chip.mobile': 'Mobile app',
  'homeHero.chip.document': 'Document',
  'homeHero.chip.prototypeDesc': 'Interactive app mockups',
  'homeHero.chip.webCloneDesc': 'Source-first site reproduction',
  'homeHero.chip.wireframeDesc': 'Lo-fi screens & flows',
  'homeHero.chip.mobileDesc': 'iOS & Android screens',
  'homeHero.chip.deckDesc': 'Presentations & pitch decks',
  'homeHero.chip.documentDesc': 'Resumes, reports & PDFs',
  'homeHero.chip.imageDesc': 'Posters, graphics & art',
  'homeHero.chip.videoDesc': 'Clips, reels & promos',
  'homeHero.chip.audioDesc': 'Voiceovers, music & SFX',
  'homeHero.chip.hyperframesDesc': 'Motion graphics & loops',
  'homeHero.chip.liveArtifactDesc': 'Data-backed live dashboards',
  'homeHero.chip.createBrandKitDesc': 'Extract a brand design system',
  'homeHero.chip.prototypeNext': 'Open a chat that builds a high-fidelity, clickable web prototype you refine turn by turn.',
  'homeHero.chip.webCloneNext': 'Open a chat that asks for a target URL, reconstructs the site, and audits the clone.',
  'homeHero.chip.wireframeNext': 'Open a chat that sketches lo-fi screens and flows to validate structure first.',
  'homeHero.chip.mobileNext': 'Open a chat that lays out mobile screens for iOS and Android.',
  'homeHero.chip.deckNext': 'Open a chat that builds a slide deck you can present and export.',
  'homeHero.chip.documentNext': 'Open a chat that drafts a polished document — resume, report, or PDF.',
  'homeHero.chip.imageNext': 'Open a chat that generates on-brand images you can iterate on.',
  'homeHero.chip.videoNext': 'Open a chat that produces a short video you can refine.',
  'homeHero.chip.audioNext': 'Open a chat that creates voiceover, music, or sound effects.',
  'homeHero.chip.webClonePromptSeed': 'Website URL to clone: ',
  'homeWorkingDir.trigger': 'Working directory',
  'homeWorkingDir.triggerShort': 'Working directory',
  'homeWorkingDir.pick': 'Choose folder',
  'homeWorkingDir.replace': 'Change working directory',
  'homeWorkingDir.recent': 'Recent folders',
  'homeWorkingDir.clear': 'Remove working directory',
  'homeWorkingDir.hint': 'Let the agent read this local folder (not imported into Design Files)',
  'homeWorkingDir.missing': 'This working folder no longer exists — pick another',
  'homeWorkingDir.applyFailed': 'Couldn\'t set the working directory — the folder may no longer exist',
  'workingDirPicker.title': 'Folder',
  'workingDirPicker.homeTitle': 'Saved in local storage — click to choose a folder',
  'workingDirPicker.processing': 'Processing…',
  'workingDirPicker.select': 'Local storage',
  'workingDirPicker.clearAria': 'Clear working directory',
  'workingDirPicker.replaceFailed': 'Could not replace working directory',
  'workingDirPicker.unavailable': 'Folder picker is unavailable in this build. Run the desktop app to pick a folder.',
  'workingDirPicker.openUnavailable': 'Open this project in the desktop app to show the folder.',
  'workingDirPicker.openFailed': 'Could not show this folder',
  'workingDirPicker.showInFileManager': 'Show in file manager',
  'workingDirPicker.replace': 'Choose folder…',
  'workingDirPicker.recent': 'Recent directories',
  'workingDirPicker.defaultLabel': 'Local storage',
  'handoff.toTarget': 'Hand off to {target}',
  'handoff.openInTarget': 'Open in {target}',
  'handoff.openAction': 'Open',
  'handoff.menuTitle': 'Open in which editor?',
  'handoff.action': 'Hand off',
  'handoff.fallbackTitle': 'No editors found on $PATH - opens in {target}',
  'handoff.chooseTargetAria': 'Choose hand-off target',
  'handoff.optionsAria': 'Handoff options',
  'handoff.editorSection': 'Open with editor',
  'handoff.cliSection': 'Copy for CLI',
  'handoff.clickOpen': 'Click to open',
  'handoff.framework': 'Code framework',
  'handoff.framework.react': 'React',
  'handoff.framework.vue': 'Vue.js',
  'handoff.framework.svelte': 'Svelte',
  'handoff.framework.solid': 'SolidJS',
  'handoff.framework.next': 'Next.js',
  'handoff.framework.vanilla': 'JS',
  'handoff.frameworkPrompt.react': 'React',
  'handoff.frameworkPrompt.vue': 'Vue.js',
  'handoff.frameworkPrompt.svelte': 'Svelte',
  'handoff.frameworkPrompt.solid': 'SolidJS',
  'handoff.frameworkPrompt.next': 'Next.js / React',
  'handoff.frameworkPrompt.vanilla': 'vanilla JavaScript, HTML, and CSS',
  'handoff.amrWebsite': 'Visit OpenDesign Cloud',
  'handoff.copyPrompt': 'Copy prompt',
  'handoff.copyPromptForTarget': 'Copy prompt for {target}',
  'handoff.copied': 'Copied',
  'handoff.projectPathUnavailable': 'Project path is still loading. Try again in a moment.',
  'handoff.copyFailed': 'Clipboard write was blocked. Try again in a moment.',
  'handoff.promptIntro': 'Continue from this local OpenDesign project folder:',
  'handoff.promptTarget': 'Target',
  'handoff.promptCli': 'CLI',
  'handoff.promptStepsLead': 'You are taking over in {cli}. Please:',
  'handoff.promptReadFiles': 'Enter or read this directory first. Prioritize DESIGN.md, README, existing HTML/CSS/JS, assets, and package.json if present.',
  'handoff.promptKeepDesign': 'Preserve the current visual design, layout, interactions, and assets. Do not stop at a plan.',
  'handoff.promptProduceCode': 'Generate or modify real runnable {framework} code. If the project already has a clearer stack, call out the conflict and keep the result runnable.',
  'handoff.promptVerify': 'Finish by telling me the run, preview, and verification commands.',
  'handoff.promptCommandHint': 'To start from the project directory, use:',
  'handoff.promptProject': 'Project',
  'handoff.promptProjectId': 'Project ID',
  'handoff.notInstalled': 'Not installed',
  'handoff.notDetectedTitle': '{target} - not detected on $PATH',
  'designSystemPicker.select': 'Choose design system',
  'designSystemPicker.loading': 'Loading design systems…',
  'designSystemPicker.searchPlaceholder': 'Search design systems (title / category / summary)',
  'designSystemPicker.searchCompactPlaceholder': 'Search design systems',
  'designSystemPicker.noneTitle': 'No design system',
  'designSystemPicker.noneSummary': 'No design system — the model freely improvises the visual style from your prompt.',
  'designSystemPicker.empty': 'No matching design systems',
  'designSystemPicker.openPreview': 'Open preview',
  'designSystemPicker.loadingPreview': 'Loading preview…',
  'designSystemPicker.noPreview': 'No preview page. OpenDesign Systems to view the full preview.',
  'designSystemPicker.previewHint': 'Hover a design system to preview it',
  'designSystemPicker.fullscreenAria': '{title} full-screen preview',
  'designSystemPicker.closeFullscreen': 'Close full-screen preview',
  'designSystemPicker.closeEsc': 'Close (Esc)',
  'designSystemPicker.previewFrameTitle': '{title} preview',
  'designSystemPicker.fullscreenFrameTitle': '{title} full-screen preview',
  'recentProjects.title': 'Recent projects',
  'recentProjects.viewAll': 'View all',
  'recentProjects.empty': 'No projects yet — type a prompt to start one.',
  'recentProjects.ownerAll': 'All',
  'recentProjects.ownerMine': 'Mine',
  'recentProjects.ownerOthers': 'Others',
  'recentProjects.kindAll': 'Any type',
  'recentProjects.kindPrototype': 'Prototype',
  'recentProjects.kindSlides': 'Slides',
  'recentProjects.kindDocument': 'Document',
  'recentProjects.kindImage': 'Image',
  'recentProjects.kindMedia': 'Media',
  'recentProjects.kindOther': 'Other',
  'recentProjects.inviteTeammates': 'Invite teammates',
  'recentProjects.multiSelect': 'Multi-select',
  'recentProjects.sortAria': 'Sort projects',
  'recentProjects.sortNewest': 'Newest first',
  'recentProjects.sortOldest': 'Oldest first',
  'recentProjects.sortName': 'Name',
  'recentProjects.collectionRecent': 'Recently viewed',
  'recentProjects.collectionPersonalProjects': 'Personal projects',
  'recentProjects.collectionTeamProjects': 'Team projects',
  'recentProjects.viewList': 'List view',
  'recentProjects.sharedBadge': 'Shared',
  'recentProjects.sharedProjectFallbackName': 'Shared project',
  'recentProjects.creatorLine': 'Created by {name}',
  'recentProjects.selfCreator': 'Me',
  'recentProjects.teamMemberCreator': 'Team member',
  'recentProjects.ownOnlyMutation': 'Only projects you created can be changed or deleted.',
  'recentProjects.shareInProgress': 'Sharing…',
  'recentProjects.duplicateInProgress': 'Duplicating…',
  'recentProjects.sharedInTeam': 'In team space',
  'recentProjects.moveToTeam': 'Move to team space',
  'recentProjects.moveToTeamDescPre': 'Once moved to the team space, ',
  'recentProjects.moveToTeamDescStrong': 'all team members can view and comment',
  'recentProjects.moveToTeamDescPost': ', and only the creator can edit. You can find it under "Team projects".',
  'recentProjects.moveToPersonalDescPre': 'Once moved out of the team space, it returns to a personal project, ',
  'recentProjects.moveToPersonalDescStrong': 'only you can view and edit it',
  'recentProjects.moveToPersonalDescPost': '.',
  'recentProjects.moveDontRemind': 'Don\'t remind me again',
  'recentProjects.confirmMoveToTeam': 'Confirm move',
  'recentProjects.confirmMoveToPersonal': 'Confirm move',
  'recentProjects.unshareInProgress': 'Moving out…',
  'recentProjects.moveOutOfTeam': 'Move out of team space',
  'recentProjects.unshareFailed': 'Could not move out of team space. Try again.',
  'recentProjects.shareFailed': 'Could not move to team space. Try again.',
  'recentProjects.shareOwnerConflict': 'Could not move to team space: another member already shares this project with the team.',
  'recentProjects.clearFilters': 'Clear filters',
  'pluginsHome.title': 'Community',
  'pluginsHome.subtitle': 'Ready-to-use OpenDesign workflows bundled with this runtime. Pick one to load a starter prompt, or browse the registry for more.',
  'pluginsHome.browseRegistry': 'Browse registry',
  'pluginsHome.count': '{filtered} of {total}',
  'pluginsHome.loadingCatalog': 'Loading catalog…',
  'pluginsHome.emptyCatalog': 'Catalog is empty. Bundled plugins ship with OpenDesign and should appear here automatically — try restarting the daemon if this persists.',
  'pluginsHome.emptyFiltered': 'No plugins match the current filters.',
  'pluginsHome.clearFilters': 'Clear filters',
  'pluginsHome.modeAria': 'Plugin mode',
  'pluginsHome.featured': 'Saved',
  'pluginsHome.totalInCatalog': '{n} in catalog',
  'pluginsHome.categoryFilterAria': 'Category filter',
  'pluginsHome.subcategoryFilterAria': '{label} subcategory filter',
  'pluginsHome.allCategory': 'All {label}',
  'pluginsHome.searchPlaceholder': 'Search plugins…',
  'pluginsHome.searchAria': 'Search plugins',
  'pluginsHome.clearSearch': 'Clear search',
  'pluginsHome.sortAria': 'Sort order',
  'pluginsHome.sortHot': 'Trending',
  'pluginsHome.sortNewest': 'Newest',
  'pluginsHome.facet.import': 'Import',
  'pluginsHome.facet.create': 'Create',
  'pluginsHome.facet.export': 'Export',
  'pluginsHome.facet.share': 'Share',
  'pluginsHome.facet.deploy': 'Deploy',
  'pluginsHome.facet.refine': 'Refine',
  'pluginsHome.facet.extend': 'Extend',
  'pluginsHome.facet.figma': 'Figma',
  'pluginsHome.facet.github': 'GitHub',
  'pluginsHome.facet.codeFolder': 'Code / folder',
  'pluginsHome.facet.url': 'URL',
  'pluginsHome.facet.screenshot': 'Screenshot',
  'pluginsHome.facet.pdf': 'PDF',
  'pluginsHome.facet.pptx': 'PPTX',
  'pluginsHome.facet.framer': 'Framer',
  'pluginsHome.facet.webflow': 'Webflow',
  'pluginsHome.facet.slides': 'Slides',
  'pluginsHome.facet.publicLink': 'Public link',
  'pluginsHome.facet.githubPr': 'GitHub PR',
  'pluginsHome.facet.githubGist': 'GitHub Gist',
  'pluginsHome.subfacet.business-dashboards': 'Dashboards',
  'pluginsHome.subfacet.app-prototypes': 'Apps',
  'pluginsHome.subfacet.landing-marketing': 'Landing / marketing',
  'pluginsHome.subfacet.developer-tools': 'Developer tools',
  'pluginsHome.subfacet.docs-reports': 'Docs / reports',
  'pluginsHome.subfacet.brand-design': 'Brand / design',
  'pluginsHome.subfacet.pitch-business': 'Pitch / business',
  'pluginsHome.subfacet.course-training': 'Course / training',
  'pluginsHome.subfacet.reports-briefings': 'Reports / briefings',
  'pluginsHome.subfacet.product-sales': 'Product / sales',
  'pluginsHome.subfacet.engineering-talks': 'Engineering talks',
  'pluginsHome.subfacet.creative-decks': 'Creative decks',
  'pluginsHome.subfacet.ui-product-mockups': 'UI / product mockups',
  'pluginsHome.subfacet.brand-visuals': 'Brand / logo',
  'pluginsHome.subfacet.storyboards-motion-refs': 'Storyboards',
  'pluginsHome.subfacet.social-content': 'Social / content',
  'pluginsHome.subfacet.avatar-portrait': 'Avatar / portrait',
  'pluginsHome.subfacet.illustration-style': 'Illustration / style',
  'pluginsHome.subfacet.motion-effects': 'Motion / effects',
  'pluginsHome.subfacet.social-short-form': 'Social / short form',
  'pluginsHome.subfacet.marketing-product': 'Marketing / product',
  'pluginsHome.subfacet.data-explainers': 'Data / explainers',
  'pluginsHome.subfacet.cinematic-story': 'Cinematic / story',
  'pluginsHome.commercialCategory.student-coursework': 'Student coursework',
  'pluginsHome.commercialCategory.corporate-strategy': 'Corporate strategy',
  'pluginsHome.commercialCategory.professional-training': 'Professional training',
  'pluginsHome.commercialCategory.b2b-sales': 'B2B sales',
  'pluginsHome.commercialCategory.academic-research': 'Academic research',
  'pluginsHome.commercialCategory.marketing-gtm': 'Marketing & GTM',
  'pluginsHome.commercialCategory.data-finance': 'Data & finance',
  'pluginsHome.commercialCategory.fundraising-pitch': 'Fundraising pitch',
  'pluginsHome.commercialCategory.government-policy': 'Government & policy',
  'pluginsHome.commercialCategory.product-management': 'Product management',
  'pluginsHome.commercialCategory.consulting': 'Consulting',
  'pluginsHome.commercialCategory.career': 'Career',
  'pluginsHome.commercialCategory.ai-literacy': 'AI literacy',
  'pluginsHome.commercialCategory.life': 'Life & story',
  'pluginsHome.commercialCategory.design-craft': 'Design craft',
  'pluginsView.lede': 'Browse installed workflows, discover registry entries, manage sources, and prepare plugins for team distribution.',
  'pluginsView.importPlugin': 'Import plugin',
  'pluginsView.agentContext': 'Agent context',
  'pluginsView.summaryAria': 'Plugin summary',
  'pluginsView.areasAria': 'Plugin areas',
  'pluginsView.loading': 'Loading plugins…',
  'pluginsView.tab.installed': 'Installed',
  'pluginsView.tab.available': 'Available',
  'pluginsView.tab.sources': 'Sources',
  'pluginsView.tab.team': 'Team',
  'pluginsView.tabHint.installed': 'Your plugins',
  'pluginsView.tabHint.available': 'From sources',
  'pluginsView.tabHint.sources': 'Catalogs',
  'pluginsView.tabHint.team': 'Enterprise',
  'pluginsView.installedTitle': 'Installed plugins',
  'pluginsView.installedSubtitle': 'Plugins you imported or installed from marketplace sources.',
  'pluginsView.installedEmpty': 'No installed user plugins yet. Use Create / Import or install an Available entry.',
  'pluginsView.availableTitle': 'Available from sources',
  'pluginsView.availableSubtitle': 'Catalog entries discovered from configured marketplaces.',
  'pluginsView.availableFiltersAria': 'Available plugin filters',
  'pluginsView.searchAvailableAria': 'Search available plugins',
  'pluginsView.searchAvailablePlaceholder': 'Search available plugins',
  'pluginsView.clearAvailableSearch': 'Clear available plugin search',
  'pluginsView.source': 'Source',
  'pluginsView.availableEmptyInstalled': 'No available entries yet. Installed catalog entries are removed from Available; uninstall one to make it available again.',
  'pluginsView.availableEmptyFiltered': 'No available entries match your filters.',
  'pluginsView.availableEmptyNoSources': 'No available entries yet. Add a source in the Sources tab.',
  'pluginsView.installing': 'Installing…',
  'pluginsView.installWaiting': 'Waiting…',
  'pluginsView.installQueuedHint': 'Another plugin is installing. Installs run one at a time — this becomes available when that one finishes.',
  'pluginsView.install': 'Install',
  'pluginsView.sourcesTitle': 'Registry sources',
  'pluginsView.sourcesSubtitle': 'Marketplace catalogs that feed Available plugin entries.',
  'pluginsView.sourceUrl': 'Source URL',
  'pluginsView.defaultTrust': 'Default trust',
  'pluginsView.trust.restricted': 'Restricted',
  'pluginsView.trust.trusted': 'Trusted',
  'pluginsView.trust.official': 'Official',
  'pluginsView.adding': 'Adding…',
  'pluginsView.addSource': 'Add source',
  'pluginsView.sourcesEmpty': 'No registry sources configured yet.',
  'pluginsView.pluginsCount': '{n} plugins',
  'pluginsView.catalogVersion': 'catalog v{version}',
  'pluginsView.trustFor': 'Trust for {name}',
  'pluginsView.refreshing': 'Refreshing…',
  'pluginsView.removing': 'Removing…',
  "pluginsView.marketplaceTitle": "Extensions",
  "pluginsView.marketplaceBody": "Install expert suites, skills, and connectors to add new work capabilities to OpenDesign.",
  "pluginsView.marketplaceModeAria": "Marketplace mode",
  "pluginsView.marketplaceSourceFiltersAria": "Marketplace source filters",
  "pluginsView.scope.official": "OpenDesign official",
  "pluginsView.scope.team": "Team",
  "pluginsView.scope.personal": "Personal",
  "pluginsView.kind.plugins": "Expert suites",
  "pluginsView.kind.skills": "Skills",
  "pluginsView.searchPlugins": "Search expert suites",
  "pluginsView.searchSkills": "Search skills",
  "pluginsView.modeNote.plugins": "Expert suites are role- and industry-focused toolkits. Type @ or slash in the composer to use them.",
  "pluginsView.modeNote.skills": "Skills are reusable task workflows and review rules. Use them directly or compose them into expert suites.",
  "pluginsView.create": "Add",
  "pluginsView.createTitle": "Add {kind}",
  "pluginsView.createWithAgent": "Describe it and let the agent build it",
  "pluginsView.createWithAgentBody": "Start from a prompt in the home composer instead of importing an existing extension.",
  "pluginsView.createWithAgentAction": "Start from a prompt",
  "pluginsView.createPluginBody": "Import a plugin from GitHub or a local folder, then upload it for team use.",
  "pluginsView.createSkillBody": "Create a reusable task workflow or review rule that can later be reused by plugins.",
  "pluginsView.createClose": "Close add panel",
  "pluginsView.createTypeAria": "Create type",
  "pluginsView.importFromUrl": "Import from link",
  "pluginsView.importUrlBody": "Paste a public link for a {kind}. OpenDesign will fetch the manifest, validate capabilities, and upload it to the team space.",
  "pluginsView.uploadFolder": "Upload local folder",
  "pluginsView.uploadFolderBody": "Choose a local folder containing {manifest}. After validation, it will upload as a team {kind}.",
  "pluginsView.importing": "Importing…",
  "pluginsView.importAndUpload": "Import and upload",
  "pluginsView.uploading": "Uploading…",
  "pluginsView.uploadKind": "Upload {kind}",
  "pluginsView.filesSelected": "{count} files selected",
  "pluginsView.chooseFolder": "Choose folder",
  "pluginsView.emptyNoMatchTitle": "No matching results",
  "pluginsView.emptyNoMatchHint": "Try another keyword.",
  "pluginsView.emptyTeamTitle": "No content shared to the team yet",
  "pluginsView.emptyTeamHint": "Share expert suites or skills from Personal to Team, and they will appear here.",
  "pluginsView.emptyPersonalPluginsTitle": "No personal expert suites yet",
  "pluginsView.emptyPersonalSkillsTitle": "No personal skills yet",
  "pluginsView.emptyPersonalHint": "Install from OpenDesign official, or use Add in the top right to create one.",
  "pluginsView.emptyOfficialPluginsTitle": "No official expert suites available",
  "pluginsView.emptyOfficialSkillsTitle": "No official skills available",
  "pluginsView.emptyOfficialHint": "Check back later, or add a marketplace in plugin sources.",
  "pluginsView.teamSharedBadge": "Shared with team",
  "pluginsView.tryIt": "Try it",
  "pluginsView.categoriesAria": "Categories",
  "pluginsView.statSkills": "{count} skills",
  "pluginsView.statConnectors": "{count} connectors",
  "pluginsView.uninstall": "Uninstall",
  "pluginsView.uninstalling": "Uninstalling…",
  "pluginsView.uninstallConfirm": "Uninstall {title}?",
  "pluginsView.uninstallSuccess": "Uninstalled {title}",
  "pluginsView.uninstallFailed": "Could not uninstall {title}",
  "pluginsView.sharing": "Sharing…",
  "pluginsView.unsharing": "Removing…",
  "pluginsView.shareToTeam": "Share with team",
  "pluginsView.syncToTeam": "Sync to team",
  "pluginsView.unshareFromTeam": "Remove from team",
  "pluginsView.moreActions": "{title} more actions",
  "pluginsView.skillUrlUnsupported": "Skills do not support import from link yet. Use Upload local folder instead.",
  "pluginsView.importPluginSuccess": "Imported and uploaded expert suite",
  "pluginsView.importFailed": "Import failed. Check the link and try again.",
  "pluginsView.uploadPluginSuccess": "Uploaded expert suite",
  "pluginsView.uploadFailed": "Upload failed. Check the folder contents.",
  "pluginsView.importSkillSuccess": "Imported Skill \"{name}\". You can share it with the team from Personal.",
  "pluginsView.shareSuccess": "Shared \"{title}\" with the team. Teammates can now use it.",
  "pluginsView.shareUnavailable": "Could not share \"{title}\" yet. Confirm you are in a team workspace.",
  "pluginsView.shareFailed": "Failed to share \"{title}\". Try again later.",
  "pluginsView.syncSuccess": "Synced the latest \"{title}\" to the team.",
  "pluginsView.syncUnavailable": "Could not sync \"{title}\" yet. Confirm you are in a team workspace.",
  "pluginsView.syncFailed": "Failed to sync \"{title}\" to the team. Try again later.",
  "pluginsView.unshareSuccess": "Removed \"{title}\" from team sharing.",
  "pluginsView.unshareUnavailable": "Could not remove \"{title}\" from team sharing. Confirm you have permission.",
  "pluginsView.unshareFailed": "Failed to remove \"{title}\" from team sharing. Try again later.",
  "pluginsView.installSuccess": "Installed \"{title}\"",
  "pluginsView.installFailed": "Failed to install \"{title}\"",
  "pluginsView.skillMissingFile": "No SKILL.md was found in the selected folder.",
  "pluginsView.skillReadFailed": "Could not read SKILL.md. Try again.",
  "pluginsView.skillMissingName": "SKILL.md is missing a name field.",
  "pluginsView.skillEmptyBody": "SKILL.md content is empty.",
  'pluginsView.teamTitle': 'Private team marketplaces',
  'pluginsView.teamBody': 'This area is reserved for enterprise and team catalogs, private trust policies, and shared plugin lifecycle controls.',
  'pluginCard.details': 'Details',
  'pluginCard.use': 'Use',
  'pluginCard.useWithQuery': 'Use with query',
  'pluginCard.applying': 'Applying…',
  'pluginCard.duplicate': 'Remix',
  'pluginCard.duplicating': 'Remixing…',
  'pluginCard.duplicateFailed': 'Could not remix this template.',
  'pluginCard.saved': 'Saved',
  'pluginCard.publish': 'Publish',
  'pluginCard.contribute': 'Contribute',
  'pluginCard.starting': 'Starting…',
  'pluginCard.detailsAria': 'View details for {title}',
  'pluginCard.chooseUseAria': 'Choose how to use {title}',
  'pluginCard.useOptionsAria': 'Use options for {title}',
  'pluginCard.duplicateAria': 'Remix {title} as a new project',
  'pluginCard.saveAria': 'Save {title}',
  'pluginCard.savedAria': '{title} is saved',
  'pluginCard.shareAria': 'Share {title}',
  'pluginCard.publishAria': 'Publish {title} as a GitHub repository',
  'pluginCard.publishTitle': 'Publish plugin as a GitHub repository',
  'pluginCard.contributeAria': 'Contribute {title} to OpenDesign',
  'pluginCard.contributeTitle': 'Contribute plugin to OpenDesign with a pull request',
  'integrations.kicker': 'Integration',
  'integrations.lede': 'Connect external systems, bring MCP tools into your agent loop, and use OpenDesign from other IDEs, scripts, and automations.',
  'integrations.agentReady': 'Agent-ready',
  'integrations.areasAria': 'Integration areas',
  'integrations.tabLabel.mcp': 'MCP',
  'integrations.tabLabel.skills': 'Skills',
  'integrations.tabHint.mcp': 'External tools',
  'integrations.tabHint.connectors': 'Accounts and APIs',
  'integrations.tabHint.useEverywhere': 'CLI, HTTP, MCP',
  'integrations.skillsTitle': 'Skills integrations',
  'integrations.skillsBody': 'Skill-level integration management is being carried over from another branch. This tab is reserved so MCP, Connectors, and future Skills setup live in the same Integration route.',
  'mcpClient.title': 'External MCP servers',
  'mcpClient.subtitle': 'Third-party tools for your coding agent.',
  'mcpClient.addServer': 'Add server',
  'mcpClient.emptyTitle': 'No MCP servers configured.',
  'mcpClient.emptyBody': 'Click "Add server" to get started — pick a template (Higgsfield OpenClaw, Pollinations, Allyson, Imagician, EdgeOne Pages, GitHub, Filesystem…) or set up a custom stdio / HTTP server.',
  'mcpClient.saveChanges': 'Save changes',
  'mcpClient.storedAt': 'Stored at',
  'mcpClient.daemonError': 'Could not reach the local daemon. Make sure OpenDesign is running, then reopen this panel.',
  'mcpClient.saveFailed': 'Save failed. Check that the daemon is running and try again.',
  'useEverywhere.modalAria': 'Use OpenDesign everywhere',
  'useEverywhere.modalTitle': 'Use OpenDesign everywhere',
  'useEverywhere.modalSubtitle': 'Drop OpenDesign into any IDE, agent, or script — CLI, HTTP, MCP, and Skills. Use “Copy guide for an agent” and paste into Claude Code, Codex, Cursor, openclaw, or hermes to set up everything.',
  'useEverywhere.closeAria': 'Close use everywhere',
  'useEverywhere.closeTitle': 'Close (Esc)',
  'useEverywhere.tabsAria': 'Integration surfaces',
  'useEverywhere.footStrong': 'One-click handoff.',
  'useEverywhere.footBody': 'Copies a structured markdown guide your agent can act on immediately — install, verify, and use.',
  'useEverywhere.configureMcp': 'Configure MCP server',
  'useEverywhere.copyGuide': 'Copy guide for an agent',
  'useEverywhere.copy': 'Copy',
  'useEverywhere.copied': 'Copied',
  'useEverywhere.copyFailed': 'Copy failed',
  'useEverywhere.copySnippetAria': 'Copy snippet: {label}',
  'useEverywhere.section.overview.tab': 'Overview',
  'useEverywhere.section.overview.heading': 'OpenDesign works wherever your agent works',
  'useEverywhere.section.overview.intro': 'OpenDesign is more than a window — it is a local privileged daemon (`od`) plus a Skills + Design-Systems + Atoms registry. Once it is running on your machine, any code agent (Claude Code, Codex, Cursor, OpenCode/openclaw, Hermes, your own script) can drive generations, inspect projects, and produce design artifacts through four interchangeable surfaces.',
  'useEverywhere.section.overview.bullet1': 'CLI — `od <command>` for headless scripts, CI, and shell automation.',
  'useEverywhere.section.overview.bullet2': 'MCP server — wires OpenDesign as a Model Context Protocol server so any MCP-capable agent can list skills, run scenarios, and read artifacts.',
  'useEverywhere.section.overview.bullet3': 'HTTP API — `http://127.0.0.1:7456/api/*` REST + SSE endpoints; the same surface the web UI uses.',
  'useEverywhere.section.overview.bullet4': 'Skills — drop-in `SKILL.md` packs (Claude-compatible) that any agent already on your PATH can invoke without OpenDesign at all.',
  'useEverywhere.section.overview.bullet5': 'Standard artifacts — seed real HTML projects from Skills, bundled default plugins, and community plugin examples before the daemon starts.',
  'useEverywhere.section.overview.snippet1': 'Start the daemon (and web UI) locally',
  'useEverywhere.section.overview.snippet2': 'Confirm it is reachable',
  'useEverywhere.section.overview.snippet3': 'Ingest standard artifacts before boot',
  'useEverywhere.section.overview.footer': 'The daemon writes to `./.od/` (project-local) by default. Set `OD_DATA_DIR=~/.open-design` to share data across projects.',
  'useEverywhere.section.cli.tab': 'CLI · od',
  'useEverywhere.section.cli.heading': 'Drive OpenDesign from any shell',
  'useEverywhere.section.cli.intro': 'The `od` bin ships with the daemon and is the same binary used by Claude Code / Codex when they run a generation. Most subcommands are thin clients that POST to the local daemon, so they work the same whether you launched it via `pnpm tools-dev` or as a packaged app.',
  'useEverywhere.section.cli.bullet1': '`od` (no args) — boots the daemon and opens the web UI.',
  'useEverywhere.section.cli.bullet2': '`od media generate ...` — produce image / video / audio bytes through the unified media protocol.',
  'useEverywhere.section.cli.bullet3': '`od run ...` — start a project run from a prompt + skill.',
  'useEverywhere.section.cli.bullet4': '`od plugin install <source>` / `od plugin apply <id>` — install and apply community plugins.',
  'useEverywhere.section.cli.bullet5': '`od skills list` / `od design-systems list` — inspect what is available locally.',
  'useEverywhere.section.cli.bullet6': '`od status` / `od doctor` — verify daemon health and detect agent CLIs on your PATH.',
  'useEverywhere.section.cli.snippet1': 'Generate an image (delegates to the configured media provider)',
  'useEverywhere.section.cli.snippet2': 'Run a scenario plugin headlessly and stream events as JSON lines',
  'useEverywhere.section.cli.snippet3': 'Inventory locally available skills and design systems',
  'useEverywhere.section.cli.snippet4': 'Check seeded artifacts through the CLI',
  'useEverywhere.section.cli.snippet5': 'Verify environment + detected agents (Claude, Codex, Cursor, …)',
  'useEverywhere.section.cli.footer': 'All subcommands accept `--daemon-url http://127.0.0.1:<port>` to target a specific running daemon — useful when running a sandboxed second instance for tests.',
  'useEverywhere.section.mcp.tab': 'MCP server',
  'useEverywhere.section.mcp.heading': 'Expose OpenDesign as an MCP server to any coding agent',
  'useEverywhere.section.mcp.intro': 'OpenDesign ships with a Model Context Protocol server (`od mcp`) that lets any MCP-capable client — Cursor, Claude Code, Antigravity, VS Code Copilot Chat, openclaw, hermes — discover OpenDesign tools (list skills, render previews, generate media, run plugins) without shelling out manually. The daemon publishes a ready-to-paste install snippet via `GET /api/mcp/install-info` for each major client.',
  'useEverywhere.section.mcp.bullet1': 'Stdio transport — no extra port, the client spawns `od mcp` directly.',
  'useEverywhere.section.mcp.bullet2': 'Auto-discovers the live daemon URL via the local IPC status socket when launched as a sidecar.',
  'useEverywhere.section.mcp.bullet3': 'Falls back to `--daemon-url http://127.0.0.1:<port>` for plain installs so the MCP process always finds a running daemon.',
  'useEverywhere.section.mcp.bullet4': 'Pins `OD_DATA_DIR` so the spawned MCP process writes to the same place the daemon already uses (avoids EPERM in packaged macOS app bundles).',
  'useEverywhere.section.mcp.snippet1': 'Generic MCP client config (works in Cursor, Claude Code, Codex, …)',
  'useEverywhere.section.mcp.snippet2': 'Or: ask the daemon for the snippet tailored to your install',
  'useEverywhere.section.mcp.snippet3': 'Live-artifacts MCP variant (read & refresh dashboards)',
  'useEverywhere.section.mcp.footer': 'In the OpenDesign app, open Settings → Integrations to copy a client-specific install command (Cursor, Claude Code, Antigravity, VS Code) instead of editing JSON by hand.',
  'useEverywhere.section.http.tab': 'HTTP API',
  'useEverywhere.section.http.heading': 'Same REST + SSE surface the web UI uses',
  'useEverywhere.section.http.intro': 'The local daemon serves an HTTP API at `http://127.0.0.1:7456` (port configurable). Every endpoint the web UI calls is also fair game for your scripts. Streaming endpoints (chat turns, project runs) emit Server-Sent Events with the contract types in `@open-design/contracts`.',
  'useEverywhere.section.http.bullet1': '`GET /api/health` — daemon liveness.',
  'useEverywhere.section.http.bullet2': '`GET /api/skills` and `GET /api/design-systems` — available registries.',
  'useEverywhere.section.http.bullet3': '`GET /api/projects` and `POST /api/projects` — list and create projects (POST returns the project + first conversation).',
  'useEverywhere.section.http.bullet4': '`GET /api/projects/:id/chat` — SSE stream of agent events for a conversation.',
  'useEverywhere.section.http.bullet5': '`POST /api/plugins/:id/apply` — bind an installed plugin and get its rendered example query + inputs.',
  'useEverywhere.section.http.bullet6': '`GET /api/agents` — detected code-agent CLIs on your PATH.',
  'useEverywhere.section.http.snippet1': 'List installed skills (the agent will use these as templates)',
  'useEverywhere.section.http.snippet2': 'Create a project from a prompt (full server-side flow)',
  'useEverywhere.section.http.snippet3': 'Stream a chat turn (SSE — each line is JSON-Lines compatible)',
  'useEverywhere.section.http.footer': 'Pure TypeScript types for every request/response live in `@open-design/contracts` — import them in your script for full autocomplete without wiring a generator.',
  'useEverywhere.section.skills.tab': 'Skills & headless',
  'useEverywhere.section.skills.heading': 'Drop-in Skills for any agent — even without OpenDesign running',
  'useEverywhere.section.skills.intro': 'A Skill is a directory with a Claude-compatible `SKILL.md` (YAML front-matter + body). OpenDesign extends the format with the `od:` namespace (`mode`, `preview`, `design_system`, `inputs`, …) so the same artifact can be used both inside OpenDesign and by a vanilla agent like Claude Code, Codex, openclaw, or hermes. Discovery follows a precedence chain so projects can override their own skills.',
  'useEverywhere.section.skills.bullet1': 'Discovery: `./.claude/skills/` → `./skills/` → `~/.claude/skills/` (project wins).',
  'useEverywhere.section.skills.bullet2': 'Symlink one skill into multiple projects to share it without copying.',
  'useEverywhere.section.skills.bullet3': 'Each skill can declare connectors, atoms, design-system requirements, and a `preview` example output for the gallery.',
  'useEverywhere.section.skills.bullet4': 'Headless: an agent with `od` on its PATH can call `od skills list` then run any skill; the daemon is optional for read-only flows.',
  'useEverywhere.section.skills.bullet5': '`pnpm seed:test-projects` exercises the same artifact shape with default plugin examples and community plugin examples, then stores the resulting `index.html` projects as reusable test data.',
  'useEverywhere.section.skills.snippet1': 'Minimal SKILL.md (Claude-compatible front matter + OpenDesign extras)',
  'useEverywhere.section.skills.snippet2': 'Symlink a shared skill into a project (cc-switch style)',
  'useEverywhere.section.skills.snippet3': 'Headless: list skills the daemon sees right now',
  'useEverywhere.section.skills.snippet4': 'Headless artifact fixture bundle',
  'useEverywhere.section.skills.footer': 'Spec: `docs/skills-protocol.md` and `docs/agent-adapters.md` cover the full adapter surface (Claude Code, Codex, Cursor, MCP-capable agents, BYOK API fallback) and the per-adapter skill injection strategies.',
  'tasks.kicker': 'Automation workspace',
  'tasks.comingSoon': 'Coming soon',
  'tasks.lede': 'Automations turn prompts into durable work: Orbit runs them, routines keep them around, schedules decide when they fire, and live artifacts show what changed.',
  'tasks.newAutomation': 'New automation',
  'tasks.previewNote': 'Preview surface only. Orbit settings are available today; routines, schedules, and live artifact wiring will land as the backend branches merge.',
  'tasks.primitivesAria': 'Automation primitives',
  'tasks.primitive.orbit.title': 'Orbit',
  'tasks.primitive.orbit.body': 'A persistent runtime for long-running or recurring agent work.',
  'tasks.primitive.orbit.enabled': 'Daily summary enabled',
  'tasks.primitive.orbit.manualOnly': 'Manual only',
  'tasks.primitive.routines.title': 'Routines',
  'tasks.primitive.routines.body': 'Durable task definitions that survive after a single chat ends.',
  'tasks.primitive.routines.meta': 'Product shell ready',
  'tasks.primitive.schedules.title': 'Schedules',
  'tasks.primitive.schedules.body': 'Time or event triggers that decide when a routine should run.',
  'tasks.primitive.schedules.meta': 'Branch pending',
  'tasks.primitive.liveArtifacts.title': 'Live artifacts',
  'tasks.primitive.liveArtifacts.body': 'Reports and notes that keep updating while an agent works.',
  'tasks.primitive.liveArtifacts.meta': 'Preview model',
  'tasks.listAria': 'Automations list',
  'tasks.routinesAndRuns': '{n} routines and runs',
  'tasks.filtersAria': 'Automation filters',
  'tasks.filter.scheduled': 'Scheduled',
  'tasks.filter.running': 'Running',
  'tasks.filter.done': 'Done',
  'tasks.configurationAria': 'Automation configuration',
  'tasks.slot.trigger': 'Trigger',
  'tasks.slot.pattern': 'Pattern',
  'tasks.slot.runtime': 'Runtime',
  'tasks.slot.output': 'Output',
  'tasks.liveArtifact': 'Live artifact',
  'tasks.viewProgress': 'View progress',
  'tasks.pause': 'Pause',
  'tasks.runNow': 'Run now',
  'tasks.openArtifact': 'Open artifact',
  'tasks.status.dailyAt': 'Daily · {time}',
  'tasks.status.pausedManual': 'Paused · manual only',
  'tasks.sample.orbit.title': 'Orbit Daily connector summary',
  'tasks.sample.orbit.metaEnabled': 'Connector digest is scheduled',
  'tasks.sample.orbit.metaDisabled': 'Open Orbit settings to enable',
  'tasks.sample.orbit.previewEnabled': 'orbit_daily.html · live artifact',
  'tasks.sample.orbit.previewDisabled': 'No run scheduled',
  'tasks.sample.orbit.triggerEnabled': 'Schedule · daily at {time}',
  'tasks.sample.orbit.triggerDisabled': 'Manual · run on demand',
  'tasks.sample.orbit.pattern': 'Routine · connector digest',
  'tasks.sample.orbit.runtime': 'Orbit · daemon scheduled',
  'tasks.sample.orbit.output': 'Live artifact · refreshable report',
  'tasks.sample.orbit.artifactMetaEnabled': 'Refreshes after each run',
  'tasks.sample.orbit.artifactMetaDisabled': 'Waiting for schedule',
  'tasks.sample.orbit.body1': '# Orbit Daily activity summary',
  'tasks.sample.orbit.body2': 'Connectors checked · successes, skips, and failures',
  'tasks.sample.orbit.body3': 'Highlights become a refreshable live artifact.',
  'tasks.sample.mcp.title': 'MCP alternatives research',
  'tasks.sample.mcp.status': 'Running in orbit · 2h 14m',
  'tasks.sample.mcp.meta': '14 / 30 sources processed',
  'tasks.sample.mcp.preview': 'research_notes.md · live',
  'tasks.sample.mcp.trigger': 'Manual · one-shot',
  'tasks.sample.mcp.pattern': 'Deep research prompt',
  'tasks.sample.mcp.runtime': 'Remote · persistent',
  'tasks.sample.mcp.output': 'Live report · auto-updating',
  'tasks.sample.mcp.artifactMeta': 'Updated 12s ago',
  'tasks.sample.mcp.body1': '# MCP alternatives - interim findings',
  'tasks.sample.mcp.body2': '14 sources reviewed · 3 contenders shortlisted',
  'tasks.sample.mcp.body3': '## Shortlist',
  'tasks.sample.mcp.body4': '- Tool-call schemas via JSON-RPC...',
  'tasks.sample.mcp.body5': '- gRPC-based agent protocols...',
  'tasks.sample.weekly.title': 'Weekly team digest',
  'tasks.sample.weekly.status': 'Next: Mon 9:00 AM',
  'tasks.sample.weekly.meta': 'Updates Team weekly doc',
  'tasks.sample.weekly.preview': 'team_weekly.md · next artifact',
  'tasks.sample.weekly.trigger': 'Schedule · weekly',
  'tasks.sample.weekly.pattern': 'Routine · team digest',
  'tasks.sample.weekly.runtime': 'Remote · recurring',
  'tasks.sample.weekly.output': 'Live artifact · markdown',
  'tasks.sample.weekly.artifactMeta': 'Last updated 4d ago',
  'tasks.sample.weekly.body1': '# Team weekly',
  'tasks.sample.weekly.body2': '## In flight',
  'tasks.sample.weekly.body3': '- Design-system integration pass',
  'tasks.sample.weekly.body4': '- Connector quality sweep',
  'tasks.sample.weekly.body5': '## Risks',
  'tasks.sample.pr.title': 'PR review reminder',
  'tasks.sample.pr.status': 'On new PR · fired 23m ago',
  'tasks.sample.pr.meta': 'Sends Slack DM',
  'tasks.sample.pr.preview': 'Last delivery succeeded',
  'tasks.sample.pr.trigger': 'Event · new PR',
  'tasks.sample.pr.pattern': 'Routine · notification',
  'tasks.sample.pr.runtime': 'Local · quick run',
  'tasks.sample.pr.output': 'Message · Slack DM',
  'tasks.sample.pr.artifactMeta': 'Last fired 23m ago',
  'tasks.sample.pr.body1': 'Opened PR #184 for review',
  'tasks.sample.pr.body2': 'Matched reviewers: design-platform, web-runtime',
  'tasks.sample.pr.body3': 'Delivery: Slack DM sent',
  'tasks.sample.meeting.title': 'Pre-meeting prep',
  'tasks.sample.meeting.status': 'Tomorrow · 10:00 AM',
  'tasks.sample.meeting.meta': 'One-shot · sends summary',
  'tasks.sample.meeting.preview': 'meeting_brief.md · queued',
  'tasks.sample.meeting.trigger': 'Schedule · one-shot',
  'tasks.sample.meeting.pattern': 'Briefing prompt',
  'tasks.sample.meeting.runtime': 'Remote · bounded',
  'tasks.sample.meeting.output': 'Artifact + message',
  'tasks.sample.meeting.artifactMeta': 'Queued for generation',
  'tasks.sample.meeting.body1': '# Meeting brief',
  'tasks.sample.meeting.body2': 'Agenda source: calendar event + linked docs',
  'tasks.sample.meeting.body3': 'Output will include decisions, blockers, and questions.',
  'tasks.sample.candidate.title': 'Candidate tracking',
  'tasks.sample.candidate.status': 'Failed · needs attention',
  'tasks.sample.candidate.meta': 'Auth expired',
  'tasks.sample.candidate.preview': 'Reconnect Greenhouse to resume',
  'tasks.sample.candidate.trigger': 'Schedule · daily',
  'tasks.sample.candidate.pattern': 'Routine · applicant sync',
  'tasks.sample.candidate.runtime': 'Remote · recurring',
  'tasks.sample.candidate.output': 'Live artifact · table',
  'tasks.sample.candidate.artifactMeta': 'Paused until auth is restored',
  'tasks.sample.candidate.body1': '# Candidate pipeline',
  'tasks.sample.candidate.body2': 'Last successful sync: 2d ago',
  'tasks.sample.candidate.body3': 'Action required: reconnect source account.',
  'routines.title': 'Automations',
  'routines.subtitle': 'Scheduled automations that run unattended.',
  'routines.newAutomation': 'New automation',
  'routines.loading': 'Loading…',
  'routines.empty': 'No automations yet.',
  'routines.emptyHint': 'Click New automation to schedule an unattended agent run.',
  'routines.runHistoryLoading': 'Loading runs…',
  'routines.runHistoryEmpty': 'No runs yet.',
  'routines.fieldName': 'Name',
  'routines.fieldNamePlaceholder': 'Morning briefing',
  'routines.fieldPrompt': 'Prompt',
  'routines.fieldPromptPlaceholder': 'Pull yesterday’s GitHub + Linear activity and summarize what changed.',
  'routines.fieldSchedule': 'Schedule',
  'routines.fieldMinute': 'Minute of every hour',
  'routines.fieldTime': 'Time',
  'routines.fieldTimezone': 'Timezone',
  'routines.fieldsetProject': 'Project',
  'routines.kind.hourly': 'Hourly',
  'routines.kind.daily': 'Daily',
  'routines.kind.weekdays': 'Weekdays',
  'routines.kind.weekly': 'Weekly',
  'routines.weekday.short.0': 'Sun',
  'routines.weekday.short.1': 'Mon',
  'routines.weekday.short.2': 'Tue',
  'routines.weekday.short.3': 'Wed',
  'routines.weekday.short.4': 'Thu',
  'routines.weekday.short.5': 'Fri',
  'routines.weekday.short.6': 'Sat',
  'routines.weekday.long.0': 'Sunday',
  'routines.weekday.long.1': 'Monday',
  'routines.weekday.long.2': 'Tuesday',
  'routines.weekday.long.3': 'Wednesday',
  'routines.weekday.long.4': 'Thursday',
  'routines.weekday.long.5': 'Friday',
  'routines.weekday.long.6': 'Saturday',
  'routines.timeAm': 'AM',
  'routines.timePm': 'PM',
  'routines.describe.hourly': 'Runs every hour at :{minute}',
  'routines.describe.daily': 'Runs daily at {time} {tz}',
  'routines.describe.weekdays': 'Runs Mon–Fri at {time} {tz}',
  'routines.describe.weekly': 'Runs every {day} at {time} {tz}',
  'routines.modeCreate': 'Create a new project each run',
  'routines.modeCreateHint': 'A fresh, isolated workspace per fire.',
  'routines.modeReuse': 'Reuse an existing project',
  'routines.modeReuseHint': 'Each run lives as a new conversation inside the project.',
  'routines.pickProject': '— Pick a project —',
  'routines.targetReuse': '→ {project}',
  'routines.targetCreate': '→ new project each run',
  'routines.tagPaused': 'paused',
  'routines.metaNext': 'next: {when}',
  'routines.metaLast': 'last:',
  'routines.triggerManual': 'manual',
  'routines.triggerScheduled': 'scheduled',
  'routines.openProject': 'Open project',
  'routines.openProjectTitle': 'Open the project this run wrote to',
  'routines.runNow': 'Run now',
  'routines.edit': 'Edit',
  'routines.pause': 'Pause',
  'routines.resume': 'Resume',
  'routines.history': 'History',
  'routines.hideHistory': 'Hide history',
  'routines.delete': 'Delete',
  'routines.deleteTitle': 'Delete this automation',
  'routines.cancel': 'Cancel',
  'routines.save': 'Save',
  'routines.saving': 'Saving…',
  'routines.create': 'Create',
  'routines.creating': 'Creating…',
  'routines.status.queued': 'queued',
  'routines.status.running': 'running',
  'routines.status.succeeded': 'succeeded',
  'routines.status.failed': 'failed',
  'routines.status.canceled': 'canceled',
  'routines.confirmDelete': 'Delete this automation? Past runs and their projects are kept.',
  'routines.errorPickProject': 'Pick a project to reuse, or switch to “Create new each run”',
  'routines.errorAgentEmptyOutput': 'Agent completed without producing any output. The model or provider may have returned an empty response — check the agent logs for upstream errors.',
  'entry.githubStarLabel': 'Star',
  'entry.githubStarTitle': 'Click to star us on GitHub',
  'entry.githubStarAria': 'Star OpenDesign on GitHub',
  'entry.tabImageTemplates': 'Image templates',
  'entry.tabVideoTemplates': 'Video templates',
  'promptTemplates.emptyNoMatch': 'No templates match your search.',
  'promptTemplates.fetchError': 'Could not load this template body.',
  'promptTemplates.promptLabel': 'Prompt body',
  'promptTemplates.copyPrompt': 'Copy prompt',
  'promptTemplates.copyDone': 'Copied!',
  'promptTemplates.allSources': 'All sources',
  'promptTemplates.retry': 'Retry',
  'connectors.title': 'Connectors',
  'connectors.subtitle': 'Local and future data sources that can power live artifacts.',
  'connectors.account': 'Account',
  'connectors.noAccount': 'Not connected',
  'connectors.tools': 'Tools',
  'connectors.connect': 'Connect',
  'connectors.disconnect': 'Disconnect',
  'connectors.authorizationPending': 'Waiting for authorization...',
  'connectors.authorizationPendingHint': 'Complete authorization in the opened window.',
  'connectors.cancelAuthorization': 'Cancel',
  'connectors.configure': 'Configure',
  'connectors.unavailable': 'Unavailable',
  'connectors.phaseStubTitle': 'Connector APIs arrive in Phase 3; this is a preview surface.',
  'connectors.statusAvailable': 'Available',
  'connectors.statusConnected': 'Connected',
  'connectors.statusError': 'Error',
  'connectors.statusDisabled': 'Disabled',
  'connectors.gateTitle': 'Add your Composio API key to continue',
  'connectors.gateBody': 'Paste your key above and click Save key to load available integrations.',
  'connectors.aboutLabel': 'About',
  'connectors.detailsLabel': 'Details',
  'connectors.statusLabel': 'Status',
  'connectors.category.aiAgents': 'AI agents',
  'connectors.category.aiInfrastructure': 'AI infrastructure',
  'connectors.category.accounting': 'Accounting',
  'connectors.category.admin': 'Admin',
  'connectors.category.advertising': 'Advertising',
  'connectors.category.analytics': 'Analytics',
  'connectors.category.automation': 'Automation',
  'connectors.category.cms': 'CMS',
  'connectors.category.crm': 'CRM',
  'connectors.category.calendar': 'Calendar',
  'connectors.category.commerce': 'Commerce',
  'connectors.category.communication': 'Communication',
  'connectors.category.contacts': 'Contacts',
  'connectors.category.dataPlatform': 'Data platform',
  'connectors.category.database': 'Database',
  'connectors.category.design': 'Design',
  'connectors.category.developer': 'Developer',
  'connectors.category.documentation': 'Documentation',
  'connectors.category.erp': 'ERP',
  'connectors.category.education': 'Education',
  'connectors.category.email': 'Email',
  'connectors.category.events': 'Events',
  'connectors.category.fieldService': 'Field service',
  'connectors.category.finance': 'Finance',
  'connectors.category.fitness': 'Fitness',
  'connectors.category.forms': 'Forms',
  'connectors.category.gaming': 'Gaming',
  'connectors.category.hr': 'HR',
  'connectors.category.hospitality': 'Hospitality',
  'connectors.category.itsm': 'ITSM',
  'connectors.category.integration': 'Integration',
  'connectors.category.localization': 'Localization',
  'connectors.category.logistics': 'Logistics',
  'connectors.category.maps': 'Maps',
  'connectors.category.marketing': 'Marketing',
  'connectors.category.media': 'Media',
  'connectors.category.meetings': 'Meetings',
  'connectors.category.nonprofit': 'Nonprofit',
  'connectors.category.observability': 'Observability',
  'connectors.category.payments': 'Payments',
  'connectors.category.personal': 'Personal',
  'connectors.category.presentations': 'Presentations',
  'connectors.category.procurement': 'Procurement',
  'connectors.category.product': 'Product',
  'connectors.category.productivity': 'Productivity',
  'connectors.category.projectManagement': 'Project management',
  'connectors.category.recruiting': 'Recruiting',
  'connectors.category.research': 'Research',
  'connectors.category.salesIntelligence': 'Sales intelligence',
  'connectors.category.scheduling': 'Scheduling',
  'connectors.category.search': 'Search',
  'connectors.category.security': 'Security',
  'connectors.category.signing': 'Signing',
  'connectors.category.social': 'Social',
  'connectors.category.spreadsheets': 'Spreadsheets',
  'connectors.category.storage': 'Storage',
  'connectors.category.support': 'Support',
  'connectors.category.surveys': 'Surveys',
  'connectors.category.tasks': 'Tasks',
  'connectors.category.timeTracking': 'Time tracking',
  'connectors.category.video': 'Video',
  'connectors.category.whiteboard': 'Whiteboard',
  'connectors.categoryLabel': 'Category',
  'connectors.providerLabel': 'Provider',
  'connectors.toolsSection': 'Tools',
  'connectors.toolsLoading': 'Loading tools…',
  'connectors.noToolsAvailable': 'No tools available yet. Connect to discover what this integration exposes.',
  'connectors.toolDetailsUnavailable': 'Tool details are unavailable, but this connector reports {n} tools.',
  'connectors.loadMoreTools': 'Load more tools',
  'connectors.openDetailsAria': 'Open {name} details',
  'connectors.toolsBadgeNone': 'No tools',
  'connectors.toolsBadgeOne': '{n} tool',
  'connectors.toolsBadgeMany': '{n} tools',
  'connectors.searchPlaceholder': 'Search connectors…',
  'connectors.searchAriaLabel': 'Search connectors by name, provider, or tool',
  'connectors.searchClear': 'Clear search',
  'connectors.emptyNoMatchTitle': 'No connectors match “{query}”',
  'connectors.emptyNoMatchBody': 'Try a different keyword, or clear the search to browse the full catalog.',
  'connectors.emptyNoMatchAction': 'Clear search',
  'newproj.tabPrototype': 'Prototype',
  'newproj.tabLiveArtifact': 'Live artifact',
  'newproj.tabDeck': 'Slide deck',
  'newproj.tabTemplate': 'From template',
  'newproj.tabMedia': 'Media',
  'newproj.tabOther': 'Other',
  'newproj.titlePrototype': 'New prototype',
  'newproj.titleLiveArtifact': 'New live artifact',
  'newproj.titleDeck': 'New slide deck',
  'newproj.titleTemplate': 'Start from a template',
  'newproj.titleImage': 'New image',
  'newproj.titleVideo': 'New video',
  'newproj.titleAudio': 'New audio',
  'newproj.titleMedia': 'New media',
  'newproj.titleOther': 'New project',
  'newproj.namePlaceholder': 'Project name',
  'newproj.fidelityLabel': 'Fidelity',
  'newproj.fidelityWireframe': 'Wireframe',
  'newproj.fidelityHigh': 'High fidelity',
  'newproj.toggleSpeakerNotes': 'Use speaker notes',
  'newproj.toggleSpeakerNotesHint': 'Less text on slides — keep talking points in notes.',
  'newproj.toggleAnimations': 'Include animations',
  'newproj.toggleAnimationsHint': 'Add motion (entrance, hover, transitions) on top of the template.',
  'newproj.targetPlatformsLabel': 'Target platforms',
  'newproj.targetPlatformsHint': 'Pick one or more. Responsive web covers browser breakpoints only; add iOS, Android, tablet app, or desktop app for native cross-platform variants.',
  'newproj.platform.responsive.label': 'Responsive web',
  'newproj.platform.responsive.hint': 'One web experience adapted for desktop, tablet, and mobile browsers',
  'newproj.platform.webDesktop.label': 'Desktop web',
  'newproj.platform.webDesktop.hint': 'Browser-first product or landing page',
  'newproj.platform.mobileIos.label': 'iOS app',
  'newproj.platform.mobileIos.hint': 'iPhone frames and iOS interaction rules',
  'newproj.platform.mobileAndroid.label': 'Android app',
  'newproj.platform.mobileAndroid.hint': 'Pixel frames and Material interaction rules',
  'newproj.platform.tablet.label': 'Tablet app',
  'newproj.platform.tablet.hint': 'Native-style tablet experience with split views',
  'newproj.platform.desktopApp.label': 'Desktop app',
  'newproj.platform.desktopApp.hint': 'macOS/Windows app chrome',
  'newproj.surfaceOptionsLabel': 'Companion surfaces',
  'newproj.includeLandingPage': 'Include landing page',
  'newproj.includeLandingPageHint': 'Add a responsive marketing page for ads, waitlists, launch campaigns, app downloads, or product explanation.',
  'newproj.includeOsWidgets': 'Include OS widgets',
  'newproj.includeOsWidgetsHint': 'Add platform-native home screen, lock screen, or quick-access widgets for mobile/tablet apps.',
  'newproj.includeOsWidgetsDisabledHint': 'Available when iOS, Android, or tablet app is selected as a target platform.',
  'newproj.templateLabel': 'Template',
  'newproj.noTemplatesTitle': 'No templates yet',
  'newproj.noTemplatesBody': 'Open any project, then use the Share menu inside the file viewer to convert it into a template. Templates show up here.',
  'newproj.savedTemplate': 'Saved template',
  'newproj.fileSingular': 'file',
  'newproj.filePlural': 'files',
  'newproj.create': 'Create',
  'newproj.locationLabel': 'Save to',
  'newproj.locationDefault': 'OpenDesign projects',
  'newproj.locationExternalBase': 'External base',
  'newproj.createLiveArtifact': 'Create live artifact',
  'newproj.createFromTemplate': 'Create from template',
  'newproj.createDisabledTitle': 'Save a project as a template first (Share menu inside any project).',
  'newproj.openFolder': 'Open folder',
  'newproj.openingFolder': 'Opening…',
  'newproj.importClaudeZip': 'Import Claude Design ZIP',
  'newproj.importClaudeZipTitle': 'Import a Claude Design .zip export',
  'newproj.importingClaudeZip': 'Importing…',
  'newproj.privacyFooter': 'Only you can see your project by default.',
  'newproj.designSystem': 'Design system',
  'newproj.dsNoneFreeform': 'None — freeform',
  'newproj.dsNoneSubtitleEmpty': 'No system tokens, choose your own palette',
  'newproj.dsNoneSubtitleSelected': 'Skip system tokens. The agent picks its own palette.',
  'newproj.dsCategoryFallback': 'Design system',
  'newproj.dsSearch': 'Search design systems…',
  'newproj.dsModeAria': 'Selection mode',
  'newproj.dsModeSingle': 'Single',
  'newproj.dsModeMulti': 'Multi',
  'newproj.dsNoneTitle': 'None — freeform',
  'newproj.dsNoneSub': 'Skip system tokens. The agent picks its own palette.',
  'newproj.dsEmpty': 'No design systems match “{query}”.',
  'newproj.dsFootSingular': 'is inspiration only.',
  'newproj.dsFootPlural': 'are inspiration only.',
  'newproj.dsFootClear': 'Clear',
  'newproj.dsBadgeDefault': 'DEFAULT',
  'newproj.dsPrimaryFallback': 'Primary',
  'newproj.surfaceImage': 'Image',
  'newproj.surfaceVideo': 'Video',
  'newproj.surfaceAudio': 'Audio',
  'newproj.modelLabel': 'Model',
  'newproj.modelSearch': 'Search models…',
  'newproj.modelEmpty': 'No models match this search.',
  'newproj.modelRecommended': 'Recommended',
  'newproj.modelMissingTitle': 'Pick a model',
  'newproj.modelMissingSub': 'Choose which model handles this surface.',
  'newproj.aspectLabel': 'Aspect',
  'newproj.videoLengthLabel': 'Length',
  'newproj.videoLengthSeconds': '{n}s',
  'newproj.audioKindLabel': 'Audio type',
  'newproj.audioKindMusic': 'Music',
  'newproj.audioKindSpeech': 'Speech / TTS',
  'newproj.audioKindSfx': 'SFX',
  'newproj.audioDurationLabel': 'Duration',
  'newproj.audioDurationSeconds': '{n}s',
  'newproj.voiceLabel': 'Voice',
  'newproj.voicePlaceholder': 'Provider voice id, optional',
  'newproj.connectorsLabel': 'Connectors',
  'newproj.connectorsHint': 'Data sources this artifact can pull from.',
  'newproj.connectorsEmptyTitle': 'No connectors configured',
  'newproj.connectorsEmptyBody': 'Connect a data source so your live artifact can fetch real numbers instead of placeholders.',
  'newproj.connectorsEmptyCta': 'Set up connectors →',
  'newproj.connectorsLoading': 'Loading connectors…',
  'newproj.connectorsCountOne': '{n} connected',
  'newproj.connectorsCountMany': '{n} connected',
  'newproj.connectorsManage': 'Manage',
  'newproj.promptTemplateLabel': 'Reference template',
  'newproj.promptTemplateNoneTitle': 'None — write your own',
  'newproj.promptTemplateNoneSub': 'Skip the gallery, describe your own brief',
  'newproj.promptTemplateRefSub': 'Reference template',
  'newproj.promptTemplateSearch': 'Search templates…',
  'newproj.promptTemplateEmpty': 'No templates installed for this surface yet.',
  'newproj.promptTemplateBodyLabel': 'Prompt (you can tune it)',
  'newproj.promptTemplateOptimizeHint': 'Edit anything — your changes carry into the agent\'s brief.',
  'newproj.promptTemplateBodyEmpty': 'Empty body — the agent will get no template reference.',
  'newproj.deleteTemplateTitle': 'Delete template',
  'newproj.deleteTemplateConfirm': 'Delete "{name}"? This cannot be undone.',
  'newproj.deleteTemplateConfirmCta': 'Delete template',
  'newproj.deleteTemplateError': 'Could not delete this template. Please try again.',
  'designs.subRecent': 'Recent',
  'designs.subYours': 'Your designs',
  'designs.filterAria': 'Filter projects',
  'designs.searchPlaceholder': 'Search…',
  'designs.emptyNoProjects': 'No projects yet.',
  'designs.emptyNoMatch': 'No projects match your search.',
  'designs.deleteTitle': 'Delete project',
  'designs.deleteConfirm': 'Delete "{name}"?',
  'designs.cardFreeform': 'freeform',
  'designs.badgeLive': 'Live',
  'designs.liveArtifactBadgesAria': 'Live artifact badges',
  'designs.liveCount': '{n} live',
  'designs.statusLive': 'Live artifact',
  'designs.statusArchived': 'Archived',
  'designs.statusError': 'Error',
  'designs.statusRefreshing': 'Refreshing…',
  'designs.statusRefreshFailed': 'Refresh failed',
  'designs.statusRefreshed': 'Refreshed',
  'designs.status.notStarted': 'Not started',
  'designs.status.queued': 'Queued',
  'designs.status.running': 'Running',
  'designs.status.awaitingInput': 'Needs input',
  'designs.status.incomplete': 'Incomplete',
  'designs.status.succeeded': 'Completed',
  'designs.status.published': 'Published',
  'designs.status.failed': 'Failed',
  'designs.status.canceled': 'Canceled',
  'designs.viewToggleAria': 'View mode',
  'designs.viewGrid': 'Grid view',
  'designs.viewKanban': 'Board view',
  'designs.kanbanEmptyColumn': 'No designs',
  'designs.deleteAria': 'Delete project {name}',
  'designs.menuMore': 'More actions',
  'designs.menuRename': 'Rename',
  'designs.menuDuplicate': 'Duplicate project',
  'designs.menuDelete': 'Delete',
  'designs.renamePrompt': 'New name for "{name}"',
  'designs.selectMode': 'Select',
  'designs.cancelSelect': 'Cancel',
  'designs.deleteSelected': 'Delete selected',
  'designs.selectedCount': '{n} selected',
  'designs.deleteSelectedConfirm': 'Delete {n} project(s)?',
  'designs.deleteSelectedSuccess': '{n} project(s) deleted successfully.',
  'designs.deleteSelectedPartial': 'Deleted {deleted} project(s); {failed} failed.',
  'designs.tagPrototype': 'Prototype',
  'designs.tagLiveArtifact': 'Live Artifact',
  'designs.tagWebClone': 'Website clone',
  'designs.tagSlide': 'Slide',
  'designs.tagMedia': 'Media',
  'designs.renameTitle': 'Rename project',
  'designs.renameSave': 'OK',
  'designs.renameCancel': 'Cancel',
  'examples.typeLabel': 'Type',
  'examples.surfaceLabel': 'Surface',
  'examples.surfaceWeb': 'Web',
  'examples.surfaceImage': 'Image',
  'examples.surfaceVideo': 'Video',
  'examples.surfaceAudio': 'Audio',
  'examples.scenarioLabel': 'Scenario',
  'examples.modeAll': 'All',
  'examples.modePrototypeDesktop': 'Prototypes · Desktop',
  'examples.modePrototypeMobile': 'Prototypes · Mobile',
  'examples.modeDeck': 'Slides',
  'examples.modeDocument': 'Docs & templates',
  'examples.modeOrbit': 'Orbit',
  'examples.modeLive': 'Live',
  'examples.scenarioGeneral': 'General',
  'examples.scenarioEngineering': 'Engineering',
  'examples.scenarioProduct': 'Product',
  'examples.scenarioDesign': 'Design',
  'examples.scenarioMarketing': 'Marketing',
  'examples.scenarioSales': 'Sales',
  'examples.scenarioFinance': 'Finance',
  'examples.scenarioHr': 'HR',
  'examples.scenarioOperations': 'Operations',
  'examples.scenarioSupport': 'Support',
  'examples.scenarioLegal': 'Legal',
  'examples.scenarioEducation': 'Education',
  'examples.scenarioPersonal': 'Personal',
  'examples.searchPlaceholder': 'Search examples…',
  'examples.searchAria': 'Search examples by name',
  'examples.emptyNoSkills': 'No skills available. Is the daemon running?',
  'examples.emptyNoMatch': 'No examples match these filters.',
  'examples.openPreview': '⤢ Open preview',
  'examples.loadingPreview': 'Loading preview…',
  'examples.hoverPreview': 'Hover to preview',
  'examples.usePrompt': 'Use this prompt',
  'examples.previewModalTitle': 'Open full preview (modal)',
  'examples.shareTitle': 'Share this example',
  'examples.shareLoadFirst': 'Hover to load preview first',
  'examples.unavailablePlaceholder': 'No shipped {kind} preview — open to learn more',
  'examples.shareUnavailable': 'No shipped {kind} preview to share',
  'examples.shareMenu': 'Share ▾',
  'examples.exportPdfAllSlides': 'Export as PDF (all slides)',
  'examples.exportPptxLocked': 'Export as PPTX… (open template first)',
  'examples.tagSlideDeck': 'Slide deck',
  'examples.tagTemplate': 'Template',
  'examples.tagDesignSystem': 'Design system',
  'examples.tagMobilePrototype': 'Mobile prototype',
  'examples.tagDesktopPrototype': 'Desktop prototype',
  'examples.tagImage': 'Image',
  'examples.tagVideo': 'Video',
  'examples.tagAudio': 'Audio',
  'examples.previewLabel': 'Preview',
  'ds.surfaceLabel': 'Surface',
  'ds.surfaceWeb': 'Web',
  'ds.surfaceImage': 'Image',
  'ds.surfaceVideo': 'Video',
  'ds.surfaceAudio': 'Audio',
  'ds.searchPlaceholder': 'Search design systems…',
  'ds.emptyNoMatch': 'No design systems match your search.',
  'ds.badgeDefault': 'DEFAULT',
  'ds.preview': 'Preview full system',
  'ds.previewTitle': 'Preview the full design system',
  'ds.categoryAll': 'All',
  'ds.categoryUncategorized': 'Uncategorized',
  'ds.showcase': 'Showcase',
  'ds.tokens': 'Tokens',
  'ds.specToggle': 'DESIGN.md',
  'ds.specLoading': 'Loading DESIGN.md…',
  'avatar.title': 'Account & settings',
  'avatar.localCli': 'Local CLI',
  'avatar.anthropicApi': 'Anthropic API',
  'avatar.useLocal': 'Use Local CLI',
  'avatar.useApi': 'Use API · BYOK',
  'avatar.codeAgent': 'Code agent',
  'avatar.rescan': 'Rescan PATH',
  'avatar.amrConsole': 'OpenDesign Cloud',
  'avatar.amrConsoleMeta': 'Balance & recharge',
  'avatar.settings': 'Settings',
  'avatar.backToProjects': 'Back to projects',
  'avatar.metaActive': 'active',
  'avatar.metaOffline': 'offline',
  'avatar.metaSelected': 'selected',
  'avatar.noAgentSelected': 'no agent selected',
  'avatar.modelSection': 'Model',
  'avatar.modelLabel': 'Model',
  'avatar.reasoningLabel': 'Reasoning',
  'avatar.serviceTierLabel': 'Service tier',
  'avatar.customSuffix': '(custom)',
  'socialShare.openDesignSection': 'Share OpenDesign',
  'socialShare.openDesignTitle': 'OpenDesign on GitHub',
  'socialShare.openDesignText': 'OpenDesign is a source-available workspace for creating, editing, deploying, and handing off design artifacts.',
  'socialShare.openDesignCopyText': '{text}\n{url}',
  'socialShare.projectSection': 'SOCIAL SHARE',
  'socialShare.publishPageTitle': 'Publish share page',
  'socialShare.publishPageSubtitle': 'Publish this preview so it can be shared on social platforms.',
  'socialShare.projectTitle': '{title} · OpenDesign',
  'socialShare.projectText': 'Built with OpenDesign: {title}. View the deployed artifact and star the repo: {repo}',
  'socialShare.projectCopyText': 'Built with OpenDesign: {title}\n{url}\nOpenDesign repo: {repo}',
  'socialShare.deployFirst': 'Deploy then share…',
  'socialShare.copied': 'Copied',
  'socialShare.platform.x': 'X',
  'socialShare.platform.linkedin': 'LinkedIn',
  'socialShare.platform.facebook': 'Facebook',
  'socialShare.platform.reddit': 'Reddit',
  'socialShare.platform.telegram': 'Telegram',
  'socialShare.platform.whatsapp': 'WhatsApp',
  'socialShare.platform.weibo': 'Weibo',
  'socialShare.platform.line': 'LINE',
  'socialShare.platform.instagram': 'Instagram',
  'socialShare.platform.xiaohongshu': 'Xiaohongshu',
  'inlineSwitcher.chipTitle': 'Switch CLI / model',
  'inlineSwitcher.chipCli': 'Local CLI',
  'inlineSwitcher.chipByok': 'BYOK',
  'inlineSwitcher.modelDefault': 'default',
  'inlineSwitcher.noAgent': 'no agent',
  'inlineSwitcher.modeLabel': 'Mode',
  'inlineSwitcher.agentLabel': 'Agent',
  'inlineSwitcher.providerLabel': 'Provider',
  'inlineSwitcher.modelLabel': 'Model',
  'inlineSwitcher.useCli': 'Use Local CLI',
  'inlineSwitcher.useByok': 'Use BYOK API key',
  'inlineSwitcher.daemonOffline': 'Daemon offline — open settings',
  'inlineSwitcher.noAgentsDetected': 'No CLI detected on PATH',
  'inlineSwitcher.openSettingsForModel': 'Configure provider in Settings',
  'inlineSwitcher.missingApiKey': 'API key not set — open Settings to add it.',
  'inlineSwitcher.openFullSettings': 'Open execution settings',
  'inlineSwitcher.customSuffix': '(custom)',
  'inlineSwitcher.unlimitedBadge': 'Unlimited',
  'project.backToProjects': 'Back to projects',
  'project.brandReadyTitle': '{name} design system is ready',
  'project.brandReadyTitleGeneric': 'Your design system is ready',
  'project.brandReadyCta': 'Preview in Design systems',
  'project.brandReadyDismiss': 'Dismiss',
  'project.brandReadyRefineHint': 'Automatic extraction can miss details. Refine it before using this system broadly.',
  'project.brandReadyAiOptimize': 'AI Optimize',
  'project.brandReadyEditManually': 'Edit manually',
  'project.brandReadyPreviewOpened': 'Design system preview opened.',
  'project.previewCommentSaveFailed': 'Comment could not be saved. Please try again.',
  'project.previewCommentSaveFailedTitle': 'Comment could not be saved',
  'project.previewCommentSaveFailedDescription': 'This comment was not saved. Please try again.',
  'project.previewCommentReorderFailed': 'Comment order could not be saved and may reset on reload.',
  'project.metaFreeform': 'freeform',
  'project.typePrototype': 'Prototype',
  'project.typeDeck': 'Slides',
  'project.typeTemplate': 'Template',
  'project.typeImage': 'Image',
  'project.typeVideo': 'Video',
  'project.typeAudio': 'Audio',
  'project.customInstructions': 'Project instructions',
  'project.customInstructionsPlaceholder': 'Instructions for this project (injected on every message)…',
  'project.resizeChatPanel': 'Resize chat panel',
  'project.instructionsActive': 'Active — included in every message',
  'project.missing': 'This project has been deleted or no longer exists.',
  'chat.tabChat': 'Chat',
  'chat.tabComments': 'Comments',
  'chat.commentsSoon': 'Comments — coming soon',
  'chat.comments.attached': 'Attached to chat',
  'chat.comments.emptyAttached': 'No comments attached.',
  'chat.comments.saved': 'Saved comments',
  'chat.comments.emptySaved': 'No saved comments.',
  'chat.comments.add': 'Add',
  'chat.comments.addAll': 'Add all',
  'chat.comments.remove': 'Remove',
  'chat.comments.placeholder': 'Comment on this element…',
  'chat.comments.addSend': 'Add & send',
  'chat.comments.updateSend': 'Update & send',
  'chat.comments.removeAttachment': 'Remove comment attachment',
  'chat.comments.removeAttachmentAria': 'Remove comment attachment for {name}',
  'chat.comments.comment': 'Comment',
  'chat.comments.sendToChat': 'Send to chat',
  'chat.comments.viewAll': 'View all comments',
  'chat.comments.sending': 'Sending…',
  'chat.comments.edit': 'Edit',
  'chat.comments.select': 'Select',
  'chat.comments.selectAll': 'Select all',
  'chat.comments.deselect': 'Deselect',
  'chat.comments.nSelected': '{n} selected',
  'chat.comments.pin': 'Pin',
  'chat.comments.addNote': 'Add note',
  'chat.comments.savedToast': 'Comment saved',
  'chat.comments.pinSavedToast': 'Pin saved',
  'chat.comments.pinAtCoords': 'at {x}, {y}',
  'chat.comments.capturedItems': '{n} captured items',
  'chat.comments.clear': 'Clear',
  'chat.comments.targetImage': 'Image',
  'chat.comments.targetControl': 'Control',
  'chat.comments.targetLink': 'Link',
  'chat.comments.targetText': 'Text',
  'chat.comments.targetSection': 'Section',
  'chat.comments.targetPage': 'Page',
  'chat.comments.targetArea': 'Area',
  'chat.annotationNotePlaceholder': 'Add a note for this mark',
  'chat.annotationAttachImage': 'Attach image',
  'chat.annotationAttachedImages': 'Attached images',
  'chat.annotationAttachedRemove': 'Remove last image',
  'chat.annotationAddToInput': 'Add to input',
  'chat.annotationAddingToInput': 'Adding...',
  'chat.annotationQueue': 'Queue',
  'chat.annotationQueueing': 'Queueing...',
  'chat.annotationSubmitOptions': 'Submit options',
  'chat.annotationSending': 'Sending...',
  'chat.annotationSendDisabledReason': 'A task is currently running',
  'chat.annotationPreviewMissing': 'Could not capture the preview. Please try again.',
  'chat.annotationPreviewMissingInk': 'Could not capture the preview. Try again to avoid sending only ink.',
  'chat.annotationSentWithoutScreenshot': 'Could not capture the preview. The annotation was sent without a screenshot.',
  'chat.annotationTimeout': 'Annotation send timed out. Please try again.',
  'chat.annotationFailed': 'Annotation send failed. Please try again.',
  'chat.annotationProjectCreateFailed': 'Could not create a project, so the annotation was not sent.',
  'chat.annotationUploadFailed': 'Attachment upload failed. Please try again.',
  'chat.attachmentFolderUnsupported': "Folders can't be attached here. Attach the files inside instead.",
  'chat.conversationsTitle': 'Conversations',
  'chat.conversationsAria': 'Conversation history',
  'chat.newConversation': 'New conversation',
  'chat.newSession': 'New conversation',
  'chat.newConversationsTitle': 'New conversation',
  'chat.conversationsHeading': 'Conversations',
  'chat.emptyConversations': 'No conversations yet.',
  'chat.deleteConversation': 'Delete conversation',
  'chat.renameConversationLabel': 'Rename "{title}"',
  'chat.deleteConversationConfirm': 'Delete "{title}"? This removes its messages.',
  'chat.untitledConversation': 'Untitled conversation',
  'chat.forkConversationFailed': 'Could not start a new conversation.',
  'chat.startTitle': 'Start a conversation',
  'chat.startHint': 'Describe what you want to generate, or start from one of these examples:',
  'chat.brandBrowserAssistDesktopOnly': 'Browser assist needs the desktop app so OpenDesign can read the live browser page.',
  'chat.brandBrowserAssistReadFailed': 'Could not read the browser page. Make sure the brand site is open and fully loaded.',
  'chat.memoryWrittenSummary': 'Remembered {count} preferences',
  'chat.brandBrowserAssistMessage': 'OpenDesign needs browser assist to finish this brand extraction. Use the card below to open Browser, then click More, choose Download Page, wait for the success message, and use the left Next Step card to continue extraction. If the card is not visible, manually open the Browser tab on the right and follow More > Download Page > Continue extraction.',
  'chat.brandBrowserLocalSnapshotMissing': 'No saved page snapshot is available for this URL.',
  'chat.brandBrowserLocalSnapshotReadFailed': 'Could not read the saved page snapshot.',
  'chat.brandBrowserSnapshotSaveFailed': 'Could not save a page snapshot from the browser.',
  'chat.brandBrowserAssistDownloadGuideTitle': 'Browser opened',
  'chat.brandBrowserAssistDownloadGuideDetails': 'Step 1: open or switch to the Browser tab on the right and clear any human check. Step 2: click More, then Download Page. Step 3: wait for the saved snapshot success message. Step 4: return to the left Next Step card and click Continue extraction to continue the programmatic extraction.',
  'brandEnrichment.title': "AI Optimize",
  'brandEnrichment.body': "OpenDesign will run a deeper extraction in the background, apply the right design-system skills automatically, and update this system in place. This can take 10-20 minutes; you can keep working.",
  'brandEnrichment.cta': "AI Optimize",
  'brandEnrichment.busy': "Starting AI Optimize...",
  'brandExtractionTranscript.sourceDesignMd': 'pasted DESIGN.md',
  'brandExtractionTranscript.user': 'Extract a design system from {source}.',
  'brandExtractionTranscript.doneTitle': 'Programmatic extraction finished for {name}.',
  'brandExtractionTranscript.doneBody': 'I created and registered the {designSystemId} design system from {source}. It is ready to preview and can be used in new designs now.',
  'brandExtractionTranscript.next': 'Next, choose a follow-up: refine the extracted design system with an agent pass that uses model tokens, or create a new design using this system.',
  'chat.fillInputTitle': 'Click to fill the input',
  'chat.jumpToLatest': 'Jump to latest',
  'chat.scrollToLatest': 'Scroll to latest',
  'chat.messageRail.aria': 'User message navigation',
  'chat.messageRail.jumpAria': 'Jump to user message {index}',
  'chat.messageRail.empty': '(No content)',
  'chat.you': 'You',
  'chat.record.retryImage': '{count} of the illustrations failed to generate — please try those again',
  'chat.quote.add': 'Add to chat',
  'chat.quote.count': '{count} notes',
  'chat.quote.duplicate': 'Already added to the chat',
  'chat.quote.removeAria': 'Remove notes',
  'chat.support.title': 'Contact support',
  'chat.support.join': 'Join',
  'chat.sendFailedRetryAria': 'Send failed — retry',
  'chat.audio.play': 'Play',
  'chat.audio.pause': 'Pause',
  'chat.audio.download': 'Download {name}',
  'chat.upgrade.balance': 'Balance left',
  'chat.upgrade.whyLow': 'This may not cover the next task — running out midway leaves it half-finished',
  'chat.upgrade.whyOut': 'You can’t start a new task right now',
  'chat.upgrade.pausedTitle': 'Insufficient allowance, task paused',
  'chat.upgrade.pausedMessage': 'Your allowance is insufficient. Top up or upgrade your plan, then try again.',
  'chat.upgrade.pausedTeamTitle': 'Insufficient team allowance, task paused',
  'chat.upgrade.pausedTeamMessage': 'Your team’s allowance is insufficient. Ask your team admin to top up or upgrade the subscription.',
  'chat.openFile': 'Open {name}',
  'chat.copyPrompt': 'Copy prompt',
  'chat.copyErrorDiagnostic': 'Copy error diagnostics',
  'chat.copyDone': 'Copied!',
  'chat.inspect.noEditableTargets': 'No editable text or style targets found.',
  'chat.inspect.noCommentTargets': 'No commentable text or visual targets found.',
  'chat.inspect.editHint': 'Select a text or style target in the preview to edit it.',
  'chat.inspect.commentHint': 'Select text or an area in the preview to comment on it.',
  'chat.composerPlaceholder': 'Describe what you want to generate…',
  'chat.activeFileEditingLabel': 'Editing',
  'chat.activeFilePlaceholder': 'Ask OpenDesign to change {file}...',
  'chat.designArtifactsShowMore': 'Show {count} more design files',
  'chat.mode.chat.label': 'Ask',
  'chat.mode.chat.title': 'Ask mode',
  'chat.mode.chat.summary': 'For quick answers, edits, planning, and discussion without assuming a design artifact must be created.',
  'chat.mode.chat.solves': 'Use it to clarify ideas, debug prompts, compare options, or ask questions about existing work.',
  'chat.mode.chat.query1': 'Summarize this draft and point out gaps.',
  'chat.mode.chat.query2': 'Help me decide the best structure for this landing page.',
  'chat.mode.chat.query3': 'Review this design and suggest concrete improvements.',
  'chat.mode.plan.label': "Plan",
  'chat.mode.plan.title': "Plan mode",
  'chat.mode.plan.summary': "Creates an editable plan document first, then hands off to Design after you review it.",
  'chat.mode.plan.solves': "Use it for PRDs, slide outlines, prototype briefs, wireframes, storyboards, and any broad request that needs confirmation before generation.",
  'chat.mode.plan.query1': "Create a slide-by-slide PPT outline first.",
  'chat.mode.plan.query2': "Draft a PRD before generating the prototype.",
  'chat.mode.plan.query3': "Turn this idea into an editable design plan.",
  'chat.mode.design.label': 'Design',
  'chat.mode.design.title': 'Design mode',
  'chat.mode.design.summary': 'For creating or changing concrete outputs: pages, prototypes, live artifacts, slides, images, videos, HyperFrames, audio, dashboards, and project files.',
  'chat.mode.design.solves': 'Use it when you want OpenDesign to generate files, update the workspace, or turn a brief into multimodal deliverables.',
  'chat.mode.design.query1': 'Create a product launch landing page and HyperFrames prototype from this brief.',
  'chat.mode.design.query2': 'Make a 10-slide investor deck with speaker notes.',
  'chat.mode.design.query3': 'Generate image, video, and audio concepts for this campaign.',
  'chat.mode.cardBestFor': 'Best for',
  'chat.mode.cardTry': 'Try asking',
  'chat.mode.cardCost': 'Typical usage',
  'chat.mode.chat.cost': 'Light',
  'chat.mode.chat.costNote': 'A conversation only — nothing is generated, so it uses the least.',
  'chat.mode.plan.cost': 'Standard',
  'chat.mode.plan.costNote': 'Produces one editable plan document before any generation.',
  'chat.mode.design.cost': 'Heavy',
  'chat.mode.design.costNote': 'Generates files and multimodal media, so a run can use the most.',
  'chat.modePicker.choose': 'Choose a mode',
  'chat.modePicker.current': 'Mode: {name}',
  'chat.modePicker.clear': 'Clear mode',
  'chat.modePicker.mode': 'Mode',
  'chat.composerHint': '⌘/Ctrl + Enter to send · include goals, content, style, and format',
  'chat.cliSettingsTitle': 'CLI & model settings',
  'chat.cliSettingsAria': 'Open CLI and model settings',
  'chat.attachTitle': 'Attach files (or paste / drop)',
  'chat.addContextTitle': 'Add context',
  'chat.attachAria': 'Attach files',
  'chat.importTitle': 'Import sources (coming soon)',
  'chat.importLabel': 'Import',
  'chat.importComingSoon': 'Coming soon',
  'chat.importSoon': 'Soon',
  'chat.importFig': 'Upload .fig file',
  'chat.importGitHub': 'Connect GitHub',
  'chat.importWeb': 'Grab web element',
  'chat.importFolder': 'Link code folder',
  'chat.importSkills': 'Skills and design systems',
  'chat.importProject': 'Reference another project',
  'chat.importDesignSystemHeader': 'Choose a design system',
  'chat.importDesignSystemBack': 'Back',
  'chat.importDesignSystemSearch': 'Search design systems…',
  'chat.importDesignSystemEmpty': 'No design systems match "{query}"',
  'chat.importDesignSystemNone': 'None — freeform',
  'chat.importDesignSystemNoneSub': 'Don\'t anchor to a system this turn',
  'chat.importDesignSystemActive': 'Active',
  'chat.importDesignSystemSwitched': 'Design system switched to {title}',
  'chat.importDesignSystemFailed': 'Couldn\'t switch design system. Please try again.',
  'chat.importDesignSystemLoadFailed': 'Couldn\'t load design systems.',
  'browserUse.title': 'Inspiration',
  'browserUse.summary': '{count} web actions, prioritizing asset extraction, design language, motion, visual checks, and component structure.',
  'browserUse.searchAria': 'Search inspiration',
  'browserUse.searchPlaceholder': 'Search screenshots, fonts, colors, a11y...',
  'browserUse.empty': 'No matching inspiration',
  'browserUse.unavailable': 'Inspiration is unavailable here',
  'browserUse.added': 'Added to composer',
  // Design Browser
  'designBrowser.aria': 'Design Browser',
  'designBrowser.goBack': 'Go Back',
  'designBrowser.goForward': 'Go Forward',
  'designBrowser.reload': 'Reload',

  'designBrowser.stopLoading': 'Stop loading',
  'designBrowser.viewportAria': 'Browser viewport',
  'designBrowser.addressPlaceholder': 'Enter URL or search...',
  'designBrowser.addressAria': 'Browser address',
  'designBrowser.suggestion.reference': 'Reference',
  'designBrowser.suggestion.history': 'History',
  'designBrowser.menu.copyScreenshot': 'Copy Screenshot',
  'designBrowser.menu.hardReload': 'Hard Reload',
  'designBrowser.menu.copyUrl': 'Copy URL',
  'designBrowser.menu.openInBrowser': 'Open in Browser',
  'designBrowser.menu.savePageBrief': 'Save Page Brief',
  'designBrowser.menu.clearBrowsingHistory': 'Clear Browsing History',
  'designBrowser.menu.clearCookies': 'Clear Cookies',
  'designBrowser.menu.clearAllData': 'Clear All Data',
  'designBrowser.status.openHttpUrlFirst': 'Open an http URL first',
  'designBrowser.status.openPageBeforeScreenshot': 'Open a page before taking a screenshot',
  'designBrowser.status.screenshotCopied': 'Screenshot copied to clipboard',
  'designBrowser.status.openPageBeforeBrief': 'Open a page before saving a brief',
  'designBrowser.status.openPageBeforeTools': 'Open a page before using browser tools',
  'designBrowser.status.clickElementToComment': 'Click an element to comment',
  'designBrowser.status.clickElementToTune': 'Click an element to tune',
  'designBrowser.status.noElementSelected': 'No browser element selected',
  'designBrowser.status.addBrowserComment': 'Add a browser comment',
  'designBrowser.status.tuneElementThenSaveHtml': 'Tune the element, then save HTML',
  'designBrowser.status.tuneLiveOnly': 'Tune is live only for non-project pages',
  'designBrowser.status.pickerFailed': 'Browser element picker failed',
  'designBrowser.status.applyStyleFailed': 'Could not apply style in browser page',
  'designBrowser.status.editTextFailed': 'Could not edit text in browser page',
  'designBrowser.status.onlyProjectHtmlCanSave': 'Only project-local HTML pages can be saved',
  'designBrowser.status.htmlSaved': 'HTML changes saved',
  'designBrowser.status.htmlSaveFailed': 'HTML save failed',
  'designBrowser.status.commentSavingUnavailable': 'Comment saving is unavailable',
  'designBrowser.status.commentSaved': 'Browser comment saved',
  'designBrowser.status.commentSendingUnavailable': 'Comment sending is unavailable',
  'designBrowser.comments.aria': 'Browser comments',
  'designBrowser.comments.openFor': 'Open browser comment for {label}',
  'designBrowser.comment.dialog': 'Browser comment',
  'designBrowser.comment.elementFallback': 'Browser element',
  'designBrowser.comment.close': 'Close browser comment',
  'designBrowser.comment.noteAria': 'Browser comment note',
  'designBrowser.comment.placeholder': 'Describe the change or issue...',
  'designBrowser.comment.addNote': 'Add note',
  'designBrowser.comment.saveComment': 'Save comment',
  'designBrowser.comment.sending': 'Sending...',
  'designBrowser.comment.sendToChat': 'Send to chat',
  'designBrowser.inspect.editTitle': 'Edit HTML element',
  'designBrowser.inspect.tuneTitle': 'Tune browser element',
  'designBrowser.inspect.closeTune': 'Close browser tune',
  'designBrowser.inspect.colors': 'Colors',
  'designBrowser.inspect.text': 'Text',
  'designBrowser.inspect.fill': 'Fill',
  'designBrowser.inspect.type': 'Type',
  'designBrowser.inspect.size': 'Size',
  'designBrowser.inspect.weight': 'Weight',
  'designBrowser.inspect.spacing': 'Spacing',
  'designBrowser.inspect.pad': 'Pad',
  'designBrowser.inspect.radius': 'Radius',
  'designBrowser.inspect.content': 'Content',
  'designBrowser.inspect.elementText': 'Element text',
  'designBrowser.inspect.saving': 'Saving...',
  'designBrowser.inspect.saveHtml': 'Save HTML',
  'designBrowser.inspect.liveOnly': 'Live only',
  'designBrowser.reference.kicker': 'OpenDesign browser',
  'designBrowser.reference.title': 'Reference Board',
  'designBrowser.reference.subtitle': 'A curated set of references across inspiration, real product UI, motion, color, type, assets, and design systems. Open one to browse it live while gathering design language for the next artifact.',
  'designBrowser.reference.categoryAria': 'Reference category',
  'designBrowser.reference.searchPlaceholder': 'Search references...',
  'designBrowser.reference.searchAria': 'Search references',
  'designBrowser.reference.clearSearch': 'Clear search',
  'designBrowser.reference.noMatches': 'No references match “{query}”.',
  'designBrowser.reference.clearFilters': 'Clear filters',
  'designBrowser.reference.open': 'Open',
  'designBrowser.reference.group.inspiration': 'Inspiration',
  'designBrowser.reference.group.interfaces': 'Real Interfaces',
  'designBrowser.reference.group.motion': 'Motion',
  'designBrowser.reference.group.color': 'Color',
  'designBrowser.reference.group.type': 'Typography',
  'designBrowser.reference.group.icons': 'Icons',
  'designBrowser.reference.group.illustration': 'Illustration',
  'designBrowser.reference.group.photography': 'Photography',
  'designBrowser.reference.group.3d': '3D & Graphics',
  'designBrowser.reference.group.mockups': 'Mockups',
  'designBrowser.reference.group.systems': 'Design Systems',
  'designBrowser.reference.group.components': 'Components',
  'designBrowser.reference.group.guidelines': 'Guidelines & A11y',
  'designBrowser.reference.group.tools': 'Tools & Resources',
  'designBrowser.reference.site.dribbble.detail': 'Design shots and UI inspiration.',
  'designBrowser.reference.site.behance.detail': 'Creative portfolios and case studies.',
  'designBrowser.reference.site.awwwards.detail': 'Award-winning website design.',
  'designBrowser.reference.site.godly.detail': 'Curated modern web design.',
  'designBrowser.reference.site.land_book.detail': 'Landing page gallery and patterns.',
  'designBrowser.reference.site.mobbin.detail': 'Real app screens and UI patterns.',
  'designBrowser.reference.site.screenlane.detail': 'Latest UI design patterns from apps.',
  'designBrowser.reference.site.pageflows.detail': 'Real product user flows and onboarding.',
  'designBrowser.reference.site.uisources.detail': 'Interaction patterns from top apps.',
  'designBrowser.reference.site.collectui.detail': 'Daily UI collection by category.',
  'designBrowser.reference.site.gsap.detail': 'Production animation engine and examples.',
  'designBrowser.reference.site.animations.detail': 'Animation patterns and interaction examples.',
  'designBrowser.reference.site.transitions.detail': 'Transition patterns for modern interfaces.',
  'designBrowser.reference.site.motionsites.detail': 'High-end motion and interaction references.',
  'designBrowser.reference.site.motion.detail': 'Scroll and timeline animation inspiration.',
  'designBrowser.reference.site.animography.detail': 'Animated type and kinetic lettering.',
  'designBrowser.reference.site.reactbits.detail': 'React text animation reference for shiny kinetic type.',
  'designBrowser.reference.site.coolors.detail': 'Fast color palette generator.',
  'designBrowser.reference.site.colorhunt.detail': 'Curated color palettes.',
  'designBrowser.reference.site.realtimecolors.detail': 'Preview palettes on a real UI.',
  'designBrowser.reference.site.color_adobe.detail': 'Color wheel and harmony rules.',
  'designBrowser.reference.site.happyhues.detail': 'Palettes shown in real context.',
  'designBrowser.reference.site.fonts_google.detail': 'Open-source font library.',
  'designBrowser.reference.site.fontshare.detail': 'Quality fonts free for commercial use.',
  'designBrowser.reference.site.typewolf.detail': 'Fonts in use and pairing guidance.',
  'designBrowser.reference.site.fontpair.detail': 'Font pairing suggestions.',
  'designBrowser.reference.site.fontsinuse.detail': 'Typography in real-world design.',
  'designBrowser.reference.site.thesvg.detail': 'SVG assets and vector references.',
  'designBrowser.reference.site.svglogos.detail': 'Clean SVG logos for product and brand mocks.',
  'designBrowser.reference.site.icons_lobehub.detail': 'Product and AI-brand icons for interfaces.',
  'designBrowser.reference.site.icon_sets_iconify.detail': '200k+ open-source icons in one place.',
  'designBrowser.reference.site.lucide.detail': 'Clean, consistent open icon set.',
  'designBrowser.reference.site.heroicons.detail': 'Tailwind-made SVG icons.',
  'designBrowser.reference.site.svgrepo.detail': 'Free SVG vectors and icons.',
  'designBrowser.reference.site.storyset.detail': 'Customizable vector illustrations.',
  'designBrowser.reference.site.undraw.detail': 'Open-source MIT illustrations.',
  'designBrowser.reference.site.blush.detail': 'Mix-and-match illustrations.',
  'designBrowser.reference.site.lummi.detail': 'Free AI-generated visuals.',
  'designBrowser.reference.site.whirrls.detail': 'Hand-drawn image references.',
  'designBrowser.reference.site.worldindots.detail': 'Dot-map and data-viz references.',
  'designBrowser.reference.site.unsplash.detail': 'Free high-resolution photos.',
  'designBrowser.reference.site.pexels.detail': 'Free stock photos and video.',
  'designBrowser.reference.site.pixabay.detail': 'Royalty-free images and media.',
  'designBrowser.reference.site.cosmos.detail': 'Visual discovery and mood boards.',
  'designBrowser.reference.site.spline.detail': 'Browser-based 3D design.',
  'designBrowser.reference.site.threejs.detail': 'WebGL 3D references and demos.',
  'designBrowser.reference.site.womp.detail': 'Easy in-browser 3D creation.',
  'designBrowser.reference.site.pixcap.detail': '3D icons, mockups, and scenes.',
  'designBrowser.reference.site.shots.detail': 'Device and browser mockups.',
  'designBrowser.reference.site.mockuuups.detail': 'Drag-and-drop device mockups.',
  'designBrowser.reference.site.angle.detail': '3D device mockup library.',
  'designBrowser.reference.site.rotato.detail': 'Animated 3D product mockups.',
  'designBrowser.reference.site.impeccable.detail': 'High-quality style and interface references.',
  'designBrowser.reference.site.styles_refero.detail': 'Design style references and visual systems.',
  'designBrowser.reference.site.brandfetch.detail': 'Brand assets, logos, and identity.',
  'designBrowser.reference.site.designsystemsrepo.detail': 'Gallery of public design systems.',
  'designBrowser.reference.site.startups.detail': 'Top startup product and brand references.',
  'designBrowser.reference.site.base_ui.detail': 'Unstyled accessible primitives for custom systems.',
  'designBrowser.reference.site.ui_shadcn.detail': 'Composable React components built on Radix and Tailwind.',
  'designBrowser.reference.site.heroui.detail': 'Modern React component library and design system.',
  'designBrowser.reference.site.radix_ui.detail': 'Accessible low-level UI primitives.',
  'designBrowser.reference.site.react_spectrum_adobe.detail': 'Accessible behavior primitives from Adobe.',
  'designBrowser.reference.site.headlessui.detail': 'Unstyled accessible components for Tailwind projects.',
  'designBrowser.reference.site.mui.detail': 'Material-based React component ecosystem.',
  'designBrowser.reference.site.mantine.detail': 'Full-featured React components and hooks.',
  'designBrowser.reference.site.chakra_ui.detail': 'Accessible React components with theme tokens.',
  'designBrowser.reference.site.ant.detail': 'Enterprise component system and patterns.',
  'designBrowser.reference.site.ark_ui.detail': 'Headless components across modern frameworks.',
  'designBrowser.reference.site.daisyui.detail': 'Tailwind CSS component classes and themes.',
  'designBrowser.reference.site.developer_apple.detail': 'Apple platform design guidelines.',
  'designBrowser.reference.site.m3_material.detail': 'Google\'s Material Design 3.',
  'designBrowser.reference.site.lawsofux.detail': 'UX principles and heuristics.',
  'designBrowser.reference.site.webaim.detail': 'Color contrast checker.',
  'designBrowser.reference.site.a11yproject.detail': 'Accessibility checklist and patterns.',
  'designBrowser.reference.site.toolfolio.detail': 'Design tools, resources, and collections.',
  'designBrowser.reference.site.getdesign.detail': 'Curated design resources.',
  'designBrowser.reference.site.tasteskill.detail': 'Design taste training and critique references.',
  'designBrowser.reference.site.uigoodies.detail': 'Hand-picked design resources.',
  'designBrowser.reference.site.sidebar.detail': 'Five design links, every day.',
  'designBrowser.reference.site.github.detail': 'Reference implementation for embedded browser workflows.',
  'browserUse.category.assets': 'Asset extraction',
  'browserUse.category.tokens': 'Design language',
  'browserUse.category.motion': 'Motion',
  'browserUse.category.visual': 'Visual checks',
  'browserUse.category.structure': 'Components',
  'browserUse.category.project': 'Project run',
  'browserUse.category.general': 'General',
  'browserUse.input.none': 'No input',
  'browserUse.input.assetKind': 'kind: images | svgs | media | fonts, limit=200',
  'browserUse.input.optionalSelector': 'Optional selector',
  'browserUse.input.requirementSelector': 'Requirement, optional selector',
  'browserUse.input.selectorOptional': 'Optional selector',
  'browserUse.input.scaleOne': 'scale=1',
  'browserUse.input.selectorScaleTwo': 'Selector, scale=2',
  'browserUse.input.gridOverlay': '12 columns, max 1200, gap 24',
  'browserUse.input.bodySelector': 'selector=\'body\'',
  'browserUse.input.navigate': 'URL, domain, or search terms',
  'browserUse.input.selector': 'Selector',
  'browserUse.input.selectorText': 'Selector and text',
  'browserUse.input.scroll': 'Pixels, top, bottom, or page',
  'browserUse.input.terminalRun': 'Command, timeout 120s',
  'browserUse.input.command': 'Command',
  'browserUse.input.maxChars': 'maxChars=8000',
  'browserUse.input.custom': '{input}',
  'browserUse.action.extract_logo.output': 'Best logo candidates from header, nav, class names, position, OG image, and favicon fallback.',
  'browserUse.action.list_images.output': 'All img, srcset, source, and CSS background images with dimensions and alt text.',
  'browserUse.action.download_assets.output': 'Downloaded asset folder plus _manifest.json with referer and cookie support.',
  'browserUse.action.extract_svgs.output': 'Inline SVGs and linked .svg files saved as individual SVG files.',
  'browserUse.action.optimize_svgs.output': 'Optimized SVG files plus compression ratio.',
  'browserUse.action.extract_colors.output': 'Weighted palette plus :root CSS color variables as palette.json and palette.html.',
  'browserUse.action.extract_fonts.output': 'Top font families, sizes, weights, and @font-face rules as typography.json.',
  'browserUse.action.extract_design_tokens.output': 'Radius, shadow, spacing, and CSS variables as tokens.json.',
  'browserUse.action.extract_type_scale.output': 'Heading, body, and button type scale with size, weight, line-height, and ratios.',
  'browserUse.action.extract_buttons.output': 'Deduped button style library as buttons.html and buttons.json.',
  'browserUse.action.extract_grid_system.output': 'Grid and flex containers, direction, gaps, columns, and max widths as layout.json.',
  'browserUse.action.extract_breakpoints.output': 'Responsive media-query breakpoints as breakpoints.json.',
  'browserUse.action.extract_gradients.output': 'CSS gradients as gradients.css, gradients.json, and preview HTML.',
  'browserUse.action.extract_shadows.output': 'Box shadows, text shadows, and drop shadows as shadows.json plus preview.',
  'browserUse.action.extract_easings.output': 'Transition and animation easing functions as easings.json.',
  'browserUse.action.export_tokens.output': 'tokens.css, tokens.scss, tailwind.theme.js, and style-dictionary.tokens.json.',
  'browserUse.action.extract_animations.output': '@keyframes, transition and transform rules, detected motion libraries, motion.css, and motion.json.',
  'browserUse.action.validate_view.output': 'Screenshot paths plus structured visual and layout issues.',
  'browserUse.action.audit_layout.output': 'Layout defects including overflow, bounds, overlap, and clipped text as audit.json.',
  'browserUse.action.audit_accessibility.output': 'A11y issues with selectors, labels, roles, focus, contrast, and screenshots where useful.',
  'browserUse.action.responsive_screenshots.output': 'Mobile 390, tablet 834, and desktop 1440 screenshots.',
  'browserUse.action.screenshot_full.output': 'Full-page screenshot beyond the viewport.',
  'browserUse.action.screenshot_element.output': 'Single element screenshot at 2x by default.',
  'browserUse.action.screenshot_with_grid.output': 'Screenshot with layout grid overlay.',
  'browserUse.action.screenshot_dark_mode.output': 'Screenshot with prefers-color-scheme: dark.',
  'browserUse.action.generate_styleguide.output': 'One-page style guide with colors, type scale, radius, and shadows.',
  'browserUse.action.extract_html.output': 'Clean self-contained HTML without script, noscript, or inline event attributes.',
  'browserUse.action.extract_component_inventory.output': 'Repeated component patterns, selectors, counts, and screenshots.',
  'browserUse.action.extract_copy.output': 'Headings, CTAs, body copy, and descriptions as copy.md and copy.json.',
  'browserUse.action.extract_nav.output': 'Primary navigation and footer links as sitemap.md and nav.json.',
  'browserUse.action.extract_forms.output': 'Form fields, labels, validation hints, and submit actions as forms.json.',
  'browserUse.action.run_project.output': 'Detected dev server URL opened in the Browser tab.',
  'browserUse.action.detect_project.output': 'Framework, package manager, install command, dev command, and port.',
  'browserUse.action.page_info.output': 'URL, title, description, OG image, theme color, favicon, and viewport.',
  'browserUse.action.snapshot.output': 'Up to 120 visible interactive and text elements with tag, label, href, and coordinates.',
  'browserUse.action.navigate.output': 'Open the page and return page_info.',
  'browserUse.action.click.output': 'Click the first matching element after scrolling it into view.',
  'browserUse.action.type_text.output': 'Fill an input and dispatch input and change events.',
  'browserUse.action.scroll.output': 'Current and maximum scroll position.',
  'browserUse.action.extract_og_metadata.output': 'Meta title, description, canonical URL, OG/Twitter cards, social image, and theme color.',
  'browserUse.action.terminal_run.output': 'stdout, stderr, and exit code.',
  'browserUse.action.terminal_run_background.output': 'Background task id and recent output.',
  'browserUse.action.terminal_read.output': 'Recent shared terminal output.',
  'chat.designToolbox.title': 'Design toolbox',
  'chat.designToolbox.tooltip': 'Design toolbox',
  'chat.designToolbox.aria': 'Open design toolbox',
  'chat.designToolbox.searchPlaceholder': 'Search skills / MCP / plugins / connectors / design files...',
  'chat.designToolbox.searchAria': 'Search design toolbox resources',
  'chat.designToolbox.followupSection': 'Follow-up',
  'chat.designToolbox.resourcesSection': 'Global resources',
  'chat.designToolbox.selected': 'Selected',
  'chat.designToolbox.noResources': 'No resources found for "{query}".',
  'chat.designToolbox.badge.video': 'Video',
  'chat.designToolbox.badge.image': 'Image',
  'chat.designToolbox.badge.motion': 'Motion',
  'chat.designToolbox.badge.polish': 'Polish',
  'chat.designToolbox.action.auto-match.title': 'Match next step',
  'chat.designToolbox.action.auto-match.badge': 'Match',
  'chat.designToolbox.action.auto-match.description': 'Define the taste bar first, then match skills, MCP, plugins, connectors, and files.',
  'chat.designToolbox.action.asset-search.title': 'Find images / references',
  'chat.designToolbox.action.asset-search.badge': 'Assets',
  'chat.designToolbox.action.asset-search.description': 'Search for usable images, reference screenshots, moodboards, and source candidates for the current design.',
  'chat.designToolbox.action.icon-workflow.title': 'Find / replace icons',
  'chat.designToolbox.action.icon-workflow.badge': 'Icons',
  'chat.designToolbox.action.icon-workflow.description': 'Find, generate, or swap iconography, SVGs, Lucide icons, and visual symbols with a consistent style.',
  'chat.designToolbox.action.image-replace.title': 'Replace page images',
  'chat.designToolbox.action.image-replace.badge': 'Swap',
  'chat.designToolbox.action.image-replace.description': 'Audit current imagery and replace weak hero, section, background, or card images with better assets.',
  'chat.designToolbox.action.reference-extract.title': 'Extract visual references',
  'chat.designToolbox.action.reference-extract.badge': 'Refs',
  'chat.designToolbox.action.reference-extract.description': 'Analyze a reference screenshot or site for palette, typography, layout posture, motion, and asset direction.',
  'chat.designToolbox.action.motion.title': 'Add animation / motion',
  'chat.designToolbox.action.motion.badge': 'Motion',
  'chat.designToolbox.action.motion.description': 'Add entrance, scroll, state-transition, and micro-interaction motion to the current HTML or page element.',
  'chat.designToolbox.action.motion-polish.title': 'Polish motion',
  'chat.designToolbox.action.motion-polish.badge': 'Timing',
  'chat.designToolbox.action.motion-polish.description': 'Review timing, easing, performance, and reduced-motion fallbacks for existing motion.',
  'chat.designToolbox.action.transition-motion.title': 'Design transitions',
  'chat.designToolbox.action.transition-motion.badge': 'Transition',
  'chat.designToolbox.action.transition-motion.description': 'Design page, scene, loading, and state transitions with restrained timing and reduced-motion fallbacks.',
  'chat.designToolbox.action.threejs-scene.title': '3D / Three.js scene',
  'chat.designToolbox.action.threejs-scene.badge': '3D',
  'chat.designToolbox.action.threejs-scene.description': 'Add or plan Three.js, Spline, Vanta, particle, WebGL, map, or deck.gl-style interactive visuals.',
  'chat.designToolbox.action.anti-ai-polish.title': 'Remove AI feel',
  'chat.designToolbox.action.anti-ai-polish.badge': 'Taste',
  'chat.designToolbox.action.anti-ai-polish.description': 'Remove template feel, AI gradients, cheap card stacks, and vague copy.',
  'chat.designToolbox.action.visual-polish.title': 'Design polish / ready to ship',
  'chat.designToolbox.action.visual-polish.badge': 'Polish',
  'chat.designToolbox.action.visual-polish.description': 'Audit visual hierarchy, type, spacing, responsive behavior, accessibility, and delivery quality.',
  'chat.designToolbox.action.image-gen.title': 'Generate images / visual references',
  'chat.designToolbox.action.image-gen.badge': 'Image',
  'chat.designToolbox.action.image-gen.description': 'Generate section references, assets, icons, social images, or a moodboard for the current page.',
  'chat.designToolbox.action.chart-gen.title': 'Generate charts / diagrams',
  'chat.designToolbox.action.chart-gen.badge': 'Charts',
  'chat.designToolbox.action.chart-gen.description': 'Generate ECharts, React Flow, diagrams, dashboards, relationship maps, or data-visualization assets.',
  'chat.designToolbox.action.logo-gen.title': 'Generate logo / identity',
  'chat.designToolbox.action.logo-gen.badge': 'Logo',
  'chat.designToolbox.action.logo-gen.description': 'Create logo routes, wordmarks, lockups, marks, and identity-system prompts for the current brand.',
  'chat.designToolbox.action.plan-outline.title': "Generate PPT outline from idea",
  'chat.designToolbox.action.plan-outline.badge': "Plan",
  'chat.designToolbox.action.plan-outline.description': "Turn a rough idea into an editable Markdown deck outline before creating slides.",
  'chat.designToolbox.action.video-gen.title': 'Generate video / motion script',
  'chat.designToolbox.action.video-gen.badge': 'Video',
  'chat.designToolbox.action.video-gen.description': 'Turn the design into a short video, Remotion / Hyperframes storyboard, or generation-ready prompt.',
  'chat.designToolbox.kind.skill': 'Skill',
  'chat.designToolbox.kind.plugin': 'Plugin',
  'chat.designToolbox.kind.mcp': 'MCP',
  'chat.designToolbox.kind.mcpTemplate': 'MCP template',
  'chat.designToolbox.kind.connector': 'Connector',
  'chat.designToolbox.kind.designFile': 'Design file',
  'chat.designToolbox.context.browser': 'Browser',
  'chat.designToolbox.context.designFiles': 'Design files',
  'chat.designToolbox.context.designSystem': 'Design system',
  'chat.designToolbox.context.folder': 'Folder',
  'chat.designToolbox.context.terminal': 'Terminal',
  'chat.designToolbox.context.sideChat': 'Side chat',
  'chat.designToolbox.context.liveArtifact': 'Live artifact',
  'chat.designToolbox.context.file': 'File',
  'chat.designToolbox.prompt.contextGeneric': 'Current target: the currently open HTML / design file / web element.',
  'chat.designToolbox.prompt.contextSpecific': 'Current target: {kind} · {label}.',
  'chat.designToolbox.prompt.preserveDraft': 'Preserve the intent already in the composer: {draft}',
  'chat.designToolbox.prompt.selectedSkill': 'Selected skill: {skill}. Use it as the primary workflow for this turn.',
  'chat.designToolbox.prompt.noSkill': 'If no specific skill matched, first choose the best combination from available skills, MCP, plugins, connectors, and design files.',
  'chat.designToolbox.prompt.autoMatchIntro': 'Act as the Creative Director orchestrator and complete a design workflow:',
  'chat.designToolbox.prompt.autoMatchStep1': '1. Define what “good-looking design” means first: audience, business goal, brand feel, style references, information density, color/type/motion/asset standards, and AI/template patterns to avoid.',
  'chat.designToolbox.prompt.autoMatchStep2': '2. Search and match the full resource index above. Do not only use design toolbox recommendations; combine skills, MCP, plugins, connectors, and design files when useful.',
  'chat.designToolbox.prompt.autoMatchStep3': '3. If the target or aesthetic bar is still unclear, guide me with a structured question-form, include recommended defaults, and make each finite-choice question editable with a custom answer field. If it is clear enough, execute the next step directly.',
  'chat.designToolbox.prompt.autoMatchStep4': '4. Complete the flow in this order: diagnose -> style direction -> resource selection -> concrete edit/generation -> verification. At each step, explain why these resources were chosen and what needs confirmation next.',
  'chat.designToolbox.prompt.assetSearch': 'Find the best image/reference assets for the current design. Search available files, connectors, MCPs, browser captures, and generation tools. Return concrete candidates with usage notes, licensing/source caveats when relevant, and a fallback generation prompt if no usable asset exists.',
  'chat.designToolbox.prompt.iconWorkflow': 'Improve the icon system for the current design: find missing icons, replace weak icons, keep stroke/fill/radius/weight consistent, prefer existing icon libraries when available, and generate SVG/icon prompts only when a library icon is insufficient.',
  'chat.designToolbox.prompt.imageReplace': 'Audit every visible image slot in the current design, identify weak or placeholder imagery, then replace or specify better hero, section, background, card, and social images. Preserve layout and provide exact file/prompt/source choices.',
  'chat.designToolbox.prompt.referenceExtract': 'Use the current reference image/site/design file as visual input. Extract palette, type scale, layout rhythm, component posture, motion cues, and asset style, then apply those findings to the current design without copying protected brand assets verbatim.',
  'chat.designToolbox.prompt.motion': 'Add high-quality motion to the current HTML / page element: choose the most useful 1-2 entrance, scroll, state-transition, transition, Rive/Lottie-style icon motion, or GSAP/Motion micro-interaction moments. Keep it restrained, prefer transform / opacity, and include prefers-reduced-motion fallbacks.',
  'chat.designToolbox.prompt.planOutline': "Create or update a Markdown planning document for a PPT/deck outline from this idea. Do not generate the final deck yet. Include slide-by-slide titles, goals, content bullets, visual direction, required data/assets, and open questions. Save it as a `.md` file in Design Files and tell me which file to review.",
  'chat.designToolbox.prompt.motionPolish': 'Review and polish existing motion timing, easing, performance, and accessibility. Remove abrupt, cheap, or readability-harming animation; use a more refined timeline when needed.',
  'chat.designToolbox.prompt.transitionMotion': 'Design high-quality transitions for the current design: page/scene changes, loading bridges, state changes, and section handoffs. Use GSAP/Motion/CSS where appropriate, keep it performant, and include reduced-motion behavior.',
  'chat.designToolbox.prompt.threejsScene': 'Plan or implement a focused Three.js/WebGL visual for the current design. Consider Three.js, Spline-style scenes, Vanta backgrounds, particle systems, Mapbox/deck.gl data layers, or browser portal effects, but keep the scene useful and verify it renders.',
  'chat.designToolbox.prompt.antiAiPolish': 'Do one anti-AI-feel polish pass: remove templated layouts, cheap gradients/glows, meaningless card stacks, and vague copy. Preserve information and make it feel like a real designer delivered it.',
  'chat.designToolbox.prompt.visualPolish': 'Polish this design until it is ready to ship: check hierarchy, typography, spacing, responsive behavior, button states, empty/loading/error states, and accessibility; directly fix the most important issues.',
  'chat.designToolbox.prompt.imageGen': 'Create the next visual-asset plan for this design: section references, hero assets, illustrations, icons, social images, or a moodboard. First decide what kind of image is missing, then provide executable generation prompts / file plan.',
  'chat.designToolbox.prompt.chartGen': 'Generate the right chart, diagram, or data-visualization for the current design. Choose between ECharts, React Flow, SVG/CSS diagrams, radar charts, relationship maps, dashboards, or deck.gl/map visualizations based on the data and user goal.',
  'chat.designToolbox.prompt.logoGen': 'Create logo and identity directions for the current brand. Produce multiple routes for wordmark, symbol, lockup, palette, usage rules, and generation prompts; make sure the result is original and usable in the current artifact.',
  'chat.designToolbox.prompt.videoGen': 'Turn this design toward video: create a short-video storyboard, Hyperframes / Remotion frame structure, or Sora/fal-ready prompt. Prefer making the existing HTML / page content naturally become shots.',
  'chat.designToolbox.prompt.useSkill': 'Use {skill} on the current design.',
  'chat.designToolbox.prompt.skillInstruction': 'First decide the best follow-up goal, then complete one concrete pass. If it depends on external assets or APIs, provide a runnable fallback or state what I need to provide.',
  'chat.designToolbox.prompt.selectedResource': 'Selected resource: {kind} · {title} ({id}).',
  'chat.designToolbox.prompt.resourceDescription': 'Resource description: {description}',
  'chat.designToolbox.prompt.pluginResource': 'Use this plugin as the main context for the current design flow. If it exposes inputs or GenUI, guide me to choose when needed; if it does not fit the target, choose a better global resource and explain why.',
  'chat.designToolbox.prompt.mcpResource': 'Prefer this MCP capability for the next design step. When external assets, web capture, image/video generation, or data are needed, first decide whether it can do the job, then give an executable plan.',
  'chat.designToolbox.prompt.mcpTemplateResource': 'This MCP is a configurable template. If it is the most useful tool for this design step, guide setup first; if a configured alternative exists, continue with that alternative.',
  'chat.designToolbox.prompt.connectorResource': 'Use this connector when real data, assets, account content, or external workflow access is needed. Before using it, explain what will be read or written and ask for confirmation when appropriate.',
  'chat.designToolbox.prompt.fileResource': 'Use this design file as the current design target or reference asset and complete the next step from it. If other files need comparison, continue searching across all design files.',
  'chat.designToolbox.prompt.resourceIndex': 'Global resource index: skills({skills}), plugins({plugins}), MCP({mcpEnabled} enabled / {mcpTemplates} templates), connectors({connectors} connected), design files({files}).',
  'chat.designToolbox.prompt.searchableSkills': 'Searchable skills',
  'chat.designToolbox.prompt.searchablePlugins': 'Searchable plugins',
  'chat.designToolbox.prompt.availableMcp': 'Available MCP',
  'chat.designToolbox.prompt.connectedConnectors': 'Connected connectors',
  'chat.designToolbox.prompt.referenceDesignFiles': 'Reference design files',
  'chat.designToolbox.prompt.mcpTemplateName': '{name} template',
  'chat.designToolbox.prompt.processRule': 'Workflow rule: define the aesthetic goal and constraints first, then search and match resources; when user choice is needed, generate a structured question-form with editable custom answers and continue after confirmation.',
  'chat.designToolbox.prompt.moreSuffix': ', +{count} more',
  'chat.designToolbox.prompt.compactLine': '{label}: {values}{suffix}.',
  'chat.mentionTabsAria': 'Mention surfaces',
  'chat.mentionTabAll': 'All',
  'chat.mentionTabTabs': 'Tabs',
  'chat.mentionTabPlugins': 'Plugins',
  'chat.mentionTabSkills': 'Skills',
  'chat.mentionTabMcp': 'MCP',
  'chat.mentionTabConnectors': 'Connectors',
  'chat.mentionTabFiles': 'Design files',
  'chat.mentionNoResults': 'No results for “{query}”.',
  'chat.mentionSearchPrompt': 'Search Design Files, tabs, plugins, skills, MCP servers, and connectors.',
  'chat.mentionSectionTabs': 'Tabs',
  'chat.mentionSectionPlugins': 'Plugins',
  'chat.mentionSectionSkills': 'Skills',
  'chat.mentionSectionMcp': 'MCP',
  'chat.mentionSectionConnectors': 'Connectors',
  'chat.mentionSectionFiles': 'Design files',
  'chat.mentionActiveSkill': 'Active',
  'chat.mentionUseMcpTitle': 'Use {name}',
  'chat.mentionUseConnectorTitle': 'Use {name}',
  'chat.mentionPluginOfficial': 'Official',
  'chat.mentionPluginMine': 'My plugin',
  'chat.linkedFolderRemoveAria': 'Remove linked folder {path}',
  'chat.linkedFolderNotFound': 'Folder does not exist',
  'chat.linkedFolderAlready': 'This folder is already linked',
  'chat.linkedFolderPickError': 'Could not open folder picker',
  'chat.queuedEditQueuedTaskAria': 'Edit queued task',
  'chat.queuedSave': 'Save',
  'chat.queuedCancel': 'Cancel',
  'chat.queuedReorder': 'Drag to reorder',
  'chat.queuedEdit': 'Edit',
  'chat.queuedHeader': 'Queued',
  'chat.queuedSteer': 'Steer this turn',
  'chat.queuedSteerInterrupts': 'Steer this turn — interrupts the run in progress',
  'chat.queuedSteerUnsupported': 'This agent can’t take a message mid-turn',
  'chat.queuedSteerClosed': 'This turn already stopped reading input',
  'chat.queuedSteerFailed': 'Couldn’t steer the turn',
  'chat.queuedSteerTextOnly': 'Only text fits into a running turn — send this one with its attachments separately',
  'chat.queuedFollowUpFallback': 'Queued follow-up',
  'chat.send': 'Send',
  'chat.stop': 'Stop',
  'chat.removeAria': 'Remove {name}',
  'chat.example1Title': 'Roadshow pitch deck',
  'chat.example1Tag': 'Deck',
  'chat.example1Prompt': 'Create a 10-slide investor roadshow deck for a seed-stage design studio. Include cover, problem, insight, product, market, traction, business model, team, ask, and contact. Editorial polish, crisp charts, strong narrative, and enough restraint for an investor meeting.',
  'chat.example2Title': 'Notes app landing page',
  'chat.example2Tag': 'Landing',
  'chat.example2Prompt': 'Design a landing page for an AI notes app that captures meetings, searches highlights, and turns notes into tasks. Include hero, product preview, feature story, social proof, pricing, FAQ, and CTA. Calm productivity aesthetic with a clear conversion path.',
  'chat.example3Title': 'Meditation mobile prototype',
  'chat.example3Tag': 'Mobile',
  'chat.example3Prompt': 'Prototype four mobile screens for a meditation app: home, session player, progress and streaks, and sleep collection. Include onboarding states, bottom navigation, accessible controls, and gentle motion notes so the flow feels ready to test.',

  'home.recommendation.eyebrow': 'Recommended for you',
  'home.recommendation.primaryCta': 'Start creating',
  'home.recommendation.change': 'Try another',
  'home.recommendation.browseAll': 'All types',
  'home.recommendation.defaultProjectName': 'New project',
  'home.recommendation.startFailed': "Couldn't start creating. Please try again.",
  'studio.firstArtifactHint.title': 'Your first design is ready',
  'studio.firstArtifactHint.body': "Try editing and annotating it directly — export or share whenever you're happy.",
  'studio.firstArtifactHint.dismiss': 'Got it',
  'home.starter.product_ui_prototype.title': 'Start with an editable product prototype',
  'home.starter.product_ui_prototype.desc':
    'Based on your goal, begin with a clickable interface you can refine.',
  'home.starter.product_ui_prototype.firstPrompt':
    'Design an editable product prototype for [your product] with the key screens and a clear primary flow.',
  'home.starter.product_ui_component.title': 'Start from a reusable component',
  'home.starter.product_ui_component.desc':
    'Build one component first, then compose it into full screens.',
  'home.starter.product_ui_component.firstPrompt':
    'Design a reusable [component name] component with its main states and variants.',
  'home.starter.product_ui_lowfi.title': 'Start with a low-fidelity prototype',
  'home.starter.product_ui_lowfi.desc':
    'Sketch the structure first, then raise the fidelity.',
  'home.starter.product_ui_lowfi.firstPrompt':
    'Create a low-fidelity wireframe of the main screens for [your product].',
  'home.starter.marketing_landing.title': 'Start with a landing page',
  'home.starter.marketing_landing.desc': 'Turn your campaign into a landing page you can ship.',
  'home.starter.marketing_landing.firstPrompt':
    'Design a landing page for [your product] with a hero, key benefits, and a clear call to action.',
  'home.starter.marketing_multivariant.title': 'Start with multiple landing variants',
  'home.starter.marketing_multivariant.desc':
    'Generate a few versions to compare before you commit.',
  'home.starter.marketing_multivariant.firstPrompt':
    'Create 3 landing page variants for [your product] with different hero messaging to compare.',
  'home.starter.internal_dashboard.title': 'Start with an internal dashboard',
  'home.starter.internal_dashboard.desc': 'Begin from a dashboard layout for your workflow.',
  'home.starter.internal_dashboard.firstPrompt':
    'Design an internal dashboard showing [key metrics] with filters and a data table.',
  'home.starter.internal_report.title': 'Start with a report',
  'home.starter.internal_report.desc': 'Describe the data and fields you want to see.',
  'home.starter.internal_report.firstPrompt':
    'Create a report page summarizing [describe the data, fields, and metrics you care about].',
  'home.starter.general_menu.title': 'Start with your first project',
  'home.starter.general_menu.desc':
    "Describe what you want and we'll generate an editable first version.",
  'home.starter.general_menu.firstPrompt':
    'Create an editable first version of [describe what you want to make].',
  'chat.example4Title': 'Product motion video',
  'chat.example4Tag': 'Motion',
  'chat.example4Prompt': 'Create a 15-second motion video storyboard for a productivity app launch: opening hook, UI close-ups, kinetic type, feature transitions, ending logo, and CTA. Include timing, scene descriptions, camera moves, and text overlays.',
  'preview.usePlugin': 'Use plugin',
  'preview.usePluginOnly': 'Use without prompt',
  'preview.usePluginOnlyDesc': 'Use the plugin structure without loading the example prompt',
  'preview.replicateContent': 'Use',
  'preview.replicateContentDesc': 'Use the example prompt to recreate the preview',
  'preview.duplicateTemplate': 'Remix',
  'preview.duplicateTemplateDesc': 'Remix this example into a new editable project',
  'preview.shareMenu': 'Share',
  'preview.exportMenu': 'Export',
  'preview.shareTemplateBadge': 'Template',
  'preview.shareToX': 'X / Twitter',
  'preview.shareToReddit': 'Reddit',
  'preview.shareToFacebook': 'Facebook',
  'preview.shareToLinkedIn': 'LinkedIn',
  'preview.shareToInstagram': 'Instagram',
  'preview.shareToXiaohongshu': '小红书',
  'preview.copyTemplateLink': 'Copy template link',
  'preview.copyShareText': 'Copy share text',
  'preview.shareSocialGroup': 'Share to social',
  'preview.shareCopyGroup': 'Copy',
  'preview.shareExportGroup': 'Export files',
  'preview.shareCopied': 'Copied',
  'preview.shareCopyFailed': 'Copy failed',
  'preview.shareTextDefault': 'OpenDesign template: {title}',
  'preview.openInNewTab': 'Open in new tab',
  'preview.exit': '⤓ Exit',
  'preview.fullscreen': '⤢ Fullscreen',
  'preview.closeTitle': 'Close (Esc)',
  'preview.loading': 'Loading {label}…',
  'preview.errorTitle': 'Couldn\'t load this example.',
  'preview.errorBody': 'The example HTML failed to fetch. Make sure OpenDesign is running and try again.',
  'preview.retry': 'Retry',
  'preview.unavailableTitle': 'No shipped preview for {noun}.',
  'preview.unavailableBody': 'Run the prompt in chat to generate {kind} output.',
  'preview.nounSkill': 'this skill',
  'preview.nounPlugin': 'this plugin',
  'preview.nounTemplate': 'this template',
  'preview.showSidebar': 'Show {label}',
  'preview.hideSidebar': 'Hide {label}',
  'misc.savedTemplate': 'Saved template',
  'misc.primary': 'Primary',
  'misc.designSystem': 'Design system',
  'workspace.designFiles': 'Design Files',
  'workspace.focusMode': 'Focus workspace',
  'workspace.showChat': 'Show chat',
  'workspace.closeTab': 'Close tab',
  'workspace.fileSyncDownloading': 'Downloading from the team…',
  'workspace.fileSyncUploading': 'Syncing to the team…',
  'workspace.deleteFileConfirm': 'Delete "{name}" from the project folder?',
  'workspace.readonlyNotice': 'This is a shared project — you can view and comment, but not change artifacts through Chat or the editing tools.',
  'workspace.readonlyNoticeBy': 'This is a shared project created by {owner} — you can view and comment, but not change artifacts through Chat or the editing tools.',
  'workspace.deleteSelectedFilesConfirm': 'Delete {n} selected file(s) from the project folder?',
  'workspace.deleteSelectedFilesPartial': 'Failed to delete {n} file(s).',
  'workspace.openFromDesignFiles': 'Open a file from',
  'workspace.designFilesLink': 'Design Files',
  'workspace.loadingSketch': 'Loading sketch…',
  'workspace.newTab': 'New tab',
  'workspace.searchFilesPlaceholder': 'Search tabs or files…',
  'workspace.openTabs': 'Open tabs',
  'workspace.searchTabs': 'Search tabs',
  'workspace.noTabsFound': 'No tabs found',
  'workspace.openFile': 'Open a file',
  'workspace.noFilesMatch': 'No files match',
  'workspace.allFiles': 'All',
  'workspace.createNew': 'Create new',
  'workspace.tabOpen': 'Open',
  'workspace.sideChatContextBanner': 'Integrated context from the current conversation',
  'workspace.sideChatDefaultTitle': 'Side chat',
  'workspace.newTerminal': 'New Terminal',
  'workspace.newTerminalDescription': 'Open a shell in the project directory in a new tab',
  'workspace.newBrowser': 'New Browser',
  'workspace.newBrowserDescription': 'Open a built-in browser tab for reference sites and design research',
  'workspace.newSketchDescription': 'Sketch rough layouts and notes for the agent to use as design context',
  'workspace.terminalStarting': 'Starting terminal…',
  'workspace.terminalStartingDescription': 'Preparing the project shell. This usually takes a few seconds.',
  'workspace.terminalSessionEnded': 'Session ended',
  'workspace.terminalReconnecting': 'Reconnecting…',
  'workspace.terminalStartFailed': 'Could not start the terminal session',
  'workspace.terminalRestart': 'Restart',
  'designFiles.title': 'Design Files',
  'designFiles.upload': 'Upload files',
  'designFiles.pasteText': 'Paste as text file',
  'designFiles.newSketch': 'New sketch',
  'designFiles.newDocument': 'New document',
  'designFiles.newDocumentTitle': 'Create a new Markdown document',
  'designFiles.empty': 'Creations will appear here',
  'designFiles.buildingPreview': 'Full preview',
  'designFiles.syncing': 'Syncing files from the team…',
  'designFiles.refresh': 'Refresh',
  'designFiles.delete': 'Delete',
  'designFiles.searchPlaceholder': 'Search files…',
  'designFiles.up': 'Up',
  'designFiles.back': 'Back',
  'designFiles.crumbs': 'Project',
  'designFiles.rowMenu': 'Row menu',
  'designFiles.openInTab': 'Open in tab',
  'designFiles.download': 'Download',
  'designFiles.downloadSelected': 'Download {n} as ZIP',
  'designFiles.deleteSelected': 'Delete {n}',
  'designFiles.clearSelection': 'Clear',
  'designFiles.selectPage': 'Select all on page',
  'designFiles.selectAll': 'Select everything',
  'designFiles.dropTitle': '⤓ Drop files here',
  'designFiles.dropDesc': 'Images, docs, references, or folders — the agent will use them as context.',
  'designFiles.dropLabel': 'Drop files here',
  'designFiles.upload.title': 'Upload files',
  'designFiles.paste.title': "Paste text as a file",
  'designFiles.upload.label': 'Upload',
  'designFiles.paste.label': "Paste",
  'designFiles.documentTemplate.titleFallback': 'Document',
  'designFiles.documentTemplate.goalHeading': 'Goal',
  'designFiles.documentTemplate.goalBody': 'Describe what OpenDesign should generate, edit, or decide from this document.',
  'designFiles.documentTemplate.capabilitiesHeading': 'How to use this document',
  'designFiles.documentTemplate.capabilityMarkdown': 'Use any Markdown format: headings, tables, checklists, links, quotes, code blocks, and images.',
  'designFiles.documentTemplate.capabilityAgent': 'The OpenDesign agent can read, edit, and use this file as project context.',
  'designFiles.documentTemplate.capabilityImages': 'Paste images, or drag image files onto the editor; uploaded images are inserted at the cursor.',
  'designFiles.documentTemplate.scenarioHeading': 'Scenario guide',
  'designFiles.documentTemplate.scenario.prototype': 'For prototypes, outline the product goal, target users, flows, screens, modules, interaction states, responsive breakpoints, and design tokens such as color, type, spacing, radius, and motion.',
  'designFiles.documentTemplate.scenario.wireframe': 'For wireframes, describe the user flow, screen list, layout hierarchy, content blocks, low-fidelity constraints, and the questions the structure should answer before visual design.',
  'designFiles.documentTemplate.scenario.mobile': 'For mobile apps, list target platforms, screens, navigation model, gestures, native patterns, device sizes, states, and mobile design tokens.',
  'designFiles.documentTemplate.scenario.slideDeck': 'For slides, write a paginated PPT outline: one section per slide with title, purpose, key message, evidence, visual direction, speaker notes, and export needs.',
  'designFiles.documentTemplate.scenario.document': 'For documents, define audience, tone, section structure, source material, citations or data, layout expectations, and PDF/export requirements.',
  'designFiles.documentTemplate.scenario.image': 'For images, specify subject, aspect ratio, composition, visual style, brand tokens, reference files, and negative constraints.',
  'designFiles.documentTemplate.scenario.video': 'For video, draft a storyboard with scenes, timing, captions, motion, assets, audio notes, and output format.',
  'designFiles.documentTemplate.scenario.hyperframes': 'For HyperFrames, describe the HTML motion piece: scenes, timeline, captions, audio-reactive moments, transitions, and capture/export requirements.',
  'designFiles.documentTemplate.scenario.audio': 'For audio, define voice or music direction, duration, mood, script or copy, pacing, pronunciation notes, and final use.',
  'designFiles.documentTemplate.scenario.liveArtifact': 'For live artifacts, describe data sources, refresh cadence, widgets, filters, interactions, empty/loading/error states, and any alerts or automations.',
  'designFiles.documentTemplate.scenario.designSystem': 'For design systems, list brand goals, tokens, typography, color, spacing, components, assets, references, and rules to follow or avoid.',
  'designFiles.documentTemplate.scenario.default': 'Describe the audience, deliverable, required content, references, constraints, and what done should look like.',
  'designFiles.documentTemplate.nextHeading': 'Next step',
  'designFiles.documentTemplate.nextBody': 'Review and edit this document, then ask OpenDesign to generate, revise, or operate from it.',

  'designFiles.projectMenu': 'Project actions',
  'designFiles.createDesignSystemFromProject': 'Create design system from this project',
  'designFiles.duplicateProject': 'Duplicate project',

  'designFiles.previewOpen': 'Open',
  'designFiles.previewClose': 'Close preview',
  'designFiles.modified': 'Modified {time} · {size}',
  'designFiles.weeksAgo': '{n}w ago',
  'designFiles.groupBy': 'Group by',
  'designFiles.groupByKind': 'Kind',
  'designFiles.groupByModified': 'Modified',
  'designFiles.filterBy': 'Filter by kind',
  'designFiles.filterClear': 'Clear',
  'designFiles.filterCount': '{n} kinds',
  'designFiles.expandGroup': 'Expand',
  'designFiles.collapseGroup': 'Collapse',
  'designFiles.sectionPages': 'Pages',
  'designFiles.sectionScripts': 'Scripts',
  'designFiles.sectionImages': 'Images',
  'designFiles.sectionSketches': 'Sketches',
  'designFiles.sectionLiveArtifacts': 'Live artifacts',
  'designFiles.sectionOther': 'Other',
  'designFiles.modifiedToday': 'Today',
  'designFiles.modifiedYesterday': 'Yesterday',
  'designFiles.modifiedPrevious7Days': 'Previous 7 days',
  'designFiles.modifiedPrevious30Days': 'Previous 30 days',
  'designFiles.modifiedOlder': 'Older',
  'designFiles.showMore': 'Show +{n} more',
  'designFiles.kindHtml': 'HTML page',
  'designFiles.kindImage': 'Image',
  'designFiles.kindSketch': 'Sketch',
  'designFiles.kindText': 'Text',
  'designFiles.kindCode': 'Script',
  'designFiles.kindPdf': 'PDF',
  'designFiles.kindDocument': 'Document',
  'designFiles.kindPresentation': 'Presentation',
  'designFiles.kindSpreadsheet': 'Spreadsheet',
  'designFiles.kindLiveArtifact': 'Live artifact',
  'designFiles.kindBinary': 'Binary',
  'designFiles.kindFolder': 'Folder',
  'designFiles.folderCount': '{n} files',
  'designFiles.newFolderTitle': 'New folder',
  'designFiles.newFolderLabel': 'Folder name',
  'designFiles.moveTitle': 'Move to folder',
  'designFiles.moveLabel': 'Destination folder',
  'designFiles.moveRoot': 'Project root',
  'designFiles.moveNewFolder': 'New folder…',
  'designFiles.move': 'Move',
  'designFiles.copyPath': 'Copy path',
  'designFiles.copiedPath': 'Path copied',
  'designFiles.copyLocalPath': 'Copy local file path',
  'designFiles.copiedLocalPath': 'Local file path copied',
  'designFiles.deleteFolderConfirm': 'Delete folder "{name}" and all its contents?',
  'designFiles.folderCreated': 'Created folder "{name}"',
  'designFiles.folderDeleted': 'Deleted folder "{name}"',
  'designFiles.filesMoved': 'Moved {n} to {dest}',
  'designFiles.colName': 'Name',
  'designFiles.colKind': 'Kind',
  'designFiles.colModified': 'Modified',
  'designFiles.perPage': 'Show',
  'designFiles.all': 'All',
  'designFiles.prev': 'Previous',
  'designFiles.next': 'Next',
  'designFiles.jumpToPage': 'Go to page',
  'designFiles.pageInfo': '{start}–{end} of {total}',
  'designFiles.sectionFolders': 'Folders',
  'designFiles.sectionStylesheets': 'Stylesheets',
  'designFiles.sectionDocuments': 'Documents',
  'designFiles.kindStylesheet': 'Stylesheet',
  'designFiles.modifiedExt': 'Modified {time} · {size} · {ext}',
  'designFiles.usefulInfoLabel': 'Useful info',
  'designFiles.usefulInfoTip': 'Double-click any file to open it in a full tab.',
  'designFiles.usefulInfoTip2': 'Type @ in chat to reference a file as context.',
  'designFiles.usefulInfoTip4': 'Pick a design system to keep generated designs on-brand.',
  'designFiles.usefulInfoTip5': 'Out of ideas? Try a plugin template from Community on the Home page.',
  'designFiles.usefulInfoTip6': 'Questions or feedback? Join us on Discord.',
  'designFiles.usefulInfoTip7': 'Enjoying OpenDesign? Star us on GitHub.',
  'designFiles.usefulInfoTip8': 'Follow @OpenDesignHQ on X for the latest updates.',
  'designFiles.usefulInfoTip9': 'Drag images, docs, or whole folders into this panel — the agent uses them as context.',
  'designFiles.usefulInfoTip10': 'Click New sketch to draw a rough layout and let the agent build from it.',
  'designFiles.usefulInfoTip11': 'Select any element in the preview to comment — the agent makes targeted edits.',
  'designFiles.usefulInfoTip12': 'Not happy with a result? Circling it in the preview beats re-describing it.',
  'designFiles.usefulInfoTip13': 'Export any design as a PDF, image, or standalone HTML in one click.',
  'designFiles.usefulInfoTip14': 'Happy with a project? Save it as a template from the Share menu and reuse it anytime.',
  'designFiles.usefulInfoTip15': 'After deploying, generate social share cards in one step.',
  'designFiles.usefulInfoTip16': 'Follow @opendesign.ai on Threads for behind-the-scenes updates.',
  'designFiles.usefulInfoTip17': 'Follow @opendesign.ai on Instagram for design inspiration.',
  'designFiles.usefulInfoTip18': 'Subscribe to OpenDesign on YouTube for tutorials and demos.',
  'designFiles.usefulInfoTip19': 'Follow OpenDesign on LinkedIn for product news.',
  'designFiles.usefulInfoTip20': 'Follow OpenDesign on Xiaohongshu for tips and inspiration.',
  'quickSwitcher.placeholder': 'Open tab or file…',
  'quickSwitcher.empty': 'No files in this project',
  'quickSwitcher.noMatches': 'No matches',
  'quickSwitcher.navigate': 'navigate',
  'quickSwitcher.open': 'open',
  'quickSwitcher.close': 'close',
  'sketch.save': 'Save sketch',
  'sketch.cancel': 'Cancel',
  'sketch.saving': 'Saving…',
  'sketch.saved': 'Saved',
  'sketch.tooltipMainMenu': 'Main menu: save, export, help, and canvas settings',
  'sketch.tooltipLock': "Keep the current drawing tool active for repeated use",
  'sketch.tooltipHand': "Pan the canvas without selecting objects",
  'sketch.tooltipSelection': "Select, move, resize, or edit objects on the canvas",
  'sketch.tooltipRectangle': "Draw a rectangle or card area",
  'sketch.tooltipDiamond': "Draw a diamond for decisions or branching structure",
  'sketch.tooltipEllipse': "Draw a circle or ellipse",
  'sketch.tooltipArrow': "Draw a directional connector or flow arrow",
  'sketch.tooltipLine': "Draw a straight divider or connector line",
  'sketch.tooltipFreedraw': "Draw freehand lines on the canvas",
  'sketch.tooltipText': "Add editable text to the canvas",
  'sketch.tooltipImage': "Insert an image into the canvas",
  'sketch.tooltipEraser': "Erase objects from the canvas",
  'sketch.tooltipFrame': "Create a frame to group a region of the canvas",
  'sketch.tooltipEmbeddable': "Web Embed only supports valid https:// or http:// links",
  'sketch.tooltipLaser': "Point at canvas content temporarily without changing it",
  'sketch.tooltipMoreTools': "Open additional tools such as frame, web embed, and laser pointer",
  'sketch.tooltipDirty': 'Unsaved changes',
  'sketch.tooltipClean': 'Saved',
  'fileViewer.empty': 'Select a file to view.',
  'fileViewer.loading': 'Loading…',
  'fileViewer.exportPptx': 'Export as PPTX',
  'fileViewer.openInNewTab': 'Open in new tab',
  'fileViewer.copyPath': 'Copy path',
  'fileViewer.copied': 'Copied!',
  'fileViewer.share': 'Share',
  'fileViewer.binaryMeta': 'Binary · {size}',
  'fileViewer.binaryNote': 'Binary file ({size} bytes). Download or open from disk to inspect.',
  'fileViewer.pdfMeta': 'PDF · {size}',
  'fileViewer.documentMeta': 'Document',
  'fileViewer.presentationMeta': 'Presentation',
  'fileViewer.spreadsheetMeta': 'Spreadsheet',
  'fileViewer.previewUnavailable': 'Preview unavailable. Download or open the file to inspect.',
  'fileViewer.download': 'Download',
  'fileViewer.open': 'Open',
  'fileViewer.imageMeta': 'Image · {size}',
  'fileViewer.reactMeta': 'React component · {size}',
  'fileViewer.sketchMeta': 'Sketch · {size}',
  'fileViewer.markdownStreamingMeta': 'Streaming preview…',
  'fileViewer.markdownErrorMeta': 'Preview may be incomplete (generation error).',
  'fileViewer.markdownStreamingStatus': 'Streaming… showing partial markdown.',
  'fileViewer.markdownErrorStatus': 'Generation error. Showing last available content.',
  'fileViewer.markdownSaving': "Saving...",
  'fileViewer.markdownSaveFailed': "Save failed",
  'fileViewer.markdownSaved': "Saved",
  'fileViewer.markdownAutoSaved': "Auto-saved · {time}",
  'fileViewer.markdownAutoSaveHint': "Auto-save on",
  'fileViewer.markdownViewMode': "Markdown view mode",
  'fileViewer.split': "Split",
  'fileViewer.markdownEditor': "Markdown editor",
  'fileViewer.markdownEditorPlaceholder': "Type notes, requirements, or instructions for this document...",
  'fileViewer.markdownPreview': "Markdown preview",
  'fileViewer.videoMeta': 'Video · {size}',
  'fileViewer.audioMeta': 'Audio · {size}',
  'fileViewer.reload': 'Reload',
  'fileViewer.reloadDisk': 'Reload from disk',
  'fileViewer.copy': 'Copy',
  'fileViewer.copyTitle': 'Copy file contents',
  'fileViewer.saveDisabled': 'Save (read-only viewer)',
  'fileViewer.save': 'Save',
  'fileViewer.preview': 'Preview',
  'fileViewer.source': 'Code',
  'fileViewer.tweaks': 'Tweaks',
  'fileViewer.tweaksUnavailable': 'No tweaks panel in this artifact',
  'fileViewer.jsxModuleTitle': 'No standalone preview',
  'fileViewer.jsxModuleBody': 'This file is a component module loaded by another page.',
  'fileViewer.jsxModuleCta': 'Open the page that renders it:',
  'fileViewer.comment': 'Comment',
  'fileViewer.edit': 'Edit',
  'fileViewer.draw': 'Draw',
  'fileViewer.mark': 'Mark',
  'fileViewer.markTool': 'Mark tool',
  'fileViewer.boxSelect': 'Box select',
  'fileViewer.textTool': 'Text',
  'fileViewer.textAnnotationRemove': 'Remove text',
  'fileViewer.screenshot': 'Screenshot',
  'fileViewer.versions.entry': 'Versions',
  'fileViewer.versions.entryFull': 'Version history',
  'fileViewer.versions.title': 'Versions',
  'fileViewer.versions.countOne': '1 version',
  'fileViewer.versions.countMany': '{count} versions',
  'fileViewer.versions.current': 'Current',
  'fileViewer.versions.sourceAi': 'AI edit',
  'fileViewer.versions.sourceManual': 'Manual edit',
  'fileViewer.versions.sourceRestore': 'Restored',
  'fileViewer.versions.restoredFrom': 'Restored from v{version}',
  'fileViewer.versions.versionLabel': 'Version {version}',
  'fileViewer.versions.listAria': 'File versions',
  'fileViewer.versions.loading': 'Loading versions...',
  'fileViewer.versions.empty': 'No versions yet.',
  'fileViewer.versions.loadFailed': 'Could not load versions.',
  'fileViewer.versions.previewFailed': 'Could not load this version preview.',
  'fileViewer.versions.previewLoading': 'Loading version preview...',
  'fileViewer.versions.noPrompt': 'No prompt recorded',
  'fileViewer.versions.noPromptBody': 'No prompt was recorded for this version.',
  'fileViewer.versions.promptTitle': 'Prompt',
  'fileViewer.versions.copyPrompt': 'Copy prompt',
  'fileViewer.versions.fullscreen': 'Fullscreen preview',
  'fileViewer.versions.open': 'Open preview in a new window',
  'fileViewer.versions.currentHelp': 'This is already the current version.',
  'fileViewer.versions.restoreHelp': 'Switching restores this HTML as a new current version.',
  'fileViewer.versions.restore': 'Switch to this version',
  'fileViewer.versions.restoreConfirmTitle': 'Switch to this version?',
  'fileViewer.versions.restoreConfirmCta': 'Switch',
  'fileViewer.versions.restoring': 'Switching...',
  'fileViewer.versions.restoreFailed': 'Could not switch to this version.',
  'fileViewer.versions.restoreSuccess': 'Switched to this version.',
  'fileViewer.editScreenshotToChat': 'Screenshot to chat',
  'manualEdit.layers': 'Layers',
  'manualEdit.editableCount': '{count} editable',
  'manualEdit.hiddenBadge': 'Hidden',
  'manualEdit.title': 'Manual editor',
  'manualEdit.fallbackTitle': 'Edit',
  'manualEdit.movePanel': 'Move edit panel',
  'manualEdit.editParams': 'Edit parameters',
  'manualEdit.closePanel': 'Close edit panel',
  'manualEdit.selectLayer': 'Select a layer',
  'manualEdit.empty': 'Click an element in the preview or choose a layer.',
  'manualEdit.noEditableLayers': 'No editable layers found.',
  'manualEdit.noClass': 'no class',
  'manualEdit.tabsAria': 'Manual edit tabs',
  'manualEdit.tabContent': 'Content',
  'manualEdit.tabStyle': 'Style',
  'manualEdit.tabAttributes': 'Attributes',
  'manualEdit.tabHtml': 'Html',
  'manualEdit.tabSource': 'Source',
  'manualEdit.attributesJson': 'Attributes JSON',
  'manualEdit.selectedHtml': 'Selected element HTML',
  'manualEdit.fullSource': 'Full artifact source',
  'manualEdit.applyContent': 'Apply Content',
  'manualEdit.applyStyle': 'Apply Style',
  'manualEdit.applyAttributes': 'Apply Attributes',
  'manualEdit.applyHtml': 'Apply HTML',
  'manualEdit.applySource': 'Apply Source',
  'manualEdit.invalidAttributes': 'Invalid attributes JSON.',
  'manualEdit.changes': 'Changes',
  'manualEdit.undo': 'Undo',
  'manualEdit.redo': 'Redo',
  'manualEdit.noChanges': 'No manual edits yet.',
  'manualEdit.imageUrl': 'Image URL',
  'manualEdit.altText': 'Alt text',
  'manualEdit.label': 'Label',
  'manualEdit.text': 'Text',
  'manualEdit.href': 'Href',
  'manualEdit.textColor': 'Text color',
  'manualEdit.background': 'Background',
  'manualEdit.fontSize': 'Font size',
  'manualEdit.weight': 'Weight',
  'manualEdit.align': 'Align',
  'manualEdit.textAlignLeft': 'Align left',
  'manualEdit.textAlignCenter': 'Align center',
  'manualEdit.textAlignRight': 'Align right',
  'manualEdit.padding': 'Padding',
  'manualEdit.margin': 'Margin',
  'manualEdit.radius': 'Radius',
  'manualEdit.referenceValues': 'Reference values',
  'manualEdit.referenceValuesEmpty': 'No matching reference values',
  'manualEdit.referenceValuesLoading': 'Loading…',
  'manualEdit.lineHeight': 'Line height',
  'manualEdit.letterSpacing': 'Letter spacing',
  'manualEdit.borderStyle': 'Border style',
  'manualEdit.borderStyleSolid': 'Solid',
  'manualEdit.borderStyleDashed': 'Dashed',
  'manualEdit.borderStyleDotted': 'Dotted',
  'manualEdit.borderStyleDouble': 'Double',
  'manualEdit.borderStyleNone': 'None',
  'manualEdit.border': 'Border',
  'manualEdit.width': 'Width',
  'manualEdit.minHeight': 'Min height',
  'manualEdit.deleteElement': 'Delete element',
  'manualEdit.deleteElementConfirm': 'Delete selected element? This can be undone with Undo.',
  'manualEdit.alignCenter': "Center",
  'manualEdit.opacity': "Opacity",
  'manualEdit.uploadImage': 'Upload image',
  'manualEdit.uploadingImage': 'Uploading image…',
  'manualEdit.uploadImageFailed': 'Could not upload image.',
  'manualEdit.focusSlides': 'Focus slides',
  'manualEdit.showPanels': 'Show panels',
  'manualEdit.parameters': "Parameters",
  'manualEdit.fontFamily': "Font",
  'manualEdit.borderColor': "Border color",
  'manualEdit.borderWidth': "Border width",
  'manualEdit.height': "Height",
  'manualEdit.sideTop': "Top",
  'manualEdit.sideBottom': "Bottom",
  'manualEdit.sideLeft': "Left",
  'manualEdit.sideRight': "Right",
  'manualEdit.layoutDirection': "Direction",
  'manualEdit.distribution': "Distribution",
  'manualEdit.gap': "Gap",
  'manualEdit.layoutUnavailable': "Layout controls are available for flex or grid containers.",
  'manualEdit.directionRow': "Horizontal",
  'manualEdit.directionRowReverse': "Horizontal reverse",
  'manualEdit.directionColumn': "Vertical",
  'manualEdit.directionColumnReverse': "Vertical reverse",
  'manualEdit.justifyStart': "Start",
  'manualEdit.justifyCenter': "Center",
  'manualEdit.justifyEnd': "End",
  'manualEdit.justifyBetween': "Space between",
  'manualEdit.justifyAround': "Space around",
  'manualEdit.justifyEvenly': "Space evenly",
  'manualEdit.alignStart': "Start",
  'manualEdit.alignEnd': "End",
  'manualEdit.alignStretch': "Stretch",
  'manualEdit.alignBaseline': "Baseline",
  'fileViewer.zoomOut': 'Zoom out',
  'fileViewer.zoomIn': 'Zoom in',
  'fileViewer.resetZoom': 'Reset zoom',
  'fileViewer.viewportAria': 'Preview viewport',
  'fileViewer.viewportDesktop': 'Desktop',
  'fileViewer.viewportDesktopTitle': 'Full-width desktop preview',
  'fileViewer.viewportTablet': 'Tablet',
  'fileViewer.viewportTabletTitle': 'Tablet preview at 820 × 1180 (modern portrait baseline)',
  'fileViewer.viewportMobile': 'Mobile',
  'fileViewer.viewportMobileTitle': 'Mobile preview at 390 × 844',
  'fileViewer.reloadAria': 'Reload',
  'fileViewer.previousSlide': 'Previous slide',
  'fileViewer.nextSlide': 'Next slide',
  'fileViewer.slideNavAria': 'Slide navigation',
  'fileViewer.speakerNotes': 'Speaker notes',
  'fileViewer.speakerNotesSlide': 'Slide {current} / {total}',
  'fileViewer.speakerNotesEmpty': 'No speaker notes for this slide.',
  'fileViewer.speakerNotesEdit': 'Edit',
  'fileViewer.speakerNotesSave': 'Save notes',
  'fileViewer.speakerNotesSaving': 'Saving...',
  'fileViewer.speakerNotesSaved': 'Saved',
  'fileViewer.speakerNotesSaveFailed': 'Could not save speaker notes.',
  'fileViewer.speakerNotesPlaceholder': 'Add speaker notes for this slide...',
  'fileViewer.previewAssetBlockedTitle': 'Preview asset blocked',
  'fileViewer.previewAssetBlockedDetail': '{filePath} could not be loaded. Replace external symlinks with files inside this project.',
  'fileViewer.presenterReset': 'Reset',
  'fileViewer.present': 'Present',
  'fileViewer.presentInTab': 'In this tab',
  'fileViewer.presentFullscreen': 'Fullscreen',
  'fileViewer.presentNewTab': 'New tab',
  'fileViewer.presentFromBeginning': 'Start from beginning',
  'fileViewer.presentFromCurrentSlide': 'Start from current slide',
  'fileViewer.presenterMode': 'Presenter mode',
  'fileViewer.exitPresentation': 'Exit presentation',
  'fileViewer.shareLabel': 'Share',
  'fileViewer.shareMenuShareLink': 'SHARE',
  'fileViewer.shareMenuPublishOnline': 'SHARE ON YOUR OWN HOSTING',
  'fileViewer.shareMenuDownload': 'DOWNLOAD',
  'fileViewer.shareMenuPresentation': 'Presentation',
  'fileViewer.shareMenuSourceFiles': 'Source files',
  'fileViewer.shareMenuSave': 'SAVE',
  'fileViewer.shareMenuPublishViaOd': 'QUICK SHARE · OPENDESIGN',
  'fileViewer.unifiedShareAria': 'Share and export actions',
  'fileViewer.unifiedShareTab': 'Share',
  'fileViewer.unifiedExportTab': 'Export',
  'fileViewer.unifiedSendTab': 'Send to...',
  'fileViewer.openFileForHistory': 'Open a file to view version history',
  'fileViewer.workspaceShareTitle': 'Share project in workspace',
  'fileViewer.workspaceSharePrivateDescription': 'Only you can access this project. Choose workspace members to share it with the team.',
  'fileViewer.workspaceShareWorkspaceDescription': 'Members of this workspace can access this project.',
  'fileViewer.workspaceAccessPrivate': 'Only me',
  'fileViewer.workspaceAccessMembers': 'Workspace members',
  'fileViewer.publishSingleFileTitle': 'Get a share link',
  'fileViewer.publishSingleFileDescription': 'Anyone with the link can view it online. Only a single file can be shared for now — embedded local assets such as images aren\'t supported yet.',
  'fileViewer.openFileRequired': 'Open a file to use this.',
  'fileViewer.publishFile': 'Publish file',
  'fileViewer.publishingFile': 'Creating link…',
  'fileViewer.unpublishFile': 'Stop sharing',
  'fileViewer.shareEmptyStateTitle': 'Nothing to share yet',
  'fileViewer.shareEmptyStateDescription': 'Create or join a team to share this file with teammates',
  'fileViewer.shareEmptyStateCreateTeam': 'Create team',
  'fileViewer.shareTeamMissingTitle': 'No team to share with yet',

  'fileViewer.publishFileRequiresTeam': 'Publishing a public link needs a team workspace. Switch to a team workspace, or use Deploy to publish this file.',
  'fileViewer.publishFileRequiresWorkspace': 'A share link needs a signed-in workspace. Sign in to OpenDesign Cloud, or use a deploy option to share this file.',
  'fileViewer.publishFileFailed': 'Could not create the share link. Try again, or use a deploy option below.',
  'fileViewer.workspaceShareSuccess': 'Shared with workspace members',
  'fileViewer.workspaceShareFailed': 'Could not share with workspace',
  'fileViewer.workspaceUnshareSuccess': 'Moved back to private',
  'fileViewer.workspaceUnshareFailed': 'Could not move back to private',
  'fileViewer.readonlySharedNoExport': 'Shared project is read-only: you can comment, but cannot edit or export.',
  'fileViewer.copyShareLink': 'Copy share link',
  'fileViewer.openSharePage': 'Open share page',
  'fileViewer.shareLinkRequiresDeploy': 'Publish online first to get a link',
  'fileViewer.shareLinkPublishGuide': 'Publish online above to enable share ↑',
  'fileViewer.shareAfterGenerationComplete': 'Share after generation completes',
  'fileViewer.copyProviderLink': 'Copy {provider} link',
  'fileViewer.copyCloudflareLink': 'Copy Cloudflare link',
  'fileViewer.screenshotCopying': 'Copying screenshot...',
  'fileViewer.screenshotCopied': 'Screenshot copied to clipboard',
  'fileViewer.screenshotClipboardDenied': 'Browser blocked clipboard access',
  'fileViewer.screenshotPreviewLoading': 'Preview is still loading. Try again in a moment.',
  'fileViewer.screenshotCaptureFailed': 'Could not capture the preview. Please try again.',
  'fileViewer.exportPdf': 'Export as PDF',
  'fileViewer.exportPdfAllSlides': 'Export as PDF (all slides)',
  'fileViewer.exportPptxBusy': 'Wait for the current turn to finish.',
  'fileViewer.exportPptxHint': 'Send a request to the agent to convert this design to PPTX.',
  'fileViewer.exportPptxNa': 'PPTX export is not available here.',
  'fileViewer.exportDaemonUnreachable': 'Could not reach the daemon. Please try again.',
  'fileViewer.exportZip': 'Download as .zip',
  'fileViewer.exportHtml': 'Export as standalone HTML',
  'fileViewer.exportMd': 'Export as Markdown',
  'fileViewer.exportImage': 'Export as image',
  'fileViewer.exportPptxImages': 'Export as PPTX (images)',
  'fileViewer.exportPptxEditable': 'Export as PPTX (editable)',
  'fileViewer.exportPptxEditableHint': 'Native editable shapes & text (not pixel-perfect)',
  'fileViewer.exportPptxModalSubtitle': "Choose how to export, then download.",
  'fileViewer.exportPptxScreenshot': "Screenshot PPTX",
  'fileViewer.exportPptxScreenshotHint': "One image per slide — pixel-perfect, but not editable.",
  'fileViewer.exportPptxConfirm': "Export",
  'fileViewer.exportPptxRecommended': "Recommended",
  'fileViewer.exportingProgress': 'Exporting…',
  'fileViewer.exportSlideProgress': 'Exporting slide {current}/{total}…',
  'fileViewer.exportingElapsed': 'Exporting… {seconds}s',
  'fileViewer.exportSlideEta': 'Exporting slide {current}/{total} · ~{seconds}s left',
  'fileViewer.exportFailedTitle': 'Export failed',
  'fileViewer.exportFailedDescription': 'This export did not complete. Please try again.',
  'fileViewer.exportDone': 'Export complete',
  'fileViewer.exportImageFailed': 'Image capture failed. Please try again or use your browser\'s screenshot tool.',
  'fileViewer.exportImageModalSubtitle': 'Choose a format, then download the current preview as an image.',
  'fileViewer.exportImageFormatLabel': 'Format',
  'fileViewer.exportImageSaving': 'Saving image…',
  'fileViewer.exportImageSaved': 'Image saved',
  'fileViewer.exportImageDownloadStarted': 'Download started',
  'fileViewer.exportImageDownloadDetails': '{filename} is in your browser downloads if no Save As dialog appeared.',
  'fileViewer.exportJsx': 'Export as JSX',
  'fileViewer.exportReactHtml': 'Export preview as HTML',
  'fileViewer.exportStarted': 'Export started',
  'fileViewer.saveAsTemplate': 'Save as template…',
  'fileViewer.savingTemplate': 'Saving template…',
  'fileViewer.savedTemplate': 'Saved as "{name}"',
  'fileViewer.savedTemplateFail': 'Could not save template — try again.',
  'fileViewer.templateNamePrompt': 'Template name',
  'fileViewer.templateNameDefault': 'Untitled template',
  'fileViewer.templateDescPrompt': 'Short description (optional — what makes this template useful?)',
  'liveArtifact.refresh.button': 'Refresh',
  'liveArtifact.refresh.buttonTitle': 'Refresh this live artifact',
  'liveArtifact.refresh.loadingTitle': 'Loading live artifact…',
  'liveArtifact.refresh.noSourceTitle': 'No refresh source is available yet.',
  'liveArtifact.refresh.running': 'Refreshing…',
  'liveArtifact.refresh.runningMessage': 'Refreshing data and preview. This can take a moment.',
  'liveArtifact.refresh.runningAction': 'The previous preview stays visible until the refresh succeeds.',
  'liveArtifact.refresh.successOne': 'Refresh complete. Data updated.',
  'liveArtifact.refresh.successMany': 'Refresh complete. Data updated.',
  'liveArtifact.refresh.successAction': 'The preview has been reloaded with the latest committed data.',
  'liveArtifact.refresh.previousFailure': 'Previous refresh failed: {message}',
  'liveArtifact.refresh.failureAction': 'Review Refresh history, fix the source or permission issue, then try again.',
  'liveArtifact.refresh.networkFailure': 'Refresh request failed. Check your connection and try again.',
  'liveArtifact.refresh.genericFailure': 'Refresh failed.',
  'liveArtifact.refresh.statusNever': 'Not refreshable',
  'liveArtifact.refresh.statusReady': 'Ready to refresh',
  'liveArtifact.refresh.statusSucceeded': 'Up to date',
  'liveArtifact.refresh.statusFailed': 'Refresh failed',
  'liveArtifact.refresh.statusRunning': 'Refreshing',
  'liveArtifact.refresh.statusRunningDescription': 'A refresh run is currently in progress.',
  'liveArtifact.refresh.statusSucceededDescription': 'The last refresh finished successfully.',
  'liveArtifact.refresh.statusFailedDescription': 'The last refresh attempt did not complete successfully.',
  'liveArtifact.refresh.statusReadyDescription': 'Refreshable sources are configured but no run is in progress.',
  'liveArtifact.refresh.statusNeverDescription': 'This live artifact has no refresh source yet.',
  'liveArtifact.refresh.eventStarted': 'Started',
  'liveArtifact.refresh.eventSucceeded': 'Succeeded',
  'liveArtifact.refresh.eventFailed': 'Failed',
  'liveArtifact.refresh.eventStartedDetail': 'Refresh started…',
  'liveArtifact.refresh.sourcesUpdatedOne': '{n} source updated',
  'liveArtifact.refresh.sourcesUpdatedMany': '{n} sources updated',
  'liveArtifact.refresh.timelineEmpty': 'No refresh activity yet in this session. Trigger Refresh to record a timeline, or wait for automated runs.',
  'liveArtifact.refresh.heroLastRefreshedLabel': 'Last refreshed',
  'liveArtifact.refresh.heroLastRefreshedNever': 'Never',
  'liveArtifact.refresh.justNow': 'just now',
  'liveArtifact.refresh.factCreated': 'Created',
  'liveArtifact.refresh.factLastUpdated': 'Last updated',
  'liveArtifact.refresh.factUnknown': 'Unknown',
  'liveArtifact.refresh.persistedTitle': 'Persisted refresh history',
  'liveArtifact.refresh.persistedHint': 'Entries loaded from refreshes.jsonl',
  'liveArtifact.refresh.persistedEmpty': 'No persisted refresh history yet.',
  'liveArtifact.refresh.persistedStatusSucceeded': 'succeeded',
  'liveArtifact.refresh.persistedStatusRunning': 'running',
  'liveArtifact.refresh.persistedStatusFailed': 'failed',
  'liveArtifact.refresh.persistedStatusCancelled': 'cancelled',
  'liveArtifact.refresh.persistedStatusSkipped': 'skipped',
  'liveArtifact.refresh.sessionTitle': 'Session activity',
  'liveArtifact.refresh.sessionHint': 'Events observed while this tab is open',
  'liveArtifact.refresh.docSourceTitle': 'Document source',
  'liveArtifact.refresh.docSourceHint': 'Source configured',
  'liveArtifact.refresh.docSourceType': 'Type',
  'liveArtifact.refresh.docSourceTool': 'Tool',
  'liveArtifact.refresh.docSourceConnector': 'Connector',
  'liveArtifact.refresh.debugSummary': 'Advanced debug metadata',
  'liveArtifact.refresh.debugNote': 'May include connector IDs, file names, source metadata, and internal artifact paths.',
  'liveArtifact.viewer.tabPreview': 'Preview',
  'liveArtifact.viewer.tabCode': 'Code',
  'liveArtifact.viewer.tabData': 'Data',
  'liveArtifact.viewer.tabRefreshHistory': 'Refresh history',
  'liveArtifact.viewer.dataEmpty': 'No data.json cache available.',
  'liveArtifact.viewer.code.templateHeading': 'Template HTML',
  'liveArtifact.viewer.code.renderedHeading': 'Rendered HTML',
  'liveArtifact.viewer.code.templateHelp': 'The editable template used with data.json to generate the preview.',
  'liveArtifact.viewer.code.renderedHelp': 'The generated index.html currently loaded by Preview.',
  'liveArtifact.viewer.code.variantAria': 'Code variant',
  'liveArtifact.viewer.code.variantTemplate': 'Template',
  'liveArtifact.viewer.code.variantRendered': 'Rendered',
  'liveArtifact.viewer.code.loading': 'Loading code…',
  'liveArtifact.viewer.code.unavailable': 'Code is not available yet.',
  'liveArtifact.viewer.code.empty': 'This code file is empty.',
  'fileViewer.deployToVercel': 'Deploy to Vercel',
  'fileViewer.redeployToVercel': 'Redeploy',
  'fileViewer.deployingToVercel': 'Deploying to Vercel…',
  'fileViewer.deployProviderLabel': 'Provider',
  'fileViewer.vercelProvider': 'Vercel',
  'fileViewer.cloudflarePagesProvider': 'Cloudflare Pages',
  'fileViewer.deployTargetLabel': 'Target',
  'fileViewer.deployTargetPreview': 'Preview',
  'fileViewer.deployTargetProduction': 'Production',
  'fileViewer.deployToProvider': 'Deploy to {provider}',
  'fileViewer.redeployToProvider': 'Redeploy to {provider}',
  'fileViewer.deployingToProvider': 'Deploying to {provider}…',
  'fileViewer.preparingPublicLink': 'Preparing public link…',
  'fileViewer.copyDeployLink': 'Copy link',
  'fileViewer.deployModalTitle': 'Deploy',
  'fileViewer.deployModalSubtitle': 'Use the selected provider account to deploy this HTML preview.',
  'fileViewer.vercelToken': 'Vercel token',
  'fileViewer.vercelTokenGetLink': 'Get Vercel token',
  'fileViewer.vercelTokenPlaceholder': 'Paste your Vercel token',
  'fileViewer.vercelTokenReuseHint': 'Saved token will be used. Enter a new token to replace it.',
  'fileViewer.vercelTokenRequired': 'Enter and save a Vercel token first.',
  'fileViewer.cloudflareApiToken': 'Cloudflare API token',
  'fileViewer.cloudflareApiTokenGetLink': 'Get API token',
  'fileViewer.cloudflareApiTokenPlaceholder': 'Paste your Cloudflare API token',
  'fileViewer.cloudflareApiTokenReuseHint': 'The saved Cloudflare API token will be used. Enter a new token to replace it.',
  'fileViewer.cloudflareApiTokenRequired': 'Enter and save a Cloudflare API token first.',
  'fileViewer.cloudflareApiTokenScopeHint': 'Select Pages Edit when creating the API token; custom domains need Zone Read / DNS Edit.',
  'fileViewer.vercelTeamId': 'Team ID',
  'fileViewer.vercelTeamSlug': 'Team slug',
  'fileViewer.cloudflareAccountId': 'Account ID',
  'fileViewer.cloudflareAccountIdHint': 'Find the account ID in the Cloudflare dashboard.',
  'fileViewer.cloudflareAccountIdRequired': 'Enter and save a Cloudflare Account ID first.',
  'fileViewer.cloudflareZoneLabel': 'Domain',
  'fileViewer.cloudflareZonePlaceholder': 'Save Cloudflare settings to load domains',
  'fileViewer.cloudflareZoneRequired': 'Select a Cloudflare domain first.',
  'fileViewer.cloudflareZonesLoading': 'Loading Cloudflare domains…',
  'fileViewer.cloudflareZonesRefresh': 'Refresh domains',
  'fileViewer.cloudflareZonesLoadFailed': 'Could not load Cloudflare domains.',
  'fileViewer.cloudflareZonesEmpty': 'No active full Cloudflare domains were found for this account.',
  'fileViewer.cloudflareDomainPrefixLabel': 'Subdomain prefix',
  'fileViewer.cloudflareDomainPrefixPlaceholder': 'demo',
  'fileViewer.cloudflareDomainPrefixInvalid': 'Use one DNS label only: lowercase letters, numbers, and hyphens.',
  'fileViewer.cloudflareHostnamePreview': 'Custom domain preview: {hostname}',
  'fileViewer.cloudflareCustomDomainHint': 'Optional: bind a custom domain. Leaving this blank still creates a pages.dev link.',
  'fileViewer.cloudflarePagesDevLinkLabel': 'pages.dev URL',
  'fileViewer.cloudflareCustomDomainLinkLabel': 'Custom domain',
  'fileViewer.optional': 'Optional',
  'fileViewer.vercelPreviewOnly': 'Deploys are Preview-only for now.',
  'fileViewer.cloudflarePagesPreviewHint': 'Cloudflare Pages deploys use Direct Upload.',
  'fileViewer.savingConfig': 'Saving…',
  'fileViewer.deployConfigSaveFailed': 'Could not save Vercel settings.',
  'fileViewer.deployFailed': 'Deploy failed. Check Vercel settings and try again.',
  'fileViewer.deployProviderConfigSaveFailed': 'Could not save {provider} settings.',
  'fileViewer.deployProviderFailed': '{provider} deploy failed. Check settings and try again.',
  'fileViewer.deployResultLabel': 'Deployed URL',
  'fileViewer.deployLinkReady': 'Ready',
  'fileViewer.deploySuccessToast': 'Deployment uploaded successfully',
  'fileViewer.deploySuccessToastDetails': '{provider} · {url}',
  'fileViewer.deployLinkPreparingLabel': 'Public link pending',
  'fileViewer.deployLinkDelayed': 'Your site is deployed. The public link is still being prepared.',
  'fileViewer.deployLinkFailed': 'Custom domain failed',
  'fileViewer.deployLinkProtectedLabel': 'Deployment protection enabled',
  'fileViewer.deployLinkProtected': 'Your site deployed, but this preview link is requiring authentication. Disable Deployment Protection or use a custom domain.',
  'fileViewer.retryLink': 'Retry now',
  'questionForm.submit': 'Submit',
  'questionForm.skip': 'Skip',
  'questionForm.locked': 'Answered',
  'tool.openInTab': 'Open {name} in a tab',
  'tool.open': 'open',
  'tool.todos': 'Todos',
  'tool.todosExpand': 'Show tasks',
  'tool.todosCollapse': 'Hide tasks',
  'tool.todosDone': 'Done',
  'tool.todosDismiss': 'Dismiss the task list',
  'tool.write': 'Write',
  'tool.edit': 'Edit',
  'tool.read': 'Read',
  'tool.delete': 'Delete',
  'tool.bash': 'Bash',
  'tool.glob': 'Glob',
  'tool.grep': 'Grep',
  'tool.fetch': 'Fetch',
  'tool.search': 'Search',
  'tool.lines': '{n} lines',
  'tool.changeSingular': 'change',
  'tool.changePlural': 'changes',
  'tool.in': 'in {path}',
  'tool.hide': 'hide',
  'tool.output': 'output',
  'tool.running': 'running…',
  'tool.error': 'error',
  'tool.done': 'done',
  'assistant.role': 'Assistant',
  'assistant.workingLabel': 'Working',
  'assistant.doneLabel': 'Done',
  'assistant.awaitingReplyLabel': 'Awaiting your reply',
  'assistant.canceledLabel': 'Task stopped',
  'assistant.canceledDetail': 'This run was stopped at your request.',
  'assistant.copyMarkdown': 'Copy',
  'assistant.forkConversation': 'New conversation',
  'assistant.forkingConversation': 'Starting new conversation…',
  'assistant.forkNote': 'Continued from chat',
  'assistant.shareToOpenDesign': 'Share to OpenDesign',
  'assistant.shareToOpenDesignBusy': 'Preparing package…',
  'assistant.feedbackPrompt': 'Feedback',
  'assistant.feedbackPositive': 'Helpful',
  'assistant.feedbackNegative': 'Not helpful',
  'assistant.feedbackReasonTitle': 'Tell us why',
  "assistant.feedbackReasonTitleNegative": "What went wrong?",
  "assistant.feedbackDiscordNegative": "Share more context in {discord} so the team can understand what went wrong and follow up directly.",
  "assistant.feedbackDiscordPositive": "Share what you made with the {discord} community, or drop a screenshot and tell us what worked well.",
  'assistant.feedbackReasonPositiveMatched': 'Understood my request',
  'assistant.feedbackReasonPositiveVisual': 'Looks good',
  'assistant.feedbackReasonPositiveUseful': 'Useful structure',
  'assistant.feedbackReasonPositiveEasy': 'Easy to keep editing',
  'assistant.feedbackReasonPositiveDesignSystem': 'Followed the design system',
  'assistant.feedbackReasonNegativeMissed': 'Did not follow my request',
  'assistant.feedbackReasonNegativeVisual': 'Visual inconsistency',
  'assistant.feedbackReasonNegativeIncomplete': 'Incomplete output',
  'assistant.feedbackReasonNegativeHard': 'Hard to use',
  'assistant.feedbackReasonNegativeCouldNotRun': 'Could not run',
  'assistant.feedbackReasonNegativeTooSlow': 'Too slow',
  'assistant.feedbackReasonNegativeDesignSystem': 'Did not follow the design system',
  'assistant.feedbackReasonOther': 'Other',
  'assistant.feedbackReasonPlaceholder': 'Add something (optional)',
  'assistant.feedbackReasonSubmit': 'Submit',
  "assistant.emptyResponseLabel": "The task could not be completed",
  "assistant.emptyResponseMessage": "This task failed to run. Please retry. If it fails again, please contact support.",
  'assistant.unfinishedLabel': 'Task not finished yet',
  'assistant.unfinishedDetail': 'This task still has {n} unfinished item(s).',
  'assistant.unfinishedSummary': '{n} task(s) remain',
  'assistant.unfinishedMore': '+{n} more',
  'assistant.continueRemaining': 'Continue remaining tasks',
  'chat.resumeRunCta': 'Continue the run',
  'chat.runError.contactSupportCta': "Contact us",
  'chat.runError.exportLogsCta': "Export logs",
  'chat.runError.switchModelCta': "Switch model",
  'chat.runError.openSettingsCta': 'Open settings',
  "chat.runError.title.readOnlyAccess": "No project editing permission",
  "chat.runError.title.messagesUnavailable": "Conversation content failed to load",
  "chat.runError.actionBlocked.readOnly": "You currently have view-only access to this project, so you can't run tasks.",
  "chat.runError.actionBlocked.messagesUnavailable": "We can't read this conversation right now. Please try again. If it fails again, contact support.",
  'chat.runError.actionBlocked.billing': "Still resolving which workspace pays for this project. Try again in a moment.",
  'chat.runError.actionBlocked.busy': "This conversation still has a run in progress. Retry becomes available once it ends.",
  'chat.support.channel.feishu': "Feishu community",
  'chat.support.channel.discord': "Discord",
  'chat.amrBalanceOwner.title': 'Insufficient team allowance',
  'chat.amrBalanceOwner.message': 'Your team’s allowance is insufficient. Ask your team admin to top up or upgrade the subscription.',
  'chat.amrBalanceOwner.messageNoOwnerName': 'Your team’s allowance is insufficient. Ask your team admin to top up or upgrade the subscription.',
  'chat.amrBalanceOwner.dismissCta': "Got it",
  'assistant.outTokens': '{n} out',
  'assistant.producedFiles': 'Files from this turn',
  'assistant.openFile': 'Open',
  'assistant.downloadFile': 'Download',
  "nextStep.imageContinue": "Continue refining",
  "nextStep.imageVariants": "Generate variations / another batch",
  "nextStep.imageStyle": "Adjust style / composition",
  'nextStep.title': 'Next step',
  'nextStep.suggestionsLabel': 'Suggested next steps',
  'nextStep.more': 'More',
  'nextStep.share': 'Share',
  'nextStep.download': 'Download',
  'nextStep.createDesignSystemTitle': 'Create design system',
  'nextStep.createDesignSystemBody': 'Duplicate this project into a design-system workspace and start an agent pass from all current files and references.',
  'nextStep.createDesignSystemBusy': 'Creating design system...',
  'nextStep.contribute': 'Contribute',
  'nextStep.planGenerateTitle': "Generate artifact",
  'nextStep.planGenerateBody': "Use the approved Markdown plan as the source of truth for the next design run.",
  'nextStep.planImproveTitle': "Improve document",
  'nextStep.planImproveBody': "Tighten the current plan document before generating the final artifact.",
  'nextStep.planGeneratePrompt': "Use `{file}` as the source of truth. Read the document first, preserve its decisions, then generate the final design artifact that matches it. If it is a slide outline, generate the deck; if it is a PRD/prototype plan, generate the prototype or wireframes; if it is a storyboard/creative brief, generate the matching visual/media artifact. Before generating, call out any blocking TODOs or contradictions you cannot resolve.",
  'nextStep.planImprovePrompt': "Read `{file}` and improve it in place as an editable plan document. Tighten scope, fill weak sections, add missing acceptance checks, and keep TODO/open questions where user input is still needed. Do not generate the final design artifact yet.",
  'nextStep.planImproveArtifactTitle': "Improve artifact",
  'nextStep.planImproveArtifactBody': "Keep iterating the generated artifact instead of going back to planning.",
  'nextStep.planImproveArtifactPrompt': "Improve `{artifact}` in place. Keep the existing working artifact and make the highest-impact product, visual, interaction, and content improvements. Preserve behavior that already works, then summarize changed files and any remaining risks.",
  'nextStep.planMergeTitle': "Align document and artifact",
  'nextStep.planMergeBody': "Reconcile the plan and generated artifact so they advance together.",
  'nextStep.planMergePrompt': "Read `{document}` and `{artifact}` together. Treat the document as the intent and the artifact as the current implementation. Reconcile them: update the artifact to match confirmed decisions, update the document only where it is stale, and keep explicit TODO/open questions for anything still unresolved. Preserve existing working behavior and summarize what changed in both files.",

  'nextStep.projectContinueTitle': 'Continue working',
  'nextStep.projectGenerateArtifactTitle': 'Generate artifact',
  'nextStep.designSystemAiRefineTitle': 'AI refine design system',
  'nextStep.designSystemAuditKitTitle': 'Audit tokens & kit',

  'nextStep.brandAiOptimizeTitle': 'Refine extracted design system',
  'nextStep.brandAiOptimizeBody': 'Starts an agent pass that consumes model tokens, re-extracts the source, and updates this design system in place.',
  'nextStep.brandCreateDesignTitle': 'Create with this design system',
  'nextStep.brandCreateDesignBody': 'Start a new design using the extracted colors, type, assets, and system guidance.',
  'nextStep.brandCreateDesignPrompt': 'Create a new design with the {designSystem} design system.',

  'nextStep.brandContinueExtractionTitle': 'Continue extraction',
  'nextStep.brandContinueExtractionBody': 'After the Browser tab is past any verification, read it and keep filling the saved kit.',
  'nextStep.brandContinueExtractionBusy': 'Continuing extraction...',
  'nextStep.brandContinueAiExtractionTitle': 'Continue with agent',
  'nextStep.brandContinueAiExtractionProgrammaticBody': 'Use the selected agent to extract from the saved draft if the programmatic pass still cannot finish.',
  'nextStep.brandContinueAiExtractionAiBody': 'Resume the selected agent from the current brand scaffold and finish the same design system.',
  'nextStep.brandContinueAiExtractionBusy': 'Continuing with agent...',
  'nextStep.createDesignBusy': 'Creating design...',
  'assistant.thinking': 'Thinking',
  'assistant.thought': 'Thought',
  'assistant.thoughtFor': 'Thought for {s}s',
  'assistant.designSystemDirectionLocked': 'Active design system selected. Visual direction is already locked.',
  'assistant.waitingFirstOutput': 'Waiting for first output',
  'assistant.statusBootingAgent': 'Booting agent',
  'assistant.statusPreparing': 'Preparing...',
  'assistant.statusStarting': 'Starting',
  'assistant.statusRequesting': 'Sending request',
  'assistant.statusThinking': 'Thinking',
  'assistant.statusStreaming': 'Streaming',
  'assistant.statusCompactingContext': 'Compacting context',
  'assistant.slowHint': 'Taking longer than usual. The form usually shows in 5–10s — you can Stop and rephrase.',
  'assistant.verbEditing': 'Editing',
  'assistant.verbWriting': 'Writing',
  'assistant.verbReading': 'Reading',
  'assistant.verbSearching': 'Searching',
  'assistant.verbRunning': 'Running',
  'assistant.verbTodos': 'Todos',
  'assistant.verbFetching': 'Fetching',
  'assistant.verbCalling': 'Calling',
  'qf.answered': 'answered',
  "qf.unanswered": "Unanswered",
  "qf.unansweredContinued": "This question was not answered. The conversation has continued.",
  'qf.answeredConfirmed': 'Confirmed',
  'qf.answeredSkipped': 'Skipped',
  "chat.att.cancelUpload": "Cancel upload of {name}",
  "chat.att.retry": "Retry",
  "chat.attachments.scrollNext": "Show next attachments",
  "chat.attachments.scrollPrev": "Show previous attachments",
  "chat.input.collapse": "Collapse",
  "chat.input.expandFull": "Show full message",
  "chat.input.viewAll": "View all",
  "chat.artifact.export": "Export",
  "chat.artifact.pending": "Generating…",
  "chat.artifact.publish": "Share",
  "chat.edge.paused": "Task paused manually",
  "chat.edge.reconnectCta": "Reconnect",
  "chat.edge.reconnectDetail": "View details",
  "chat.edge.reconnectFailed": "Network connection not restored",
  "chat.edge.reconnectFailedDescription": "Please check your network connection and try again.",
  "chat.edge.reconnecting": "Restoring network connection",
  "chat.edge.reconnectingDescription": "Connection attempt {attempt}/{max} is in progress. Please wait.",
  "chat.edge.retrying": "Retrying",
  "chat.edge.retryingRateLimitedTitle": "Model service is busy",
  "chat.edge.retryingRateLimitedDescription": "There are a lot of requests to this model service right now and the provider's rate limit has been reached. Try again later, or switch to another model.",
  "qf.visualNext": "Next style",
  "qf.visualPrev": "Previous style",
  "qf.visualRandom": "Random",
  "qf.visualReshuffle": "Shuffle",
  "qf.visualViewFan": "Stack back up",
  "qf.visualViewGrid": "Show as grid",
  "qf.confirmed": "Confirmed",
  "qf.picked": "{count} picked",
  "qf.moreOptions": "More options",
  "qf.colorPresets": "Preset colors",
  "qf.colorCustom": "Custom color",
  "qf.colorPickerLabel": "Open the color picker",
  "qf.colorHexLabel": "Hex color value",
  "qf.colorPreview": "Preview: this is how the accent color looks in the interface.",
  "qf.colorInvalid": "Enter a 6-digit hex color, for example #3b82f6",
  'qf.choose': 'Choose…',
  'qf.customLabel': 'Custom answer',
  'qf.customPlaceholder': 'Type your own answer...',
  'qf.otherOption': 'Other',
  'qf.ownAnswer': 'Write your own',
  'qf.required': 'required',
  'qf.lockedSubmitted': 'Answers sent — agent is using these for the rest of the session.',
  'qf.lockedPrev': 'This form is from a previous turn.',
  'qf.hint': 'Pick what fits. Skip optional fields you don\'t care about — the agent will use sensible defaults.',
  'qf.submitDefault': "Next",
  'qf.submitDisabledTitle': 'Fill in the required fields first',
  'qf.submitTitle': "Next",
  'questions.tabLabel': 'Questions',
  'questions.banner': 'Mind if I ask a couple of quick questions?',
  'questions.bannerAnswered': 'Questions answered',
  'questions.strategyBlockedNotice': "This task was stopped by the strategy quality gate, so this form can no longer be submitted. Start a new request to continue.",
  'questions.continue': 'Continue',
  'questions.generating': 'Generating questions…',
  'questions.skipAll': "Skip — you decide",
  'questions.autoSkipHint': 'Auto-continues when the timer ends',
  'questions.submitting': 'Submitting…',
  'sketch.toolSelect': 'Select (no-op)',
  'sketch.toolPen': 'Pen',
  'sketch.toolText': 'Text',
  'sketch.toolRect': 'Rectangle',
  'sketch.toolArrow': 'Arrow',
  'sketch.toolEraser': 'Eraser',
  'sketch.color': 'Color',
  'sketch.strokeSize': 'Stroke size',
  'sketch.undo': 'Undo',
  'sketch.clear': 'Clear',
  'sketch.close': 'Close',
  'sketch.closeConfirm': 'Close the sketch and discard your unsaved changes?',
  'sketch.textPrompt': 'Text:',
  'sketch.textModalTitle': 'Add text',
  'critiqueTheater.userFacingName': 'Design Jury',
  'critiqueTheater.roleDesigner': 'Designer',
  'critiqueTheater.roleCritic': 'Critic',
  'critiqueTheater.roleBrand': 'Brand',
  'critiqueTheater.roleA11y': 'Accessibility',
  'critiqueTheater.roleCopy': 'Copy',
  'critiqueTheater.roundLabel': 'Round {n} of {m}',
  'critiqueTheater.mustFix': '{n} must-fix',
  'critiqueTheater.composite': 'Composite',
  'critiqueTheater.threshold': 'Threshold',
  'critiqueTheater.consensus': 'Consensus',
  'critiqueTheater.interrupt': 'Interrupt',
  'critiqueTheater.interrupting': 'Interrupting…',
  'critiqueTheater.interrupted': 'Interrupted',
  'critiqueTheater.degradedHeading': 'Panel offline this run',
  'critiqueTheater.degradedReasonMalformed': 'Malformed panel output (parser rejected the block).',
  'critiqueTheater.degradedReasonOversize': 'Panel output exceeded the safe byte budget.',
  'critiqueTheater.degradedReasonAdapter': 'Adapter {adapter} did not support the Critique protocol.',
  'critiqueTheater.degradedReasonProtocol': 'Adapter {adapter} sent an unsupported protocol version.',
  'critiqueTheater.degradedReasonMissingArtifact': 'Run finished without a final artifact.',
  'critiqueTheater.replay': 'Replay',
  'critiqueTheater.replaySpeed': 'Replay speed',
  'critiqueTheater.readOnly': 'Read-only',
  'critiqueTheater.shippedSummary': 'Shipped at round {round} · composite {composite}',
  'critiqueTheater.interruptedSummary': 'Interrupted at round {round} · best composite {composite}',
  'critiqueTheater.shippedBadge': 'Shipped',
  'critiqueTheater.belowThresholdBadge': 'Below threshold',
  'critiqueTheater.timedOutBadge': 'Timed out',
  'critiqueTheater.failedHeading': 'Run failed',
  'critiqueTheater.failedReasonCliExit': 'Agent CLI exited non-zero before the panel could finish.',
  'critiqueTheater.failedReasonPerRoundTimeout': 'A round exceeded its time budget.',
  'critiqueTheater.failedReasonTotalTimeout': 'The full run exceeded its total time budget.',
  'critiqueTheater.failedReasonOrchestrator': 'Internal orchestrator error.',
  'critiqueTheater.transcriptEmpty': 'No transcript to replay yet. Run a critique to record one.',
  'critiqueTheater.transcriptLoading': 'Loading transcript…',
  'critiqueTheater.transcriptError': 'Could not load transcript: {error}',
  'critiqueTheater.replaySpeedPaused': 'Paused',
  'critiqueTheater.replaySpeedInstant': 'Instant',
  'critiqueTheater.replaySpeedLive': 'Live',
  'critiqueTheater.replaySpeedFast': 'Fast',
  'critiqueTheater.settingsNav': 'Design Jury',
  'critiqueTheater.settingsNavHint': 'Five-panel design review for your runs',
  'critiqueTheater.settingsEnabledLabel': 'Show Design Jury during agent runs',
  'critiqueTheater.settingsEnabledDescription': 'When enabled, a five-panel review appears alongside agent generations and scores the output before shipping. You can interrupt at any time.',
  'critiqueTheater.settingsEnabledProjectHint': 'Saved for this project. New runs in this project will route through Design Jury server-side.',
  'critiqueTheater.settingsEnabledNoProjectHint': 'Open a project to persist this server-side. Until then, this only changes the in-browser preference.',
  'pet.title': 'Pets',
  'pet.subtitle': 'Use Show pet to control whether the companion appears in your workspace. Choose a pet below.',
  'pet.navTitle': 'Pets',
  'pet.navHint': 'Adopt or customize',
  'pet.tabBuiltIn': 'Built-in',
  'pet.tabBuiltInHint': 'Curated companions bundled with OpenDesign — pick one and adopt.',
  'pet.builtInEmpty': 'Built-in pets are unavailable right now. Try refreshing the Community tab once the daemon is online.',
  'pet.tabCustom': 'Custom',
  'pet.tabCustomHint': 'Make your own with a name, glyph, color or sprite.',
  'pet.tabCommunity': 'Community',
  'pet.tabCommunityHint': 'Hatched pets from Codex — adopt one or generate a new one.',
  'pet.tabsAria': 'Choose pet',
  'pet.adopt': 'Adopt',
  'pet.adoptedBadge': 'Adopted',
  'pet.adoptCallout': 'Adopt a pet',
  'pet.changePet': 'Change pet',
  'pet.wake': 'Show pet',
  'pet.tuck': 'Hide pet',
  'pet.wakeTitle': 'Show the pet in the workspace. If none is selected, the first built-in pet will be used.',
  'pet.tuckTitle': 'Hide the pet from the workspace.',
  'pet.settingsTitle': 'Open pet settings',
  'pet.useCustom': 'Use my pet',
  'pet.customTitle': 'Make your own',
  'pet.customHint': 'Pick a name, glyph and accent — the overlay updates live.',
  'pet.customGreetingPlaceholder': 'Say hi from your pet…',
  'pet.fieldName': 'Name',
  'pet.fieldGlyph': 'Glyph',
  'pet.fieldGlyphHint': 'A single emoji works best (e.g. 🐝, 🦄, 🐢).',
  'pet.fieldGreeting': 'Greeting',
  'pet.fieldAccent': 'Accent color',
  'pet.fieldAccentCustom': 'Custom color',
  'pet.fieldAccentDefault': 'Default accent color',
  'pet.overlayAria': 'Pet companion',
  'pet.spriteAria': '{name} — drag to move, click to chat',
  'pet.spriteTitle': 'Hi from {name}! Click to chat.',
  'pet.taskSummarySingle': '{count} agent task is running.',
  'pet.taskSummaryMultiple': '{count} agent tasks are running across {projects} projects.',
  'pet.taskSummaryRecentSingle': '{count} agent task recently completed.',
  'pet.taskSummaryRecentMultiple': '{count} agent tasks recently completed.',
  'pet.taskListAria': 'Active agent tasks',
  'pet.taskOpenProject': 'Open {project}',
  'pet.taskGroup.running': 'Running',
  'pet.taskGroup.queued': 'Waiting',
  'pet.taskGroup.recent': 'Recently completed',
  'pet.idleQuote.leonardo.text': 'Learning never exhausts the mind.',
  'pet.idleQuote.leonardo.author': 'Leonardo da Vinci',
  'pet.idleQuote.michelangelo.text': 'I saw the angel in the marble and carved until I set him free.',
  'pet.idleQuote.michelangelo.author': 'Michelangelo',
  'pet.idleQuote.bernini.text': 'There are two devices which can help the sculptor: light and shadow.',
  'pet.idleQuote.bernini.author': 'Gian Lorenzo Bernini',
  'pet.idleQuote.raphael.text': 'When one is painting one does not think.',
  'pet.idleQuote.raphael.author': 'Raphael',
  'pet.idleQuote.caravaggio.text': 'All works, no matter what or by whom painted, are nothing but bagatelles and childish trifles unless they are made and painted from life.',
  'pet.idleQuote.caravaggio.author': 'Caravaggio',
  'pet.idleQuote.rodin.text': 'The main thing is to be moved, to love, to hope, to tremble, to live.',
  'pet.idleQuote.rodin.author': 'Auguste Rodin',
  'pet.composerTitle': 'Pets — wake, tuck, or pick one',
  'pet.composerMenuTitle': 'Pets',
  'pet.composerMenuHint': 'tip: type /pet to toggle',
  'pet.composerOpenSettings': 'Manage Pets',
  'pet.welcomeTeaserTitle': 'Adopt a pet',
  'pet.welcomeTeaserBody': 'A tiny floating companion that hangs out with you.',
  'pet.welcomeTeaserCta': 'Pick one',
  'pet.imageUpload': 'Upload sprite',
  'pet.imageReplace': 'Replace sprite',
  'pet.imageRemove': 'Use emoji',
  'pet.imageHintIdle': 'PNG, JPG, WebP, GIF or SVG. Sheet upload? Drop a horizontal strip and set the frame count.',
  'pet.imageHintActive': 'Showing your sprite. Set frames > 1 to walk a horizontal spritesheet.',
  'pet.fieldFrames': 'Frames',
  'pet.fieldFramesHint': '1 = static. > 1 = horizontal spritesheet.',
  'pet.fieldFps': 'Speed (fps)',
  'pet.fieldFpsHint': 'How quickly the frames cycle.',
  'pet.atlasImport': 'Import Codex sprite',
  'pet.atlasImportTitle': 'Import a hatch-pet 8x9 / 192x208 atlas (PNG or WebP).',
  'pet.atlasPickerTitle': 'Pick an animation row',
  'pet.atlasPickerHint': 'Codex pets ship 9 animation rows. By default we keep the full atlas so the pet swaps rows on hover, drag, and idle. You can also freeze it to a single loop.',
  'pet.atlasCancel': 'Discard atlas',
  'pet.atlasAdopt': 'Freeze to this row',
  'pet.atlasAdoptFull': 'Use full atlas (animated)',
  'pet.atlasAdoptFullTitle': 'Keep every row so the pet reacts to hover, drag direction, and long idles.',
  'pet.atlasAdoptRowTitle': 'Slice just the highlighted row into a single looping strip.',
  'pet.atlasActiveHint': 'Animated atlas active — the pet picks a row from your interaction (hover, drag, idle).',
  'pet.atlasRow.idle': 'Idle',
  'pet.atlasRow.running-right': 'Run right',
  'pet.atlasRow.running-left': 'Run left',
  'pet.atlasRow.waving': 'Waving',
  'pet.atlasRow.jumping': 'Jumping',
  'pet.atlasRow.failed': 'Failed',
  'pet.atlasRow.waiting': 'Waiting',
  'pet.atlasRow.running': 'Running',
  'pet.atlasRow.review': 'Review',
  'pet.hatchTitle': 'Hatch a new pet with AI',
  'pet.hatchHint': 'Use the bundled hatch-pet skill in chat to generate a Codex-style spritesheet, then import it here.',
  'pet.hatchConcept': 'Pet concept (optional)',
  'pet.hatchConceptPlaceholder': 'e.g. a tiny pixel-art shiba in a cozy sweater',
  'pet.hatchCopy': 'Copy prompt',
  'pet.hatchCopied': 'Copied!',
  'pet.hatchFoot': 'After the skill saves your pet, come back and pick "Import Codex sprite".',
  'pet.slashPopoverAria': 'Slash commands',
  'pet.slashPopoverTitle': 'Commands',
  'pet.slashPopoverHint': '↑↓ navigate · enter to pick · esc to dismiss',
  'pet.slashPet': 'Toggle, adopt, or jump to pet settings.',
  'pet.slashMcp': 'Open MCP server settings or insert a server tool hint.',
  'pet.slashPetWake': 'Wake the floating pet overlay.',
  'pet.slashPetTuck': 'Tuck the pet away for now.',
  'pet.slashHatch': 'Generate a Codex pet via the hatch-pet skill.',
  'pet.slashHatchArg': '<concept>',
  'pet.slashSearch': 'Search the web through the OD research command.',
  'pet.slashSearchArg': '<query>',
  'pet.codexTitle': 'Recently hatched',
  'pet.codexSubtitle': 'Pets packaged by the hatch-pet skill show up here for one-click adoption.',
  'pet.codexSubtitleWithDir': 'Scanning {dir} for pets packaged by the hatch-pet skill.',
  'pet.codexEmpty': 'No hatched pets yet. Type /hatch in chat to generate one.',
  'pet.codexLoading': 'Looking for hatched pets…',
  'pet.codexRefresh': 'Refresh',
  'pet.codexAdopt': 'Adopt',
  'pet.codexAdopting': 'Adopting…',
  'pet.communitySync': 'Download community pets',
  'pet.communitySyncing': 'Downloading…',
  'pet.communitySyncTitle': 'Sync the latest pets from Codex Pet Share + j20 Hatchery into ~/.codex/pets/.',
  'pet.communitySyncDone': 'Synced {wrote} new pets ({total} total).',
  'pet.communitySyncFailed': 'Sync failed: {error}',
  'pet.codexBundled': 'Bundled',
  'pet.codexBundledTitle': 'Ships with OpenDesign — no download needed.',
  'settings.systemPrefsTitle': 'System preferences',
  'settings.systemPrefsHint': 'Completion sound, browser notifications, and task status alerts.',
  'settings.notifications': 'Notifications',
  'settings.notificationsHint': 'Sound and desktop notification on task completion',
  'settings.notifyCompletionSound': 'Completion sound',
  'settings.notifyCompletionSoundHint': 'Plays when a turn finishes. Off by default.',
  'settings.notifySuccessSound': 'Success sound',
  'settings.notifyFailureSound': 'Failure sound',
  'settings.notifyDesktop': 'Desktop notification',
  'settings.notifyDesktopHint': 'Sent when the window is not focused.',
  'settings.notifyDesktopBlocked': 'Notifications blocked by the browser. Allow them in site settings.',
  'settings.notifyDesktopUnsupported': 'Desktop notifications unavailable in this environment.',
  'settings.notifyTest': 'Send test',
  'settings.notifyTestSent': 'Test notification sent. If no banner appears, check browser and system notification settings.',
  'settings.notifyTestFailed': 'Notification call failed. Check browser and system notification settings.',
  'settings.notifySoundDing': 'Ding',
  'settings.notifySoundChime': 'Chime',
  'settings.notifySoundTwoToneUp': 'Two-tone up',
  'settings.notifySoundPluck': 'Pluck',
  'settings.notifySoundBuzz': 'Buzz',
  'settings.notifySoundTwoToneDown': 'Two-tone down',
  'settings.notifySoundThud': 'Thud',
  'settings.skills': 'Skills',
  'settings.skillsHint': 'Functional skills the agent can invoke mid-task',
  'settings.skillsNew': 'New skill',
  'settings.skillsEmpty': 'Select a skill on the left, or create a new one.',
  'settings.skillsEdit': 'Edit',
  'settings.skillsDelete': 'Delete',
  'settings.skillsDeleteConfirm': 'Confirm delete',
  'settings.skillsName': 'Name',
  'settings.skillsTriggers': 'Triggers (comma- or newline-separated)',
  'settings.skillsDescription': 'Description',
  'settings.skillsBody': 'SKILL.md body',
  'settings.skillsCreate': 'Create',
  'settings.skillsSave': 'Save',
  'settings.skillsSaving': 'Saving…',
  'settings.skillsOverrideCreate': 'Create user override',
  'settings.skillsOverrideSave': 'Save as user override',
  'settings.skillsBuiltInOverrideWarning': 'Editing this built-in skill creates a user override. The built-in entry will be hidden from the list until you delete the override. Continue?',
  'settings.skillsFiles': 'Files',
  'settings.skillsNoFiles': 'No files in this skill folder.',
  'settings.skillsNameRequired': 'Skill name is required.',
  'settings.skillsBodyRequired': 'Skill body is required.',
  'settings.designSystems': 'Design Systems',
  'settings.designSystemsHint': 'Manage which design systems appear in the home gallery',
  'settings.designSystemsInstalled': 'Installed',
  'settings.designSystemsAdd': 'Add design system',
  'settings.designSystemsHiddenCount': '{count} hidden from home gallery',
  'settings.designSystemsShowAll': 'Show all',
  'settings.designSystemsShowHidden': 'Show hidden',
  'settings.designSystemsSource': 'Source',
  'settings.designSystemsSourceLocal': 'Local',
  'settings.designSystemsSourceGithub': 'GitHub',
  'settings.designSystemsSourceShadcn': 'shadcn',
  'settings.designSystemsShadcnReference': 'shadcn registry reference',
  'settings.designSystemsImportShadcn': 'Import from shadcn',
  'settings.designSystemsStructure': 'Structure',
  'settings.designSystemsModeHybrid': 'Hybrid',
  'settings.designSystemsModeNormalized': 'Normalized',
  'settings.designSystemsModeVerbatim': 'Verbatim',
  'settings.designSystemsCraft': 'Craft',
  'settings.designSystemsCraftColor': 'Color',
  'settings.designSystemsCraftAccessibility': 'Accessibility',
  'settings.designSystemsGithubUrl': 'GitHub URL',
  'settings.designSystemsProjectPath': 'Project path',
  'settings.designSystemsImportGithub': 'Import from GitHub',
  'settings.designSystemsImportProject': 'Import from project',
  'settings.designSystemsImportedStatus': 'Imported {title}',
  'settings.designSystemsViewImported': 'View imported design system',
  'settings.designSystemsCategory': 'Category',
  'settings.designSystemsAllCategories': 'All categories',
  'settings.designSystemsShowInHomeGallery': 'Show in home gallery',
  'settings.projectLocations': 'Project locations',
  'settings.projectLocationsHint': 'Workspace storage roots',
  'settings.projectLocationsDescription': 'Add work bases that can contain multiple OpenDesign project folders. New projects are saved as one folder inside the selected base.',
  'settings.projectLocationsSaveError': 'Could not save project locations. Check that each path is an accessible folder.',
  'settings.projectLocationsSaved': 'Project locations saved.',
  'settings.projectLocationsScanError': 'Could not scan project locations.',
  'settings.projectLocationsScanComplete': 'Scan complete: {imported} imported, {existing} already registered.',
  'settings.projectLocationsNoFolderSelected': 'No folder selected.',
  'settings.projectLocationsDuplicate': 'That work base is already added.',
  'settings.projectLocationsWorkBaseMeta': 'Work base · projects are created as subfolders here',
  'settings.projectLocationsAddFolder': 'Add folder…',
  'settings.projectLocationsDefaultBadge': 'Default location',
  'settings.projectLocationsMakeDefault': 'Make default',
  'settings.projectLocationsDefaultSaved': 'Default project location updated.',
  'settings.librarySkills': 'Skills',
  'settings.libraryDesignSystems': 'Design Systems',
  'settings.librarySearch': 'Search...',
  'settings.libraryAll': 'All',
  'settings.libraryPreview': 'Preview',
  'settings.libraryPreviewClose': 'Close',
  'settings.libraryLoading': 'Loading...',
  'settings.libraryNoResults': 'No items match your search.',
  'settings.libraryEnabled': 'Enabled',
  'settings.libraryDisabled': 'Disabled',
  'settings.connectorsNavHint': 'External system connections',
  'settings.connectorsHint': 'Manage connector and tool provider settings for this device.',
  'settings.connectorsComposioApiKey': 'Composio API Key',
  'settings.connectorsSavedTitle': 'Saved to local daemon',
  'settings.connectorsSavedWithTail': 'Saved · ••••{tail}',
  'settings.connectorsSaved': 'Saved',
  'settings.connectorsGetApiKey': 'Get API Key',
  'settings.connectorsReplaceKeyPlaceholder': 'Enter a new key to replace the saved key',
  'settings.connectorsApiKeyPlaceholder': 'Paste Composio API key',
  'settings.connectorsClear': 'Clear',
  'settings.connectorsClearConfirmTitle': 'Clear the saved Composio API key?',
  'settings.connectorsClearConfirmBody': 'Removing the key disconnects every Composio connector linked to this workspace. Connected accounts, OAuth grants, and tool access will all be removed.',
  'settings.connectorsClearConfirmContinue': 'Continue',
  'settings.connectorsClearFinalTitle': 'This will disconnect all connectors',
  'settings.connectorsClearFinalBody': 'There is no undo. You will need to reconnect each integration from scratch after pasting a new key.',
  'settings.connectorsClearFinalConfirm': 'Delete key & disconnect',
  'settings.connectorsClearArming': 'Hold on\u2026',
  'settings.connectorsClearCancel': 'Cancel',
  'settings.connectorsSaveKey': 'Save key',
  'settings.connectorsSaveKeyTitle': 'Send this key to the local daemon',
  'settings.connectorsKeySaving': 'Saving\u2026',
  'settings.connectorsKeySaved': 'Saved ✓',
  'settings.connectorsKeyError': 'Couldn\u2019t save the key. Check that the local daemon is running and try again.',
  'settings.connectorsHelpSaved': 'Your key is saved in the local daemon. Paste a new key to replace it, or Clear to remove.',
  'settings.connectorsHelpUnsaved': 'Unsaved changes \u2014 click Save key to store this credential in the local daemon and refresh the catalog below.',
  'settings.connectorsHelpEmpty': 'Keys are stored locally and never shared.',
  'settings.connectorsLoadingSavedKey': 'Checking for a saved key in the local daemon\u2026',
  'settings.autosaveSaving': 'Saving\u2026',
  'settings.autosaveSaved': 'All changes saved',
  'settings.autosaveError': 'Couldn\u2019t save changes. The local daemon may be offline.',
  'settings.libraryToggleLabel': 'Toggle',
  'settings.memory': 'Memory',
  'settings.memoryHint': 'Saved facts and context for future chats',
  'settings.customInstructionsTitle': 'Global rules',
  'settings.customInstructionsHint': 'Fixed instructions OpenDesign should follow in every chat. Save facts, preferences, and project context as memories.',
  'settings.customInstructionsPlaceholder': 'e.g. "Always use TypeScript. Prefer functional components. Keep responses concise."',
  'settings.memoryDescription': 'Control whether saved facts, preferences, and project context are reused in future chats.',
  'settings.memoryEnabled': 'Enabled',
  'settings.memoryDisabled': 'Disabled',
  'settings.memoryEnableLabel': 'Enable memory injection',
  'settings.memoryDisabledBanner': 'Memory is currently OFF. Existing facts are preserved on disk but will not be folded into new chats and new turns will not extract anything new.',
  'settings.memoryNew': 'New memory',
  'settings.memoryEdit': 'Edit',
  'settings.memoryDelete': 'Delete',
  'settings.memoryPreview': 'Preview',
  'settings.memoryEmpty': 'No memory yet.',
  'settings.memoryEmptyHintZh': '记住: 用户偏好深色主题',
  'settings.memoryEmptyHintEn': 'I prefer dark mode',
  'settings.memoryName': 'e.g. UI preferences',
  'settings.memoryDesc': 'One sentence — what is this memory about?',
  'settings.memoryBody': '- Rule one\n- Rule two\n\nWhy: optional reason\nWhen to apply: optional scope',
  'settings.memoryBodyHint': 'Bullet the rules first, then optional Why and When-to-apply lines. Markdown supported. Or click a starter above to load a working example.',
  'settings.memoryStartersLabel': 'Need a starting point? Click to fill the form:',
  'settings.memoryStarterUserName': 'My role',
  'settings.memoryStarterUserDesc': 'I am a frontend engineer working on a SaaS design tool',
  'settings.memoryStarterUserBody': '- Role: senior frontend engineer\n- Stack: React, TypeScript, Vite\n- Domain: design / collaboration tools\n- Timezone: GMT+8 (Asia/Shanghai)\n\nWhen to apply: any chat — frame examples around web frontend.',
  'settings.memoryStarterFeedbackName': 'UI preferences',
  'settings.memoryStarterFeedbackDesc': 'Dark mode, large body text, low information density',
  'settings.memoryStarterFeedbackBody': '- Theme: dark by default\n- Body text: ≥ 18px\n- Information density: prefer whitespace, fewer items per screen\n\nWhy: less eye strain during long sessions.\nWhen to apply: whenever you generate UI, web pages, or slides.',
  'settings.memoryStarterProjectName': 'Current project',
  'settings.memoryStarterProjectDesc': 'OpenDesign v0.5 — chat-driven design editor',
  'settings.memoryStarterProjectBody': '- Goal: ship the chat-driven editor this quarter\n- Priorities: streaming render, local multimodal, offline-first\n- Stack: Next.js 16, Express daemon, SQLite\n\nWhen to apply: in any conversation about this project.',
  'settings.memorySaveHint': 'Not auto-saved — click Create / Save to apply.',
  'settings.memoryIndexSaveHint': 'Edits to the index are not auto-saved — click Save index to apply.',
  'settings.memoryIndexUnsaved': 'Unsaved changes',
  'settings.memoryFlashCreated': '✓ Memory created',
  'settings.memoryFlashSaved': '✓ Memory saved',
  'settings.memoryFlashDeleted': '✓ Memory deleted',
  'settings.memoryFlashIndexSaved': '✓ Index saved',
  'settings.memoryFlashPathCopied': '✓ Path copied',
  'settings.memoryNameLabel': 'Title',
  'settings.memoryTypeLabel': 'Type',
  'settings.memoryDescLabel': 'Description',
  'settings.memoryBodyLabel': 'Content',
  'settings.memoryTypeUser': 'User',
  'settings.memoryTypeFeedback': 'Feedback',
  'settings.memoryTypeProject': 'Project',
  'settings.memoryTypeReference': 'Reference',
  'settings.memoryTypeProfile': 'Profile',
  'settings.memoryTypeRule': 'Rule',
  'settings.memoryTabMemories': 'Memories',
  'settings.memoryTabMemoriesCaption': 'View and manage saved memory',
  'settings.memoryTabHow': 'How it works',
  'settings.memoryTabHowCaption': 'The two loops and their controls',
  'settings.memoryAddDisclosure': 'Add or import memories',
  'settings.memoryAddDisclosureHint': 'Profile, manual entry, or connected apps',
  'settings.memoryProfileTab': 'Work profile',
  'settings.memoryProfileTabCaption': 'Who you are and your defaults',
  'settings.memoryProfileTitle': 'Your work profile',
  'settings.memoryProfileHint':
    'A few facts about you and your defaults. Memory injects this before every task so the agent infers what you mean from a short ask.',
  'settings.memoryProfileName': 'Work profile',
  'settings.memoryProfileDescription':
    'Role, company, domain, audience, taste, and defaults the assistant should reuse.',
  'settings.memoryProfileSave': 'Save profile',
  'settings.memoryProfileSaving': 'Saving…',
  'settings.memoryProfileSaved': 'Profile saved',
  'settings.memoryProfileRole': 'Role',
  'settings.memoryProfileRolePlaceholder': 'e.g. Founder, designer, PM',
  'settings.memoryProfileCompany': 'Company / Team',
  'settings.memoryProfileCompanyPlaceholder': 'e.g. Acme, growth team',
  'settings.memoryProfileDomain': 'Domain',
  'settings.memoryProfileDomainPlaceholder': 'e.g. B2B SaaS, fintech, devtools',
  'settings.memoryProfileAudience': 'Primary audience',
  'settings.memoryProfileAudiencePlaceholder': 'e.g. executives, engineers, end users',
  'settings.memoryProfileAesthetic': 'Aesthetic / taste',
  'settings.memoryProfileAestheticPlaceholder':
    'e.g. clean and editorial, light backgrounds, generous whitespace',
  'settings.memoryProfileDeliverables': 'Default deliverables',
  'settings.memoryProfileDeliverablesPlaceholder': 'e.g. landing pages, decks, one-pagers',
  'settings.memoryProfileLocale': 'Locale / Language',
  'settings.memoryProfileLocalePlaceholder': 'e.g. English (US), Simplified Chinese',
  'settings.memoryProfileGoals': 'Current goals',
  'settings.memoryProfileGoalsPlaceholder':
    'e.g. ship the new pricing page, raise conversion on the trial flow',
  'settings.memoryHooksTitle': 'Memory hooks',
  'settings.memoryHooksHint':
    'Choose which parts of memory run automatically. The master switch above turns all of them off.',
  'settings.memoryHooksProfileLabel': 'Use my profile',
  'settings.memoryHooksProfileDesc': 'Inject your work profile into every task.',
  'settings.memoryHooksRewriteLabel': 'Rewrite short asks',
  'settings.memoryHooksRewriteDesc': 'PRE: expand a short request into a full task brief.',
  'settings.memoryHooksVerifyLabel': 'Self-verify output',
  'settings.memoryHooksVerifyDesc': 'POST: check the result against your rules, then show a scorecard.',
  'settings.memoryHooksExtractionLabel': 'Learn from chats',
  'settings.memoryHooksExtractionDesc': 'Capture useful facts and preferences from chat turns.',
  'settings.memoryIndex': 'MEMORY.md (index)',
  'settings.memoryIndexSave': 'Save index',
  'settings.memoryIndexReset': 'Reset',
  'settings.memoryToastChanged': 'Memory updated',
  'settings.memoryToastClickHint': 'View',
  'settings.memoryAll': 'All',
  'settings.memoryExtractions': 'Extraction history',
  'settings.memoryExtractionsHint': 'Regex runs first, LLM runs in background.',
  'settings.memoryExtractionsEmpty': 'No extractions yet. The next chat turn will populate this list.',
  'settings.memoryExtractionsRefresh': 'Refresh',
  'settings.memoryExtractionsRefreshing': 'Refreshing…',
  'settings.memoryExtractionPhaseRunning': 'Running…',
  'settings.memoryExtractionPhaseSuccess': 'Success',
  'settings.memoryExtractionPhaseSkipped': 'Skipped',
  'settings.memoryExtractionPhaseFailed': 'Failed',
  'settings.memoryExtractionSkipNoProvider': 'No API key configured for LLM memory extraction.',
  'settings.memoryExtractionSkipUnsupportedProvider': 'A saved media provider is not supported for LLM memory extraction.',
  'settings.memoryExtractionSkipDisabled': 'Memory is disabled.',
  'settings.memoryExtractionSkipEmpty': 'Empty user message — nothing to extract.',
  'settings.memoryExtractionSkipNoMatch': 'No regex pattern matched this turn.',
  'settings.memoryExtractionKindHeuristic': 'regex',
  'settings.memoryExtractionKindLlm': 'LLM',
  'settings.memoryExtractionProviderEnv': 'env',
  'settings.memoryExtractionProviderMediaConfig': 'media settings',
  'settings.memoryExtractionProviderOverride': 'memory settings',
  'settings.memoryExtractionProposed': 'proposed',
  'settings.memoryExtractionWritten': 'written',
  'settings.memoryExtractionDuration': 'in',
  'settings.memoryExtractionDelete': 'Delete',
  'settings.memoryExtractionsClear': 'Clear',
  'settings.memoryExtractionsClearTitle': 'Clear all extraction history',
  'settings.memoryExtractionsClearConfirm': 'Clear all extraction history? This cannot be undone.',
  'settings.memoryNoProviderBannerTitle': 'LLM memory extraction is not running',
  'settings.memoryNoProviderBannerBody': 'No API key found for the memory extractor. Add an OpenAI key under Media providers, or set ANTHROPIC_API_KEY / OPENAI_API_KEY in the environment, to enable LLM-driven extraction. Heuristic regex extraction is still active.',
  'settings.memoryUnsupportedProviderBannerBody': 'A media provider key is saved, but Memory can only reuse text-capable providers: OpenAI, MiniMax, AIHubMix, and SenseAudio. Configure one of those under Media providers, set ANTHROPIC_API_KEY / OPENAI_API_KEY, or choose a Memory model in Advanced.',
  'settings.libraryInstall': 'Install',
  'settings.libraryInstallGithub': 'GitHub',
  'settings.libraryInstallLocal': 'Local Path',
  'settings.libraryInstallUrl': 'https://github.com/owner/repo',
  'settings.libraryInstallPath': '/path/to/skill-folder',
  'settings.libraryInstallButton': 'Install',
  'settings.libraryUninstall': 'Uninstall',
  'settings.libraryBuiltIn': 'Built-in',
  'settings.libraryInstalled': 'Installed',
  'settings.orbit.eyebrow': 'Automation',
  'settings.orbit.title': 'Orbit',
  'settings.orbit.navHint': 'Daily connector summary',
  'settings.orbit.lede': 'Collect connector activity on a schedule and publish the result as a refreshable live artifact.',
  'settings.orbit.statusOnTitle': 'Scheduled daily runs are on',
  'settings.orbit.statusOffTitle': 'Scheduled daily runs are off',
  'settings.orbit.statusActive': 'Active',
  'settings.orbit.statusOff': 'Off',
  'settings.orbit.runTitle': 'Start an Orbit run and open the live conversation',
  'settings.orbit.running': 'Running…',
  'settings.orbit.runOpen': 'Run it now',
  'settings.orbit.dailySummaryTitle': 'Daily summary',
  'settings.orbit.dailySummarySub': 'Runs once per day at the scheduled local time.',
  'settings.orbit.on': 'On',
  'settings.orbit.off': 'Off',
  'settings.orbit.runTimeTitle': 'Run time',
  'settings.orbit.runTimeSub': 'Default 08:00. Save to apply to the daemon schedule.',
  'settings.orbit.runTimeAria': 'Daily Orbit run time',
  'settings.orbit.nextRun': 'Next run',
  'settings.orbit.nextRunScheduledAfterSave': 'Scheduled after Save',
  'settings.orbit.schedule': 'Schedule',
  'settings.orbit.pausedManualOnly': 'Paused — manual runs only',
  'settings.orbit.templateTitle': 'Prompt template',
  'settings.orbit.templateMissing': 'Template {id} is not installed.',
  'settings.orbit.templateMissingOption': '{id} (missing)',
  'settings.orbit.templateMissingInstall': 'Install an Orbit skill to steer the prompt.',
  'settings.orbit.templateMissingPickAnother': 'Pick another template from the dropdown.',
  'settings.orbit.templateResetTitle': 'Reset to {id}',
  'settings.orbit.templateReset': 'Reset',
  'settings.orbit.templateHelp': 'Steer Orbit with a skill — the selected template example prompt is injected into every Orbit run so summaries follow that template shape.',
  'settings.orbit.templateAria': 'Orbit prompt template',
  'settings.orbit.templatesLoading': 'Loading templates…',
  'settings.orbit.templatesOptgroup': 'Orbit skill templates',
  'settings.orbit.lastRun': 'Last run',
  'settings.orbit.triggerManual': 'Manual',
  'settings.orbit.triggerScheduled': 'Scheduled',
  'settings.orbit.meterAria': '{succeeded} succeeded, {skipped} skipped, {failed} failed out of {checked} checked',
  'settings.orbit.countChecked': 'Checked',
  'settings.orbit.countSucceeded': 'Succeeded',
  'settings.orbit.countSkipped': 'Skipped',
  'settings.orbit.countFailed': 'Failed',
  'settings.orbit.runError': 'Could not run Orbit. Make sure the local daemon is running and connectors are configured.',
  'settings.orbit.gateAriaLabel': 'Connectors required to use Orbit',
  'settings.orbit.gateEyebrow': 'Setup required',
  'settings.orbit.gateTitle': 'Connect a tool to power Orbit',
  'settings.orbit.gateBody': 'Orbit summarizes activity across your connectors. You haven\u2019t connected anything yet \u2014 add at least one integration to give Orbit something to report on.',
  'settings.orbit.gateBodyNoKey': 'Orbit summarizes activity across your connectors, and connectors run through Composio. Add a Composio API key in Connectors to load the catalog and pick your first integration.',
  'settings.orbit.gateAction': 'Open Connectors',
  'settings.orbit.gateActionNoKey': 'Configure Composio',
  'settings.orbit.gateLoading': 'Checking your connectors\u2026',
  'settings.orbit.controlsLockedBadge': 'Locked',
  'settings.orbit.controlsLockedHint': 'Connect a tool to unlock Orbit\u2019s schedule and template controls.',
  'settings.orbit.artifactKickerLive': 'live artifact',
  'settings.orbit.artifactKickerLegacy': 'Legacy summary',
  'settings.orbit.artifactTitle': 'Daily Orbit activity summary',
  'settings.orbit.artifactMetaLive': 'Refreshable HTML artifact generated from connector activity.',
  'settings.orbit.artifactMetaLegacy': 'Generated before live artifact support was enabled — run Orbit again to publish one.',
  'settings.orbit.copyMarkdownTitle': 'Copy markdown summary to clipboard',
  'settings.orbit.copied': 'Copied',
  'settings.orbit.copy': 'Copy',
  'settings.orbit.openArtifact': 'Open artifact',
  'settings.orbit.sourceMarkdown': 'Source markdown',
  'notify.successTitle': 'Task completed',
  'notify.failureTitle': 'Task failed',
  'notify.successBody': 'A turn has finished.',
  'notify.failureBody': 'The task ended with an error.',
  'updater.available': 'Update available',
  'updater.availableBody': 'OpenDesign {version} is available. It will download before the installer can open.',
  'updater.activeRunsTitle': 'OpenDesign is still working',
  'updater.activeRunsBody': '{count} active tasks are still running. Restarting now will interrupt them.',
  'updater.activeRunsUnknownBody': 'OpenDesign could not confirm whether tasks are still running. Restarting now may interrupt active work.',
  'updater.checking': 'Checking for updates',
  'updater.download': 'Download update',
  'updater.downloading': 'Downloading update',
  'updater.downloadingPercent': 'Downloading update {percent}%',
  'updater.done': 'Done',
  'updater.failed': 'Update failed',
  'updater.installerOpenBody': 'The installer is open. OpenDesign is quitting so you can finish the update.',
  'updater.installerOpened': 'Installer opened',
  'updater.later': 'Later',
  "updater.allowSilentUpdates": "Allow automatic install of future in-app updates",
  'updater.openFailedFallback': 'The installer could not be opened.',
  'updater.installRestart': 'Install and restart',
  'updater.installingRestart': 'Installing and restarting...',
  'updater.openInstaller': 'Install update',
  'updater.opening': 'Opening installer...',
  'updater.dialogAvailableGeneric': 'A new version is available.\nDownload it to install the update.',
  'updater.dialogAvailableVersion': 'v{version} is available.\nDownload it to install the update.',
  'updater.dialogCheckFailed': 'Couldn\'t check for updates\nVersion information is temporarily unavailable. Check your network connection and try again.',
  'updater.dialogDownloadFailed': 'Update download didn’t finish\nMake sure your network connection is working, then try again.',
  'updater.downloadFailedTitle': 'Update download didn’t finish',
  'updater.dialogReadyGeneric': 'A new version is ready.\nBetter experiences and smarter design await.',
  'updater.dialogReadyVersion': 'v{version} is ready.\nBetter experiences and smarter design await.',
  'updater.dialogUnsupported': 'In-app updates aren\'t available here.\nDownload the latest version from Releases.',
  'updater.payloadReadyGeneric': 'A new OpenDesign update is ready. OpenDesign will close and restart automatically.',
  'updater.payloadReadyVersion': 'OpenDesign {version} is ready. OpenDesign will close and restart automatically.',
  'updater.quitButton': 'Quit OpenDesign',
  'updater.quitFailedBody': 'The installer is open, but OpenDesign could not quit. Quit OpenDesign before replacing the app.',
  'updater.quitFailedTitle': 'Could not quit',
  'updater.quitting': 'Quitting...',
  'updater.ready': 'Update ready',
  'updater.readyGeneric': 'A new version is ready. OpenDesign will close and open the installer.',
  'updater.readyVersion': 'OpenDesign {version} is ready. OpenDesign will close and open the installer.',
  'updater.reinstallLearnMore': 'Learn more',
  'updater.reinstallReadyGeneric': 'This update requires a full reinstall. OpenDesign will close and open the installer.',
  'updater.reinstallReadyVersion': 'OpenDesign {version} requires a full reinstall. OpenDesign will close and open the installer.',
  'updater.restartAnyway': 'Restart anyway',
  'updater.upToDate': 'You\'re already on the latest version.',
  'updater.viewVersionFeatures': 'Explore new features',
  'updater.manualDownload': 'Download manually',
  'whatsNew.updatedTitle': 'OpenDesign {version} is here',
  'whatsNew.cta': 'View the release notes',
  'newsletter.label': 'Newsletter (optional)',
  'newsletter.placeholder': 'you@studio.com',
  'settings.memoryModelInlineLabel': 'Memory model',
  'settings.memoryModelInlineSameAsChat': 'Same as chat',
  'settings.memoryModelInlineSameAsChatWithModel': 'Same as chat ({model})',
  'settings.memoryModelInlineSameAsChatWithProvider': 'Same as chat ({provider})',
  'settings.memoryModelInlineHintCli': 'Optional. Uses the selected Local CLI when supported; choose a model only to override the default.',
  'settings.memoryModelInlineHintCliConstrained': 'Optional. Uses the selected Local CLI when supported; {provider} is only the fallback provider family.',
  'settings.memoryModelInlineHintByok': 'Optional. Reuses your chat API key — pick a cheaper model to save cost.',
  'settings.memoryModelInlineHintByokNeutral': 'Memory uses a separate model from chat. Defaults to your chat model.',
  'settings.memoryModelInlineFlashSaved': 'Saved',
  'settings.memoryModelInlineFlashCleared': 'Cleared',
  'diagnostics.exportTitle': 'Export diagnostics',
  'diagnostics.exportButton': 'Export diagnostics',
  'diagnostics.exportHint': 'Bundles recent app logs and machine info into a zip you can share with the team.',
  'diagnostics.exporting': 'Exporting…',
  'diagnostics.exportSuccess': 'Saved diagnostics to {path}',
  'diagnostics.exportFailed': 'Could not export diagnostics: {message}',
  'automations.eyebrow': 'Scheduled agent sessions',
  'automations.title': 'Automations',
  'automations.lede': 'Plan recurring conversations for project work, Orbit digests, and live artifacts.',
  'automations.summaryAria': 'Automation summary',
  'automations.metricActive': 'Active',
  'automations.metricPaused': 'Paused',
  'automations.metricTemplates': 'Templates',
  'automations.newAutomation': 'New automation',
  'automations.yourAutomations': 'Your automations',
  'automations.loading': 'Loading',
  'automations.emptyTitle': 'No automations yet',
  'automations.emptyBody': 'Create one from a template or start with a blank schedule.',
  'automations.targetNewEachRun': 'New project each run',
  'automations.targetCreateEachRun': 'New project each run',
  'automations.lastRun': 'Last run {time}',
  'automations.openResult': 'Open result',
  'automations.run': 'Run',
  'automations.runNowTitle': 'Run now and open the conversation',
  'automations.history': 'History',
  'automations.hideHistory': 'Hide history',
  'automations.edit': 'Edit',
  'automations.pause': 'Pause',
  'automations.resume': 'Resume',
  'automations.deleteAria': 'Delete automation',
  'automations.deleteTitle': 'Delete this automation',
  'automations.deleteConfirm': 'Delete this automation? Past runs and their projects are kept.',
  'automations.proposalsTitle': 'Evolution proposals',
  'automations.proposalsSub': 'Review automation output before it changes memory, skills, or design systems.',
  'automations.proposalsPending': '{n} pending',
  'automations.apply': 'Apply',
  'automations.reject': 'Reject',
  'automations.proposalsDismissReason': 'Dismissed in Automations',
  'automations.templatesTitle': 'Templates',
  'automations.templatesSub': 'Orbit and live artifacts are templates inside the same automation flow.',
  'automations.templatesCount': '{filtered} of {total}',
  'automations.templateFiltersAria': 'Template filters',
  'automations.templatesEmptyTitle': 'No templates in this category yet.',
  'automations.templatesEmptyBody': 'Try a different filter, or start from a blank automation.',
  'automations.useTemplate': 'Use template',
  'automations.runHistoryLoading': 'Loading run history...',
  'automations.runHistoryEmpty': 'No runs yet.',
  'automations.runHistoryTitle': 'Run history',
  'automations.runHistoryLatest': 'Latest 10',
  'automations.crystallize': 'Crystallize',
  'automations.crystallizing': 'Crystallizing',
  'automations.crystallizeTitle': 'Draft skill and memory proposals from this run',
  'automations.crystallizeFailed': 'Crystallize failed: {error}',
  'automations.crystallizePartialSuccess': 'Crystallize created proposals, but Automations could not refresh the proposal list. Review the visible proposals or try refreshing.',
  'automations.crystallizeRefreshFailed': 'Crystallize finished, but Automations could not refresh proposals. Try refreshing before running it again.',
  'automations.crystallizeNoProposals': 'Crystallize finished, but no proposals were returned. Try refreshing or check the run details.',
  'automations.openConversation': 'Open conversation',
  'automations.runHistoryAria': 'Automation run history',
  'automations.proposalsAria': 'Automation evolution proposals',
  'automations.templatesAria': 'Automation templates',
  'automations.runInProgress': 'In progress',
  'automations.promptPlaceholder': 'Pull yesterday’s GitHub + Linear activity and summarize what changed.',
  'automations.scheduleStatusPaused': 'Paused',
  'automations.nextRunManualOnly': 'Manual only',
  'automations.nextRunScheduled': 'Scheduled',
  'automations.nextRunAt': 'Next {time}',
  'automations.statusSucceeded': 'Succeeded',
  'automations.statusFailed': 'Failed',
  'automations.statusRunning': 'Running',
  'automations.statusQueued': 'Queued',
  'automations.statusCanceled': 'Canceled',
  'automations.kindOrbit': 'Orbit',
  'automations.kindLiveArtifact': 'Live artifact',
  'automations.kindAutomation': 'Automation',
  'automations.proposalTargetMemory': 'Memory',
  'automations.proposalTargetDesignSystem': 'Design system',
  'automations.proposalTargetSkill': 'Skill',
  'automations.proposalTargetTemplate': 'Automation template',
  'automations.proposalActionCreate': 'Create',
  'automations.proposalActionUpdate': 'Update',
  'automations.proposalActionMerge': 'Merge',
  'automations.proposalActionMove': 'Move',
  'automations.proposalActionDelete': 'Delete',
  'automations.proposalActionPromote': 'Promote',
  'automations.filterAll': 'All',
  'automations.filterOrbit': 'Orbit',
  'automations.filterLiveArtifacts': 'Live artifacts',
  'automations.filterMemory': 'Memory',
  'automations.filterDesignSystems': 'Design systems',
  'automations.filterSkills': 'Skills',
  'automations.filterConnectors': 'Connectors',
  'automations.filterCompression': 'Compression',
  'automations.filterRelease': 'Release',
  'automations.filterQuality': 'Quality',
  'automations.tpl.memoryRefresh.title': 'Refresh project memory from recent work.',
  'automations.tpl.memoryRefresh.desc': 'Turns repeated decisions, preferences, and feedback into reusable memory updates.',
  'automations.tpl.designSystemRefresh.title': 'Update design systems from shipped artifacts.',
  'automations.tpl.designSystemRefresh.desc': 'Finds reusable tokens, components, and rules across recent design work.',
  'automations.tpl.liveArtifactRegistry.title': 'Audit live artifacts and refresh stale versions.',
  'automations.tpl.liveArtifactRegistry.desc': 'Keeps persistent dashboards, reports, and previews current instead of duplicating them.',
  'automations.tpl.orbitDashboard.title': 'Build a connector activity dashboard.',
  'automations.tpl.orbitDashboard.desc': 'Aggregates selected connectors into an Orbit-style live dashboard.',
  'automations.tpl.releaseNotes.title': 'Draft release notes from shipped design work.',
  'automations.tpl.releaseNotes.desc': 'Connects merged PRs, artifacts, and product-facing changes into release notes.',
  'automations.tpl.qualityRegressionWatch.title': 'Watch for design and implementation regressions.',
  'automations.tpl.qualityRegressionWatch.desc': 'Compares recent changes against benchmarks, traces, and accepted references.',
  'automations.tpl.orbitDaily.title': 'Daily connector digest.',
  'automations.tpl.orbitDaily.desc': 'Refreshes a connector activity digest on a schedule.',
  'automations.tpl.liveStatusBoard.title': 'Keep a live status artifact fresh.',
  'automations.tpl.liveStatusBoard.desc': 'Updates one persistent artifact instead of creating a new report each run.',
  'dsManager.areaAria': 'Design systems area',
  'dsManager.tabDesignSystem': 'Design system',
  'dsManager.tabTemplate': 'Template',
  'dsManager.sourceAria': 'Design system source',
  'dsManager.templateSourceAria': 'Template source',
  'dsManager.yourSystems': 'Your systems',
  'dsManager.officialPresets': 'Official presets',
  'dsManager.shareToTeam': 'Share to team',
  'dsManager.shareToTeamFailed': 'Couldn\'t share to team',
  'dsManager.syncToTeam': 'Sync to team',
  'dsManager.syncToTeamFailed': 'Couldn\'t sync to team',
  'dsManager.unshareFromTeam': 'Remove from team',
  'dsManager.unshareFromTeamFailed': 'Couldn\'t remove from team',
  'dsManager.teamSyncedReadOnly': 'Only the sharer or a workspace admin can change this',
  'dsManager.enterprise': 'Enterprise',
  'dsManager.yourTemplates': 'Your templates',
  'dsManager.yourSystemsAria': 'Your design systems',
  'dsManager.eyebrowDesignSystems': 'Design Systems',
  'dsManager.yourSystemsHeading': 'Your systems',
  'dsManager.filterAria': 'Filter design systems',
  'dsManager.filterAll': 'All',
  'dsManager.filterPublished': 'Published',
  'dsManager.filterDraft': 'Draft',
  'dsManager.createTitle': 'Create new design system',
  'dsManager.createBody': 'Teach OpenDesign your brand, product, code, assets, and design references.',
  'dsManager.createAction': 'Create',
  'dsManager.emptyMine': 'No design systems yet. Create one from real product context, review the draft, then publish it for future projects.',
  'dsManager.badgeDefault': 'Chat default',
  'dsManager.rowMetaUpdated': 'You · updated {date}',
  'dsManager.edit': 'Edit',
  'dsManager.openSystem': 'Edit system',
  'dsManager.editWithAgent': 'Edit with agent',
  'dsManager.downloadTitle': 'Download design system (.zip + SKILLS.md)',
  'dsManager.downloadAria': 'Download {title} as a .zip',
  'dsManager.downloadFailed': 'Could not download the design system. Please try again.',
  'dsManager.deleteConfirm': 'Delete "{title}"? This removes the draft design system from this device.',
  'dsManager.makeDefault': 'Default for new chats',
  'dsManager.statusPublished': 'Published',
  'dsManager.statusDraft': 'Draft',
  'dsManager.openSystemAria': 'Edit {title}',
  'dsManager.deleteSystemAria': 'Delete {title}',
  'dsManager.deletePermissionDenied': 'You don\'t have permission to delete this design system.',
  'dsManager.presetsAria': 'Official design system presets',
  'dsManager.eyebrowLibrary': 'Library',
  'dsManager.eyebrowTemplates': 'Templates',
  'dsManager.yourTemplatesAria': 'Your templates',
  'dsManager.emptyTemplates': 'No templates yet. Create one from any generated project via Share once template publishing is enabled.',
  'dsManager.templateDescFallback': 'Created from a project',
  'dsManager.comingSoonBadge': 'Coming soon',
  'dsManager.enterpriseDsTitle': 'Enterprise design systems',
  'dsManager.enterpriseDsBody': 'Shared team design systems and governed brand libraries are coming soon.',
  'dsManager.enterpriseTplTitle': 'Enterprise templates',
  'dsManager.enterpriseTplBody': 'Team-approved templates and organization-wide publishing are coming soon.',
  'settings.instructionsTitle': 'Instructions & rules',
  'settings.instructionsSubtitle': 'Fixed behavior the assistant should follow',
  'settings.instructionsNavSub': 'Fixed assistant behavior',
  'settings.customInstructionsDesc': 'Fixed instructions OpenDesign follows in every chat. These are not saved memories; use Memory for facts, preferences, and project context.',
  'mcpClient.forwardedToLabel': 'Forwarded to:',
  'mcpClient.notForwardedToLabel': 'Not forwarded to:',
  'mcpClient.forwardedAcpNote': 'ACP adapters marked stdio only receive stdio MCP servers from this list; HTTP and SSE entries are dropped at spawn time.',
  'mcpClient.notForwardedNote': 'For those agents, configure MCP servers in the agent\'s own config file (e.g. ~/.codex/config.toml, ~/.gemini/settings.json); the servers below are silently unused there.',

  // Design systems library + extraction
  'brand.libraryTitle': 'Design System',
  'brand.librarySubtitle': 'Teach OpenDesign your design systems — extract one from a website, then apply it in any chat.',
  'brand.newBrand': 'New Design System',
  'brand.searchPlaceholder': 'Search your design systems…',
  'brand.empty': 'No design systems yet. Extract one from a website to get started.',
  'brand.colorsCount': '{count} colors',
  'brand.extracting': 'Extracting…',
  'brand.failed': 'Extraction failed',
  'brand.needsInput': 'Needs input',
  'brand.needsInputHint': 'Extraction paused — open the project to finish verification or answer the question.',
  'brand.appliedToChat': 'Using {name}',
  'brand.previewEmpty': 'Select a design system to preview',
  'brand.viewDetails': 'View details',
  'newBrand.title': 'New Design System',
  'newBrand.subtitle': 'Paste a website, or pick a brand below, and we\'ll extract its colors, fonts and logo.',
  'newBrand.urlLabel': 'Brand website',
  'newBrand.urlPlaceholder': 'yourcompany.com',
  'newBrand.extract': 'Extract design system',
  'newBrand.cancel': 'Cancel',
  'newBrand.close': 'Close',
  'newBrand.stage1': 'Fetching the site & measuring its design',
  'newBrand.stage2': 'Building a design system preview',
  'newBrand.stage3': 'Deriving & registering the design system',
  'newBrand.measured': '{colors} colors · {fonts} fonts · {logos} logos',
  'newBrand.done': 'Design system ready',
  'brandDetail.identity': 'Identity',
  'brandDetail.designLanguage': 'Design Language',
  'brandDetail.colors': 'Colors',
  'brandDetail.fonts': 'Fonts',
  'brandDetail.tone': 'Tone',
  'brandDetail.aesthetic': 'Aesthetic',
  'brandDetail.tagline': 'Tagline',
  'brandDetail.voice': 'Voice',
  'brandDetail.useInChat': 'Use in new chat',
  'brandDetail.delete': 'Delete design system',
  'brandDetail.back': 'Design System',
  'brandDetail.refining': 'Refining this design system…',
  'brandDetail.notFound': 'Design system not found.',
  'brandDetail.logo': 'Logo',
  'brandDetail.typography': 'Typography',
  'brandDetail.palette': 'Palette',
  'brandDetail.voiceTone': 'Voice & tone',
  'brandDetail.imageryLayout': 'Imagery & layout',
  'brandDetail.images': 'Images',
  'brandDetail.designSystem': 'Design system',
  'brandDetail.brandAssets': 'Design system assets',
  'brandDetail.openProject': 'Open project',
  'brandDetail.themeLight': 'Light',
  'brandDetail.themeDark': 'Dark',
  'brandDetail.subjects': 'Subjects',
  'brandDetail.treatment': 'Treatment',
  'brandDetail.useLabel': 'Use',
  'brandDetail.avoidLabel': 'Avoid',
  'brandDetail.layoutPosture': 'Layout posture',
  'brandDetail.deleteConfirm': 'Delete "{name}"? This removes the design system.',
  'brandDetail.viewMore': 'Show all {count}',
  'brandDetail.viewLess': 'Show less',
  'settings.resetOnboarding': 'Reset onboarding',
  'settings.resetOnboardingDesc': 'Replay the first-run setup, including brand extraction.',
  'settings.resetOnboardingButton': 'Reset',
  'settings.clearUpdaterCacheTitle': 'Clear update cache',
  'settings.clearUpdaterCacheHint': 'Removes downloaded updates and stale updater caches, then resets update state. Use this when updates appear stuck.',
  'settings.clearUpdaterCacheButton': 'Clear cache',
  'settings.clearUpdaterCacheConfirmButton': 'Confirm clear',
  'settings.clearUpdaterCacheSuccess': 'Update cache cleared.',
  'settings.clearUpdaterCacheFailed': 'Couldn\'t clear the update cache.',
  'onboarding.brandTitle': 'Extract your design system',
  'onboarding.brandSubtitle': 'Paste a website and we\'ll turn its brand signals into a reusable design system for future work.',
  'onboarding.brandSkip': 'Skip',
  'onboarding.brandDone': 'Design system extracted',
  'onboarding.buildTitle': 'Create once, build everywhere',
  'onboarding.buildBody': 'OpenDesign turns your brand into a reusable design system — then keeps everything you build on-brand and consistent.',
  'onboarding.buildBenefitMemoryTitle': 'One brand memory',
  'onboarding.buildBenefitMemoryBody': 'Colors, type, spacing, components, and voice become a DESIGN.md your agents can reuse.',
  'onboarding.buildBenefitAlignedTitle': 'Every output stays aligned',
  'onboarding.buildBenefitAlignedBody': 'Prototype, slide, PDF, dashboard, and marketing work all pull from the same rules.',
  'onboarding.buildBenefitSourcesTitle': 'Start from what you have',
  'onboarding.buildBenefitSourcesBody': 'Use a GitHub repo, website, existing DESIGN.md, screenshots, fonts, or Figma files.',
  'onboarding.buildPreviewLabel': 'Brand system',
  'onboarding.buildStart': 'Build a design system',
  'onboarding.buildHome': 'Go to home',
  'dsCreate.referenceLabel': 'Copy from existing design system',
  'dsCreate.referenceLoading': 'Loading DESIGN.md...',
  'dsCreate.referenceLoadFailed': 'Could not load that design system.',
  'dsCreate.heroShowGuideAria': 'Show design system guide',
  'dsCreate.heroHideGuideAria': 'Hide design system guide',
  'dsCreate.heroShowGuideTitle': 'Show guide',
  'dsCreate.heroHideGuideTitle': 'Hide guide',
  'dsCreate.heroGuide': 'Guide',
  'dsCreate.missingSourceError': 'Add a website, DESIGN.md, description, file, Figma source, or notes to create a design system.',
  'dsCreate.continueToGeneration': 'Continue to generation',
  'dsCreate.embeddedTitle': 'Generate from your material',
  'dsCreate.embeddedBody': 'Start with a website or brand reference, then add any source files you already have.',
  'dsCreate.sourceSectionTitle': 'Extract from GitHub, websites, or source material',
  'dsCreate.sourceSectionBody': 'Start with a GitHub repo, website, DESIGN.md, or files that show your style. OpenDesign first creates a usable system quickly, then AI can refine it inside the project.',
  'dsCreate.githubWebsiteLabel': 'GitHub or website',
  'dsCreate.add': 'Add',
  'dsCreate.startFromBrand': 'Start from a brand',
  'dsCreate.brandPickerSubtitle': 'Search hundreds of brands — pick one and we\'ll add its site as a style reference.',
  'dsCreate.brandPickerQuickPicks': 'Popular brands — click to add',
  'dsCreate.addedSourceLinks': 'Added source links',
  'dsCreate.openSourceLabel': 'Open {label}',
  'dsCreate.removeSourceLabel': 'Remove {label}',
  'dsCreate.addFiles': 'Add files',
  'dsCreate.describeBrand': 'Describe brand',
  'dsCreate.optional': 'optional',
  'dsCreate.describeBrandHelp': 'Brand voice, intro and product context. Used in the fast pass and AI refinement.',
  'dsCreate.companyPlaceholder': 'e.g. Mission Impastabowl: fast-casual pasta restaurant with kiosk, mobile app and website',
  'dsCreate.pasteDesignMd': 'Paste DESIGN.md',
  'dsCreate.pasteDesignMdHelp': 'Paste a DESIGN.md to create directly from tokens, rationale and component guidance.',
  'dsCreate.reference': 'Reference',
  'dsCreate.designMdViewMode': 'DESIGN.md view mode',
  'dsCreate.advancedToggle': 'Advanced — repo, local code, Figma',
  'dsCreate.githubRepo': 'GitHub repo',
  'dsCreate.localCodeLabel': 'Link local code',
  'dsCreate.localCodeHelper': 'Use a folder or selected files from this computer.',
  'dsCreate.localCodePrompt': 'Drag a folder here or browse',
  'dsCreate.uploadFigLabel': 'Upload .fig',
  'dsCreate.uploadFigHelper': 'Decoded on your machine into real tokens, components & assets — no Figma account.',
  'dsCreate.uploadFigPrompt': 'Drop .fig here or browse',
  'dsCreate.figmaUrl': 'Figma URL',
  'dsCreate.figmaPlaceholder': 'https://figma.com/design/… or /file/…',
  'dsCreate.addedFigmaUrls': 'Added Figma URLs',
  'dsCreate.savedFigmaHelp': 'Saved as a Figma design source. The agent uses it as the canonical reference; export a .fig above for a full offline decode.',
  'dsCreate.notes': 'Notes',
  'dsCreate.notesPlaceholder': 'e.g. We use a warm, earthy color palette with rounded corners. Our brand voice is playful but professional...',
  'dsCreate.back': 'Back',
  'dsCreate.generate': 'Generate',
  'dsCreate.libraryPickerTitle': 'Select from library',
  'dsCreate.libraryPickerConfirm': 'Add to assets',
  'dsCreate.designMdPreviewKicker': 'DESIGN SYSTEM',
  'dsCreate.designMdPreviewTitle': 'DESIGN.md preview',
  'dsCreate.componentKit': 'component kit',
  'dsCreate.defaultTheme': 'default theme',
  'dsCreate.componentKitTitle': '{name} — component kit',
  'dsCreate.designMdGeneratedDescription': 'Generated from pasted DESIGN.md tokens, rationale and component guidance.',
  'dsCreate.previewButtons': 'Buttons',
  'dsCreate.previewButtonsHelp': 'Five types across three sizes.',
  'dsCreate.buttonPrimary': 'Primary',
  'dsCreate.buttonDashed': 'Dashed',
  'dsCreate.buttonText': 'Text',
  'dsCreate.buttonLink': 'Link',
  'dsCreate.sizeSmall': 'Small',
  'dsCreate.sizeMedium': 'Medium',
  'dsCreate.sizeLarge': 'Large',
  'dsCreate.previewTypeScale': 'Type scale',
  'dsCreate.extractedTokens': 'Extracted DESIGN.md tokens',
  'brandPicker.categorySoftware': 'Software',
  'brandPicker.categoryFinance': 'Finance',
  'brandPicker.categoryFashion': 'Fashion',
  'brandPicker.categoryActivewear': 'Activewear',
  'brandPicker.categoryBeauty': 'Beauty',
  'brandPicker.categoryWellness': 'Wellness',
  'brandPicker.categoryFood': 'Food',
  'brandPicker.categoryBeverage': 'Beverage',
  'brandPicker.categoryMedia': 'Media',
  'brandPicker.categoryEducation': 'Education',
  'brandPicker.categoryElectronics': 'Electronics',
  'brandPicker.categoryAutomotive': 'Automotive',
  'brandPicker.categoryHealthcare': 'Healthcare',
  'brandPicker.categoryTravel': 'Travel',
  'brandPicker.heading': 'Start from a brand you love',
  'brandPicker.subtext': 'Click any brand to extract its design system straight from its website.',
  'brandPicker.quickPicksLabel': 'Popular brands — click to extract',
  'brandPicker.searchPlaceholder': 'Search brands…',
  'brandPicker.allCategories': 'All',
  'brandPicker.extractAction': 'Extract',
  'brandPicker.showMore': 'Show more',
  'brandPicker.opening': 'Starting extraction — opening {brand}…',
  'ds.kitVisualize': 'Visualize',
  'ds.kitEdit': 'Edit',
  'ds.kitSource': 'Source',
  'ds.saveDesignMd': 'Save DESIGN.md',
  'ds.saving': 'Saving…',
  'ds.copyDesignMd': 'Copy DESIGN.md',
  'ds.editDesignMd': 'Edit DESIGN.md',
  'ds.openDesignMd': 'Open DESIGN.md',
  'ds.copyDesignMdModule': 'Copy {module} section',
  'ds.editDesignMdModule': 'Edit {module} section',
  'ds.openDesignMdModule': 'Open {module} section',
  'ds.uploadMd': 'Upload MD',
  'ds.uploadFont': 'Add font file',
  'ds.pasteImage': 'Paste image',
  'ds.refresh': 'Refresh',
  'ds.download': 'Download',
  'ds.importFolder': 'Import folder',
  'ds.reset': 'Reset',
  'ds.editingDesignMdHint': 'Editing this Markdown updates the rendered kit modules.',
  'ds.editingModuleHint': 'Editing only the {module} module.',
  'ds.manualEditModuleHint': 'Edit {module} here. Hover this section to reveal controls.',
  'ds.saveModule': 'Save module',
  'ds.uploadLogo': 'Upload logo',
  'ds.uploadImage': 'Upload image',
  'ds.uploading': 'Uploading…',
  'ds.moduleEmptyLogo': 'No logo yet',
  'ds.moduleEmptyFonts': 'No fonts captured.',
  'ds.actionDone': 'Done',
  'ds.actionFailed': 'Something went wrong. Please try again.',
  'ds.uploadDone': 'Uploaded',
  'ds.uploadFailed': 'Upload failed. Please try again.',
  'ds.deleteLogo': 'Delete logo',
  'ds.deleteImage': 'Delete {caption}',
  'ds.deleteProjectConfirm': 'Delete "{title}"? This permanently removes this design system and its project from this device.',
  'ds.deleteProjectAction': 'Delete {title}',
  'ds.editColor': 'Edit {name}',
  'ds.colorLabel': 'Color',
  'ds.hexLabel': 'Hex',
  'ds.hexValueLabel': 'Hex value',
  'ds.saveColor': 'Save color',
  'ds.invalidHexColor': 'Enter a valid hex color, such as #FF6A3D.',
  'ds.colorSaveFailed': 'Could not save this color.',
  'ds.colorResetFailed': 'Could not reset this color.',
  'ds.designMdSectionLabel': '{module} DESIGN.md section',
  'ds.kitErrorTitle': 'This view ran into a problem.',
  'ds.kitErrorRetry': 'Reload',
  'ds.shortcutsLabel': 'Keyboard shortcuts',
  'ds.shortcutsHint': 'Shortcuts: E edit · C copy · U upload · R refresh · ⌫ delete logo',
  'ds.moduleEmptyImages': 'No images yet',
  'ds.noOriginalColor': 'No original color is available for this swatch.',
  'ds.manifestReadFailed': 'Unable to read _ds_manifest.json.',
  'ds.reviewCollapseSection': 'Collapse {title}',
  'ds.reviewExpandSection': 'Expand {title}',
  'ds.reviewNeedsReview': 'Needs review',
  'ds.reviewLooksGood': 'Looks good',
  'ds.reviewActionsLabel': '{title} review',
  'ds.reviewNeedsWorkEllipsis': 'Needs work...',
  'ds.reviewEditFile': 'Edit {file}',
  'ds.reviewFeedbackLabel': 'Tell the agent what to change',
  'ds.reviewFeedbackPlaceholder': 'e.g. tighten spacing in {title}, regenerate this preview...',
  'ds.reviewChangedAfterFeedback': 'This section changed after your feedback. Review it again before publishing.',
  'ds.reviewChangedDuringRun': 'This section changed during the latest run. Review it before publishing.',
  'ds.reviewLastFeedback': 'Last feedback',
  'ds.previewGenerating': 'Generating preview...',
  'ds.creatingProjectTitle': 'Creating your design system...',
  'ds.creatingProjectSubtitle': 'Keep this tab open. You can come back in a few minutes.',
  'ds.generationProgressLabel': 'Design system generation progress {progress}%',
  'ds.publishRepoRequiredTitle': 'Finish importing your GitHub repo before you can publish.',
  'ds.publishDesignSystem': 'Publish design system',
  'ds.unpublishDesignSystem': 'Unpublish design system',
  'ds.published': 'Published',
  'ds.publish': 'Publish',
  'ds.extractionRunningTitle': 'Extracting design system',
  'ds.extractionCompleteTitle': 'Extraction complete',
  'ds.extractionRunningBody': 'OpenDesign is updating this system in place.',
  'ds.extractionCompleteBody': 'All extracted modules are shown below; empty sections are intentionally blank.',
  'ds.publishCardPublished': 'Your team\'s new projects can use this design system as context by default.',
  'ds.publishCardDraft': 'Your design system is ready, but your feedback will improve it. Publish it when it is ready to use in future projects.',
  'ds.useSystemTitle': 'Use this system',
  'ds.useSystemBody': 'Start a new design that inherits this system\'s colors, type, and components - kept on-brand automatically.',
  'ds.createNewDesign': 'Create new design',
  'ds.openSourceContext': 'Open source context',
  'ds.manifestNeedsAttention': 'Design manifest needs attention',
  'ds.openManifest': 'Open manifest',
  'ds.workspacePreparing': 'Preparing the design system workspace.',
  'ds.workspaceLoadingLabel': 'Design system workspace is loading',
  'ds.sectionQueued': 'Queued',
  'ds.sectionReviewUpdatedFiles': 'Updated files need review',
  'ds.reviewNeedsWork': 'Needs work',
  'ds.sectionRequiredFileMissing': 'Required file missing: {file}',
  'ds.sectionNoFilesYet': 'No files yet',
  'ds.generationSourceTitle': 'Source context',
  'ds.generationSourceDetail': 'Reading linked source context and repository evidence.',
  'ds.generationGuidanceTitle': 'Brand guidance',
  'ds.generationGuidanceDetail': 'Writing DESIGN.md guidance and voice.',
  'ds.generationTokensTitle': 'Design tokens',
  'ds.generationTokensDetail': 'Extracting colors, type, and spacing tokens.',
  'ds.generationPreviewsTitle': 'Preview cards',
  'ds.generationPreviewsDetail': 'Rendering reviewable preview cards.',
  'ds.generationUiKitTitle': 'UI kit',
  'ds.generationUiKitDetail': 'Creating reusable components and patterns.',
  'ds.generationAssetsTitle': 'Brand assets',
  'ds.generationAssetsDetail': 'Collecting logos, fonts, images, and icons.',
  'ds.phaseQueuedTypography': 'Typography queued',
  'ds.phaseQueuedTokens': 'Tokens queued',
  'ds.phaseQueuedSpacing': 'Spacing queued',
  'ds.phaseQueuedUiKit': 'UI kit queued',
  'ds.phaseQueuedAssets': 'Assets queued',
  'ds.phaseReadingTypography': 'Reading typography',
  'ds.phaseReadingTokens': 'Reading tokens',
  'ds.phaseReadingSpacing': 'Reading spacing',
  'ds.phaseReadingUiKit': 'Reading UI kit',
  'ds.phaseReadingAssets': 'Reading assets',
  'ds.phaseWritingTypography': 'Writing typography',
  'ds.phaseWritingTokens': 'Writing tokens',
  'ds.phaseWritingSpacing': 'Writing spacing',
  'ds.phaseBuildingUiKit': 'Building UI kit',
  'ds.phaseUpdatingAssets': 'Updating assets',
  'ds.phaseNeedsAttention': 'Needs attention',
  'ds.phaseUpdated': 'Updated',
  'ds.sectionActivityFromTodo': '{phase}: {todo}',
  'ds.sectionActivityReadFiles': 'Read {files}',
  'ds.sectionActivityPhaseFiles': '{phase}: {files}',
  'ds.sectionRunningReadingContext': 'Reading context for {title}.',
  'ds.sectionRunningNow': '{phase} now.',
  'ds.reviewLastReviewed': 'Last reviewed {time}',
  'ds.agentFeedbackQueued': 'Agent feedback queued',
  'ds.agentFeedbackSent': 'Agent feedback sent',
  'ds.agentFeedbackSentAt': 'Agent feedback sent {time}',
  'ds.agentFeedbackFailedWithError': 'Agent feedback failed: {error}',
  'ds.agentFeedbackFailed': 'Agent feedback failed',
  'ds.agentFeedbackUnknown': 'Agent feedback status unknown',
  'ds.repoConnectBannerTitle': 'Connect your repo to pull aspects of your design system',
  'ds.repoConnectCardTitle': 'Connect your repo',
  'ds.repoConnectPendingBody': 'Checking your GitHub connection...',
  'ds.repoConnectPendingButton': 'Checking GitHub...',
  'ds.repoConnectedTitle': 'GitHub is connected',
  'ds.repoConnectedBody': 'Re-import this repo to pull its files into your design system.',
  'ds.repoImportButton': 'Import repo',
  'ds.repoConnectBannerBody': 'Connect GitHub so OpenDesign can read your repository and pull colors, type, and components into this design system.',
  'ds.repoConnectCardBody': 'Pull colors, type, and components from your repository into this design system.',
  'ds.repoConnectButton': 'Connect GitHub',
  // Settings > Workspace region (E-frontend, D4.3): role-gated shell for
  // other-lane workspace destinations (members / billing / team space).
  'settings.workspace': 'Workspace',
  'settings.workspaceHint': 'Members, billing, and team spaces',
  'settings.workspaceLede': 'Team-level settings for this workspace. These areas are managed by the team service — open one to continue.',
  'settings.workspaceBack': 'Back to workspace',
  'settings.workspaceMembers': 'Members & invites',
  'settings.workspaceMembersHint': 'Manage who can access this workspace and send invitations.',
  'settings.workspaceBilling': 'Subscription & seats',
  'settings.workspaceBillingHint': 'Plan, seats, and payment for this workspace.',
  'settings.workspaceAutoRecharge': 'Auto-recharge',
  'settings.workspaceAutoRechargeHint': 'Automatically top up credits when the balance runs low.',
  'settings.workspaceTeamSpace': 'Team space',
  'settings.workspaceTeamSpaceHint': 'Shared projects and visibility for your team.',
  // Full-page Settings (`/settings`): sidebar nav head above the section list.
  'settings.pageBackToHome': 'Back to home',
  'settings.pageNavGroupPersonal': 'Personal',
  'newproj.startFromLabel': 'Start from',
  'newproj.startBlank': 'Blank',
  'newproj.startBlankHint': 'Start from scratch',
  'workspace.pages': 'Pages',
  'workspace.allProjectFiles': 'All project files',
  'workspace.newBlankPage': 'New blank page',
  'workspace.noPagesYet': 'No pages yet',
  'workspace.pageCreateFailed': 'Could not create the page.',
  'workspace.pageCreatorTitle': 'Create page',
  'workspace.pageCreatorSearch': 'Search templates',
  'workspace.pageCreatorCategoryAll': 'All scenes',
  'workspace.pageCreatorEmpty': 'No page types match your search.',
  'workspace.pageCreatorPreview': 'Preview',
  'workspace.pageCreatorUse': 'Use',
  'fileViewer.presentInTabDeckHint': 'Speaker notes in popup window',
  'fileViewer.presentEscHint': 'Press Esc to exit',
  'fileViewer.presenterPause': 'Pause',
  'fileViewer.presenterResume': 'Resume',
  'fileViewer.presenterPrevious': 'Previous',
  'fileViewer.presenterNext': 'Next',
  'questions.uploadingFiles': 'Uploading files…',
  'questions.uploadNeedsProject': 'File upload needs an active project.',
  'questions.uploadPartialFailed': 'Uploaded {uploaded} file(s), but {failed} failed.',
  'questions.uploadFailed': 'File upload failed for {failed} file(s).',
  // #5517 media-providers redesign: pill selector + single detail card.
  'settings.mediaProviderModelProviders': 'Providers',
  'settings.mediaProviderModel': 'Model',
  'settings.mediaProviderModelPlaceholder': 'Use provider default',
  'settings.mediaProviderDocsTitle': 'Documentation',
  'settings.mediaProviderDocsHint': 'View setup instructions for this provider.',
  'settings.mediaProviderSaveHint': 'Changes are not saved until you select Save.',
  'settings.mediaProviderNoKeyRequired': 'No key required',
  'settings.mediaProviderNoKeyHint': 'This provider uses a local login or bundled runtime.',
  'manualEdit.sectionImage': 'IMAGE',
  'manualEdit.sectionContent': 'CONTENT',
  'manualEdit.sectionPage': 'PAGE',
  'manualEdit.pageBackground': 'Background',
  'manualEdit.pageBaseSize': 'Base size',
  'manualEdit.pageStylesHtmlOnly': 'Page styles are available only for full HTML documents.',
  'pluginsView.createKindPlugin': 'Plugin',
  'pluginsView.createKindSkill': 'Skill',
  'pluginsView.importUrlLabel': 'URL',
  'pluginsView.shareActionBadge': 'Action plugin',
  'pluginsView.shareCloseAria': 'Close share confirmation',
  'pluginsView.shareWhatStarts': 'What this starts',
  'pluginsView.shareSourcePlugin': 'Source plugin',
  'pluginsView.shareFactPlugin': 'Plugin',
  'pluginsView.shareFactId': 'ID',
  'pluginsView.shareFactCopiedTo': 'Copied to',
  'pluginsView.shareFactTrust': 'Trust',
  'pluginsView.shareActionPrompt': 'Action prompt',
  'pluginsView.shareStarting': 'Starting…',
  'community.title': 'Community',
  'community.searchPlaceholder': 'Search',
  'community.searchAria': 'Search',
  'community.filtersAria': 'Template filters',
  'community.closePreview': 'Close preview',
  'community.typePrototype': 'Prototype',
  'community.typeLiveArtifact': 'Live Artifact',
  'community.typeSlides': 'Slides',
  'community.typeDocument': 'Document',
  'community.typeImage': 'Image',
  'community.typeVideo': 'Video',
  'community.typeHyperFrames': 'HyperFrames',
  'community.typeAudio': 'Audio',
  'community.typeWebGL': 'WebGL',
  'community.usePrompt': 'Try it now',
  'community.emptyTitle': 'No {type} templates yet',
  'community.emptyBody': 'Templates published to the community will show up here.',
  'marketplace.title': 'Plugins marketplace',
  'marketplace.filterTrusted': 'Trusted',
  'marketplace.filterRestricted': 'Restricted',
  'marketplace.emptyBefore': 'No plugins installed yet. Try',
  'marketplace.emptyAfter': ', or register a marketplace below.',
  'marketplace.trustPrefix': 'trust: ',
  'marketplace.catalogsTitle': 'Configured catalogs',
  'marketplace.catalogsEmpty': 'None registered. Add one with',
  'marketplace.pluginCount': '{count} plugin(s)',
  'genui.continue': 'Continue',
  'genui.authorize': 'Authorize',
  'genui.skip': 'Skip',
  'genui.acceptAll': 'Accept all',
  'genui.rejectAll': 'Reject all',
  'genui.submit': 'Submit',
  'genui.submitPartial': 'Submit partial decision',
  'genui.patchNotesPlaceholder': 'Notes for the patch author (optional)',
  'inspect.close': 'Close inspect',
  'inspect.colors': 'Colors',
  'inspect.text': 'Text',
  'inspect.background': 'Background',
  'inspect.typography': 'Typography',
  'inspect.size': 'Size',
  'inspect.weight': 'Weight',
  'inspect.align': 'Align',
  'inspect.padding': 'Padding',
  'inspect.radius': 'Radius',
  'inspect.resetElement': 'Reset element',
  'library.title': 'Library',
  'library.headerHint': 'Clip any page, design system, screenshot, image, or Figma import JSON into your Library — local-first, one click, no login.',
  'library.getClipper': 'Get the OpenDesign Web Clipper',
  'library.searchPlaceholder': 'Search captions, tags, titles…',
  'library.filterByKind': 'Filter by kind',
  'library.filterBySource': 'Filter by source',
  'library.kindAll': 'All kinds',
  'library.kindImages': 'Images',
  'library.kindElements': 'Elements',
  'library.kindDesignSystems': 'Design systems',
  'library.kindVideo': 'Video',
  'library.kindFonts': 'Fonts',
  'library.kindColors': 'Colors',
  'library.kindText': 'Text',
  'library.kindLinks': 'Links',
  'library.sourceAll': 'All sources',
  'library.sourceClipper': 'Clipper',
  'library.sourceAgent': 'Agent',
  'library.sourceDesignSystem': 'Design system',
  'library.sourceGenerated': 'Generated',
  'library.viewMode': 'View mode',
  'library.viewGrid': 'Grid',
  'library.viewGridTooltip': 'Show assets as a grid',
  'library.viewTimeline': 'Timeline',
  'library.viewTimelineTooltip': 'Group assets by day, newest first',
  'library.refresh': 'Refresh',
  'library.refreshTooltip': 'Reload the list with the current filters',
  'library.sync': 'Sync',
  'library.syncing': 'Syncing…',
  'library.syncTooltip': 'Pull your design systems and agent-generated artifacts into the Library',
  'library.upload': 'Upload',
  'library.uploadTooltip': 'Upload images, fonts, or files into the Library',
  'library.selectedCount': '{count} selected',
  'library.selectAll': 'Select all',
  'library.clear': 'Clear',
  'library.chatToDesign': 'Chat to design',
  'library.chatToDesignTitle': 'Start a chat to turn {count} into a design',
  'library.working': 'Working…',
  'library.useInDesignSystem': 'Use in design system',
  'library.createDesignSystem': 'Create new design system',
  'library.createDesignSystemSub': 'Open the create flow with these {count} attached',
  'library.refineExisting': 'Refine existing',
  'library.noEditableDesignSystems': 'No editable design systems yet.',
  'library.addAssetsAndRefine': 'Add assets & open to refine',
  'library.deleteCount': 'Delete {count}',
  'library.loading': 'Loading…',
  'library.emptyTitle': 'No assets yet.',
  'library.emptyHintBefore': 'Clip from any page with the OpenDesign Web Clipper, run',
  'library.emptyHintAfter': ', or upload inside a project — everything lands here.',
  'library.dropToUpload': 'Drop to upload to your Library',
  'library.confirmDeleteTitleOne': 'Delete {count} asset?',
  'library.confirmDeleteTitleMany': 'Delete {count} assets?',
  'library.confirmDeleteBodyOne': 'This permanently removes it from your Library. This can’t be undone.',
  'library.confirmDeleteBodyMany': 'This permanently removes them from your Library. This can’t be undone.',
  'library.cancel': 'Cancel',
  'library.today': 'Today',
  'library.yesterday': 'Yesterday',
  'library.previewAsset': 'Preview {title}',
  'library.selectAsset': 'Select asset',
  'library.deselectAsset': 'Deselect asset',
  'library.openDesignSystem': 'Open design system',
  'library.openProject': 'Open project',
  'library.opening': 'Opening…',
  'library.editAsPage': 'Edit as page',
  'library.viewSource': 'Source',
  'library.remove': 'Remove',
  'mcp.aboutTemplate': 'About {name}',
  'mcp.approvedRefresh': 'I’ve approved — Refresh',
  'mcp.approveInBrowserHint': 'Approve in the browser tab that opened. We\'ll catch the callback automatically — or click Refresh below if you completed it already.',
  'mcp.argsPlaceholder': 'space-separated',
  'mcp.authModeNone': 'No managed OAuth',
  'mcp.authModeOAuth': 'Managed OAuth',
  'mcp.browserDidntOpen': 'Browser didn\'t open?',
  'mcp.categoryDataViz': 'Data viz',
  'mcp.categoryDataVizHint': 'Charts and diagrams as proper image artifacts.',
  'mcp.categoryDesignSystems': 'Design systems',
  'mcp.categoryDesignSystemsHint': 'Figma read/write, design-token translation, brand inspiration.',
  'mcp.categoryImageEditing': 'Image editing',
  'mcp.categoryImageEditingHint': 'Local post-processing, OCR and CV-driven edits.',
  'mcp.categoryImageGeneration': 'Image generation',
  'mcp.categoryImageGenerationHint': 'Models that produce raster, vector or video assets.',
  'mcp.categoryPublishing': 'Publishing',
  'mcp.categoryPublishingHint': 'Push generated artifacts to a public URL.',
  'mcp.categoryUiComponents': 'UI components',
  'mcp.categoryUiComponentsHint': 'Designer-grade components, blocks and landing-page material.',
  'mcp.categoryUtilities': 'Utilities',
  'mcp.categoryUtilitiesHint': 'Filesystem, fetch, GitHub and similar generic tools.',
  'mcp.categoryWebCapture': 'Web capture',
  'mcp.categoryWebCaptureHint': 'Render a URL into an image so the agent can see what it built.',
  'mcp.checking': 'Checking…',
  'mcp.clickConnectHint': 'Click Connect to grant OpenDesign access via the provider\'s OAuth flow.',
  'mcp.closePicker': 'Close picker',
  'mcp.collapse': 'Collapse',
  'mcp.collapseServerAria': 'Collapse this MCP server',
  'mcp.commandPlaceholder': 'e.g. npx, node, /path/to/binary',
  'mcp.commandRequired': 'Command is required for stdio transport.',
  'mcp.completedAuthTitle': 'I\'ve completed authorization — check connection status now',
  'mcp.connect': 'Connect',
  'mcp.connected': 'Connected.',
  'mcp.connecting': 'Connecting…',
  'mcp.customServer': 'Custom server',
  'mcp.customServerDesc': 'Empty form. Pick stdio or SSE / HTTP and fill the fields yourself.',
  'mcp.disabled': 'Disabled',
  'mcp.disconnect': 'Disconnect',
  'mcp.disconnectFailed': 'Disconnect failed. Check daemon logs.',
  'mcp.disconnecting': 'Disconnecting…',
  'mcp.displayNamePlaceholder': 'Display name (optional)',
  'mcp.enabled': 'Enabled',
  'mcp.enableServerAria': 'Enable this MCP server',
  'mcp.expand': 'Expand',
  'mcp.expandServerAria': 'Expand this MCP server',
  'mcp.expandToEdit': 'Expand to edit',
  'mcp.fieldArgs': 'Args',
  'mcp.fieldCommand': 'Command',
  'mcp.fieldEnv': 'Env (KEY=VALUE)',
  'mcp.fieldEnvShort': 'Env',
  'mcp.fieldHeaders': 'Headers (KEY=VALUE)',
  'mcp.fieldId': 'ID',
  'mcp.fieldOAuthMode': 'OAuth mode',
  'mcp.fieldTransport': 'Transport',
  'mcp.fieldUrl': 'URL',
  'mcp.homepage': 'Homepage',
  'mcp.idInvalid': 'ID must start with a letter or digit and only contain letters, digits, dash, or underscore (max 64 chars).',
  'mcp.jsonHelperExampleHead': 'Example MCP JSON',
  'mcp.jsonHelperHttpNote': 'use url + headers instead of command / args',
  'mcp.jsonHelperToggle': 'Need help? Map your MCP server\'s JSON config using the example below.',
  'mcp.moveDown': 'Move down',
  'mcp.moveUp': 'Move up',
  'mcp.noManagedOAuth': 'No managed OAuth.',
  'mcp.noManagedOAuthSaveDirect': 'Save this server and OpenDesign will use it directly.',
  'mcp.noManagedOAuthUseAsConfigured': 'OpenDesign will use this server as configured. Add headers below if the server needs a token.',
  'mcp.nonExpiringToken': 'Non-expiring token.',
  'mcp.notConnected': 'Not connected.',
  'mcp.openAuthorizationPage': 'Open authorization page',
  'mcp.pickerFilterPlaceholder': 'Filter by name, transport, capability…',
  'mcp.pickerHint': 'Pre-fills the form. You can still edit any field after.',
  'mcp.pickerNoMatch': 'No templates match “{query}”. Try clearing the filter or use the custom server option below.',
  'mcp.pickTemplate': 'Pick a template',
  'mcp.reauthenticateTitle': 'Reauthenticate (replaces the existing token)',
  'mcp.recheckTokenTitle': 'Re-check token status against the daemon',
  'mcp.reconnect': 'Reconnect',
  'mcp.refresh': 'Refresh',
  'mcp.removeServer': 'Remove this MCP server',
  'mcp.saveFirstThenClick': 'Save first, then click',
  'mcp.starting': 'Starting…',
  'mcp.toGrantOAuthAccess': 'to grant OpenDesign access via the provider\'s OAuth flow.',
  'mcp.tokenExpires': 'Token expires {time}.',
  'mcp.transportAria': 'Transport: {transport}',
  'mcp.tryLabel': 'Try:',
  'mcp.tryPromptTitle': 'Paste this prompt into the chat composer to try the server end-to-end',
  'mcp.unnamedServer': 'Unnamed MCP server',
  'mcp.urlMalformed': 'URL is malformed.',
  'mcp.urlProtocolInvalid': 'URL must use http:// or https://.',
  'mcp.urlRequired': 'URL is required for SSE / HTTP transport.',
  'mcp.waitingForAuthorization': 'Waiting for authorization…',
  'memory.connectorReadFailed': 'Couldn\'t read {name}.',
  'memory.connectorNoReadableContent': 'No readable content from {name}.',
  'memory.providerLocalCli': 'Local CLI',
  'memory.providerFallbackName': 'Memory model',
  'memory.extractionSourceConnector': 'Connected apps were read, but OpenDesign could not turn that context into memory.',
  'memory.extractionSourceChat': 'OpenDesign could not run memory extraction for this chat.',
  'memory.failureAuthExpiredTitle': '{provider} authentication expired',
  'memory.failureAuthActionCli': 'Sign in to the selected Local CLI or choose a different Memory model.',
  'memory.failureAuthActionKey': 'Update the Memory extraction model key or sign in again.',
  'memory.failureQuotaTitle': '{provider} quota or rate limit hit',
  'memory.failureQuotaAction': 'Try again later or switch the Memory extraction model.',
  'memory.failureRequestTitle': '{provider} request failed',
  'memory.failureRequestActionCli': 'Check the selected Local CLI and try again.',
  'memory.failureRequestActionProvider': 'Check the model provider connection and try again.',
  'memory.failureGenericTitle': 'Memory extraction failed',
  'memory.failureGenericActionCli': 'Try again after checking the selected Local CLI.',
  'memory.failureGenericActionSettings': 'Try again after checking the Memory extraction model settings.',
  'memory.noData': 'No data',
  'memory.attemptReadTitle': 'Read {name}',
  'memory.attemptFailedTitle': 'Could not read {name}',
  'memory.attemptSkippedTitle': 'Skipped {name}',
  'memory.skipChatDisabled': 'Chat conversation learning is off.',
  'memory.kindConnectedApps': 'Connected apps',
  'memory.timeAgo': '{time} ago',
  'memory.scanRunningTitle': 'Scanning connected apps',
  'memory.scanFailedTitle': 'Connected app scan failed',
  'memory.scanSkippedTitle': 'Connected app scan skipped',
  'memory.scanSavedOne': 'Saved {count} memory',
  'memory.scanSavedOther': 'Saved {count} memories',
  'memory.scanNoNewMemories': 'No new memories found',
  'memory.scanTitle': 'Connected app scan',
  'memory.scanMetaChecking': 'Checking selected apps',
  'memory.scanMetaNeedsAttention': 'Needs attention',
  'memory.scanMetaFromConnectedApps': 'From connected apps',
  'memory.scanMetaCheckedApps': 'Checked selected apps',
  'memory.scanBusyLabel': 'Scanning apps',
  'memory.scanSelectPrompt': 'Select apps to scan',
  'memory.scanSelectedApps': 'Scan selected apps',
  'memory.connectorReadFailedRetry': 'Could not read connected apps. Try again from the Connectors tab.',
  'memory.appCountOne': '{count} app',
  'memory.appCountOther': '{count} apps',
  'memory.foundSuggestionsOne': 'Found {count} suggested memory from {apps}. Review before saving.',
  'memory.foundSuggestionsOther': 'Found {count} suggested memories from {apps}. Review before saving.',
  'memory.noSuggestionsFound': 'No memory suggestions found. OpenDesign could not read useful content from the selected app yet.',
  'memory.checkedNoSuggestionsOne': 'Checked {count} selected app, but found no new memory suggestions.',
  'memory.checkedNoSuggestionsOther': 'Checked {count} selected apps, but found no new memory suggestions.',
  'memory.savedFromConnectedAppsOne': 'Saved {count} memory from connected apps.',
  'memory.savedFromConnectedAppsOther': 'Saved {count} memories from connected apps.',
  'memory.savedPartial': 'Saved {saved} of {total} selected memories. Please try the remaining items again.',
  'memory.tabManual': 'Add manually',
  'memory.tabManualCaption': 'Write a fact or preference',
  'memory.tabConnected': 'Import from apps',
  'memory.tabConnectedCaption': 'Scan connected tools',
  'memory.storagePathAria': 'Memory storage path — click to copy',
  'memory.flowOnboarding': 'Onboarding',
  'memory.flowBrandContext': 'Brand context',
  'memory.flowChatSignals': 'Chat signals',
  'memory.flowSavedMemory': 'Saved memory',
  'memory.howCopy': 'Memory is gathered automatically from profile setup, project and brand extraction, connected apps, and useful facts learned during chats. The saved list below is the review surface; everything else stays quiet unless you open Add or Advanced.',
  'memory.areasAria': 'Memory areas',
  'memory.manualPanelHint': 'Add facts, preferences, or project context yourself. Fixed assistant behavior lives in Instructions & rules.',
  'memory.connectedPanelHint': 'Choose apps to scan for design preferences, project context, and visual references. Nothing is scanned until you select an app.',
  'memory.loading': 'Loading',
  'memory.connectedCount': '{count} connected',
  'memory.manage': 'Manage',
  'memory.chooseSources': 'Choose sources',
  'memory.chooseSourcesHint': 'Select connected apps first. OpenDesign only scans the apps you choose.',
  'memory.selectedCount': '{count} selected',
  'memory.connectorListAria': 'Connected memory apps',
  'memory.readToolsCount': '{count} read tools',
  'memory.checkingConnectionStatus': 'Checking connection status…',
  'memory.finishAuthorization': 'Finish authorization in your browser, then return here',
  'memory.connectBeforeExtraction': 'Connect this app before extraction',
  'memory.useConnectorAria': 'Use {name} for memory extraction',
  'memory.selected': 'Selected',
  'memory.select': 'Select',
  'memory.reconnectConnectorAria': 'Reconnect {name}',
  'memory.connectConnectorAria': 'Connect {name}',
  'memory.connectStateChecking': 'Checking',
  'memory.connectStateWaiting': 'Waiting',
  'memory.connectStateConnecting': 'Connecting',
  'memory.reconnect': 'Reconnect',
  'memory.selectedOfConnectedOne': 'Selected {count} of {total} connected app.',
  'memory.selectedOfConnectedOther': 'Selected {count} of {total} connected apps.',
  'memory.suggestedMemories': 'Suggested memories',
  'memory.suggestedMemoriesHint': 'Review design-related memories before saving them.',
  'memory.saving': 'Saving',
  'memory.saveSelected': 'Save selected',
  'memory.discard': 'Discard',
  'memory.diagnosticsAria': 'Connected app read status',
  'memory.lastScan': 'Last scan',
  'memory.bytesRead': '{bytes} read',
  'memory.recentScans': 'Recent scans',
  'memory.runHistoryAria': 'Connected app memory run status',
  'memory.savedMemoryHint': 'Saved facts, preferences, and project context available to future chats.',
  'memory.savedCount': '{count} saved',
  'memory.extractionCountOne': '{count} extraction',
  'memory.extractionCountOther': '{count} extractions',
  'memory.emptyHintBefore': 'Tell the assistant a fact in chat — e.g.',
  'memory.emptyHintAfter': '— and it will be saved here automatically.',
  'memory.advancedHint': 'Inspect or edit the underlying memory index.',
  'memory.memoryTree': 'Memory tree',
  'memory.memoryTreeHint': 'Technical view of the same saved memories. Most users only need the saved-memory list above.',
  'memory.nodeCountOne': '{count} node',
  'memory.nodeCountOther': '{count} nodes',
  'dsCreate.addingSourceMaterial': 'Adding source material...',
  'dsCreate.browseFolder': 'Browse folder',
  'dsCreate.confirmBody': 'You\'ll land in a project that fills in live — logo, palette, typography, imagery — as it measures your brand. Keep the tab open.',
  'dsCreate.confirmTitle': 'OpenDesign will extract your design system.',
  'dsCreate.designMdPreviewFallbackName': 'Design system',
  'dsCreate.dropZoneSelections': '{label} selections',
  'dsCreate.extractDesignSystem': 'Extract design system',
  'dsCreate.extractionAlreadyStarting': 'Extraction is already starting. Please wait for the current request to finish.',
  'dsCreate.figmaFileFallbackLabel': 'Figma file',
  'dsCreate.figmaUrlInvalid': 'Enter a Figma file URL (https://figma.com/file/… or /design/…).',
  'dsCreate.githubAccessAutoBody': 'GitHub repo links use the first working access method; other website links are saved as source references.',
  'dsCreate.githubAccessAutoTitle': 'GitHub access: Auto',
  'dsCreate.githubAccessMethodsAria': 'GitHub repository access methods',
  'dsCreate.githubAuthorizeFailed': 'Could not start GitHub authorization.',
  'dsCreate.githubBadgeAutomatic': 'Automatic',
  'dsCreate.githubBadgeChecking': 'Checking',
  'dsCreate.githubBadgeComingSoon': 'Coming soon',
  'dsCreate.githubBadgeConnected': 'Connected',
  'dsCreate.githubBadgeNeedsAttention': 'Needs attention',
  'dsCreate.githubBadgeNotConfigured': 'Not configured',
  'dsCreate.githubBadgeOptional': 'Optional',
  'dsCreate.githubBadgePending': 'Pending',
  'dsCreate.githubComposioCheckingDesc': 'Checking connector status in the background; URL intake is not blocked.',
  'dsCreate.githubComposioConnectedAsDesc': 'Composio GitHub connector connected as {account}; it is available as fallback when this device cannot read the repository.',
  'dsCreate.githubComposioConnectedDesc': 'Composio GitHub connector is available as fallback when this device cannot read the repository.',
  'dsCreate.githubComposioDefaultDesc': 'Composio GitHub connector access for agent tools; repo URLs still work with local git or GitHub CLI.',
  'dsCreate.githubComposioErrorDesc': 'Reconnect the Composio GitHub connector, or continue with local git/GitHub CLI.',
  'dsCreate.githubComposioNotConfiguredDesc': 'Add a Composio API key only if this project needs connector-backed GitHub tools.',
  'dsCreate.githubComposioPendingDesc': 'Finish the Composio authorization window; local GitHub intake remains available.',
  'dsCreate.githubConfigureComposio': 'Configure Composio',
  'dsCreate.githubConnecting': 'Connecting...',
  'dsCreate.githubConnectorCheckFailed': 'Could not check the GitHub connector.',
  'dsCreate.githubConnectorCheckTimeout': 'Could not finish checking GitHub connector. You can still add repository URLs or connect GitHub manually.',
  'dsCreate.githubConnectViaComposio': 'Connect via Composio',
  'dsCreate.githubDisconnect': 'Disconnect',
  'dsCreate.githubDisconnectFailed': 'Could not disconnect GitHub.',
  'dsCreate.githubDisconnecting': 'Disconnecting...',
  'dsCreate.githubHideAccessMethods': 'Hide access methods',
  'dsCreate.githubMethodConnectorPlatform': 'Connector platform',
  'dsCreate.githubMethodOdAccount': 'OpenDesign account',
  'dsCreate.githubMethodOdAccountDesc': 'Native GitHub sign-in managed by OpenDesign; this build does not use an OD-managed GitHub token yet.',
  'dsCreate.githubMethodThisDevice': 'This device',
  'dsCreate.githubMethodThisDeviceDesc': 'Uses public git clone, local git credentials, or GitHub CLI auth available on this machine.',
  'dsCreate.githubOpenAuthorization': 'Open authorization',
  'dsCreate.githubShowAccessMethods': 'Show access methods',
  'dsCreate.libraryPartiallyAdded': 'Added {added} of {total} item(s) from the library.',
  'dsCreate.localCodeFilesSelected': '{count} local code files selected',
  'dsCreate.prepareProjectFailed': 'Could not prepare the design system project.',
  'dsCreate.removeFile': 'Remove {name}',
  'dsCreate.startingExtraction': 'Starting extraction...',
  'dsFlow.activityDetailFailed': 'The chat message has the run details. You can adjust the request and try again.',
  'dsFlow.activityDetailReady': 'Review the updated Design System and Design Files tabs.',
  'dsFlow.activityDetailRunning': 'Watching project files and preparing the review draft.',
  'dsFlow.activityFailedTitle': 'Workspace update needs attention',
  'dsFlow.activityProgressAria': 'Workspace update progress {progress}%',
  'dsFlow.activityReadyTitle': 'Workspace update ready',
  'dsFlow.activityRunningTitle': 'OpenDesign is updating this system',
  'dsFlow.addBrandFonts': 'Add brand font files',
  'dsFlow.agentMsgCapturedDirection': 'Captured direction: {summary}',
  'dsFlow.agentMsgCreating': 'I am creating the design system workspace, preview cards, and supporting files from the context you provided.',
  'dsFlow.agentMsgReady': 'Your design system draft is ready. Review the Design System tab, inspect generated files, publish it, or ask me for changes here.',
  'dsFlow.agentMsgRevision': 'I am applying your feedback to the design system. You can keep reviewing the current draft while the revision runs.',
  'dsFlow.agentMsgTokenRebuild': 'I am preparing a token contract rebuild for review. The active contract will stay unchanged until the revision is accepted.',
  'dsFlow.agentPushLayer': 'Agent push layer',
  'dsFlow.assetsLabel': 'Assets',
  'dsFlow.auditNeedsRepair': '{summary} Review the audit details before running a repair.',
  'dsFlow.brandFontsMissingBody': 'Typography previews are using substitute web fonts until brand font files are added.',
  'dsFlow.brandFontsMissingTitle': 'Brand font files missing',
  'dsFlow.chatCreateRequest': 'Create design system',
  'dsFlow.chatSeedUpdateSystem': 'Update this design system: ',
  'dsFlow.composerPlaceholder': 'Follow-up action: use AI extraction to refine this system. Longer run; updates land here.',
  'dsFlow.conversationCreateFailed': 'Could not create a design system conversation.',
  'dsFlow.evidenceFallbackTokens': 'Fallback tokens',
  'dsFlow.evidenceFonts': 'Fonts',
  'dsFlow.evidenceIndexes': 'Evidence indexes',
  'dsFlow.evidenceScannedFiles': 'Scanned files',
  'dsFlow.evidenceSnippets': 'Snippets',
  'dsFlow.evidenceSourceTokens': 'Source tokens',
  'dsFlow.fileDraftPreview': 'File draft preview',
  'dsFlow.filesTouched': 'Files touched',
  'dsFlow.forceRebuild': 'Force',
  'dsFlow.generalRevision': 'General revision',
  'dsFlow.generationCompleted': 'Generation completed',
  'dsFlow.generationProgressAria': 'Generation progress {progress}%',
  'dsFlow.generationStopped': 'Generation stopped',
  'dsFlow.generationStoppedWithError': 'Generation stopped: {error}',
  'dsFlow.jobCompleted': '{noun} completed',
  'dsFlow.jobDetailGeneration': 'Preparing the remaining files.',
  'dsFlow.jobDetailReady': 'Review workspace is ready.',
  'dsFlow.jobDetailRevision': 'Applying your feedback.',
  'dsFlow.jobDetailTokenRebuild': 'Preparing a reviewable token contract draft.',
  'dsFlow.jobNeedsAttention': '{noun} needs attention',
  'dsFlow.jobNounGeneration': 'Generation',
  'dsFlow.jobNounRevision': 'Revision',
  'dsFlow.jobNounTokenRebuild': 'Token rebuild',
  'dsFlow.jobRebuildingTokens': 'OpenDesign is rebuilding tokens',
  'dsFlow.jobRevising': 'OpenDesign is revising',
  'dsFlow.jobStillWorking': 'OpenDesign is still working',
  'dsFlow.loadingDesignSystem': 'Loading design system...',
  'dsFlow.metaEvidenceNotes': 'Evidence notes',
  'dsFlow.metaScannedInventory': 'Scanned file inventory',
  'dsFlow.metaSnippetIndex': 'Snippet index',
  'dsFlow.metaTokenExtraction': 'Token extraction evidence',
  'dsFlow.metaTokenReport': 'Token contract quality report',
  'dsFlow.movedBackToDraft': 'Moved back to draft',
  'dsFlow.needsWorkSeed': 'Needs work on {title}: ',
  'dsFlow.no': 'No',
  'dsFlow.openingDesignSystemWorkspace': 'Opening the design system workspace...',
  'dsFlow.openingWorkspace': 'Opening the workspace...',
  'dsFlow.packageFallbackMeta': '{source} · DESIGN.md-only fallback',
  'dsFlow.packageLegacy': 'Legacy design system',
  'dsFlow.packageManifestMeta': '{source} · {mode} mode · manifest indexed',
  'dsFlow.packagePillFallback': 'Fallback',
  'dsFlow.packagePillReady': 'Hybrid ready',
  'dsFlow.packageStructured': 'Structured import package',
  'dsFlow.pendingRevision': 'Pending revision',
  'dsFlow.pickLocalAgentFirst': 'Pick a local agent first, then ask OpenDesign to update this design system.',
  'dsFlow.previewPages': 'Preview pages',
  'dsFlow.proposedChanges': 'Proposed changes',
  'dsFlow.publishCardReady': 'OpenDesign is ready for review. Give feedback on the work so far, then publish when it is useful for future projects.',
  'dsFlow.publishCardRevision': 'OpenDesign is applying your feedback. You can keep reviewing while the updated draft is prepared.',
  'dsFlow.publishCardTokenRebuild': 'OpenDesign is preparing a token contract rebuild for review. The active contract stays unchanged until you accept it.',
  'dsFlow.publishCardWorking': 'OpenDesign is still working, but you can start giving feedback on the work so far.',
  'dsFlow.pullLayer': 'Pull layer',
  'dsFlow.rebuildTokenContract': 'Rebuild token contract',
  'dsFlow.reviewDraftTitle': 'Review draft design system',
  'dsFlow.revisionAccept': 'Accept',
  'dsFlow.revisionAccepted': 'Revision accepted',
  'dsFlow.revisionAcceptFailed': 'Could not accept revision',
  'dsFlow.revisionHistory': 'Revision history',
  'dsFlow.revisionMsgAccepted': 'Accepted. The design system draft now includes this update.',
  'dsFlow.revisionMsgPending': 'I prepared a proposed update. Review the diff card on the right, then accept it or ask for another change.',
  'dsFlow.revisionMsgRejected': 'Rejected. I left the current design system unchanged.',
  'dsFlow.revisionProgressUnavailable': 'Could not read revision progress',
  'dsFlow.revisionReady': 'Revision ready for review',
  'dsFlow.revisionReject': 'Reject',
  'dsFlow.revisionRejected': 'Revision rejected',
  'dsFlow.revisionRejectFailed': 'Could not reject revision',
  'dsFlow.revisionStopped': 'Revision stopped',
  'dsFlow.revisionStoppedWithError': 'Revision stopped: {error}',
  'dsFlow.saveChangesFailed': 'Could not save changes',
  'dsFlow.savedDesignMd': 'Saved DESIGN.md',
  'dsFlow.sectionDraftBody': 'Draft body',
  'dsFlow.sectionFallbackTitle': 'Section',
  'dsFlow.sectionMarkedLooksGood': '{title} marked as looks good',
  'dsFlow.sectionNoContent': 'No content yet.',
  'dsFlow.sectionNoDetails': 'No details yet.',
  'dsFlow.setDefaultAction': 'Default for new chats',
  'dsFlow.setDefaultTitle': 'Preselect this design system for new chats and new projects.',
  'dsFlow.sourceEvidence': 'Source evidence',
  'dsFlow.sourceTypeBundled': 'Bundled',
  'dsFlow.sourceTypeDefault': 'Design system',
  'dsFlow.sourceTypeGithub': 'GitHub import',
  'dsFlow.sourceTypeInstalled': 'Installed',
  'dsFlow.sourceTypeLocal': 'Local import',
  'dsFlow.sourceTypeUser': 'User workspace',
  'dsFlow.statusUpdateFailed': 'Could not update status',
  'dsFlow.stepReadCurrentSystem': 'Read current system',
  'dsFlow.stepRefreshReview': 'Refresh review',
  'dsFlow.stepUpdateDesignFiles': 'Update design files',
  'dsFlow.subtitleBrand': 'Logo, voice and usage rules',
  'dsFlow.subtitleColor': 'Palette and semantic roles',
  'dsFlow.subtitleComponents': 'Reusable interface patterns',
  'dsFlow.subtitleDefault': 'Design guidance',
  'dsFlow.subtitleSpacing': 'Spacing scale and radius tokens',
  'dsFlow.subtitleTypography': 'Text hierarchy and styles',
  'dsFlow.tabDesignFiles': 'Design Files',
  'dsFlow.tabDesignSystem': 'Design System',
  'dsFlow.tokenContractLabel': 'Token contract',
  'dsFlow.tokenContractRebuildRecommended': 'rebuild recommended',
  'dsFlow.tokenContractReportAvailable': 'quality report available',
  'dsFlow.tokenContractScore': 'score {score}',
  'dsFlow.tokenRebuildStarted': 'Token contract rebuild started',
  'dsFlow.tokenRebuildStartFailed': 'Could not start token contract rebuild',
  'dsFlow.workspaceOpenFailed': 'Could not open the design system workspace.',
  'dsFlow.workspaceUpdatedReview': 'Workspace updated. Review the files or ask for another change.',
  'dsFlow.workspaceUpdatedSynced': 'Workspace updated and DESIGN.md synced for review.',
  'dsFlow.workspaceUpdatedWithAudit': 'Workspace updated. {summary}',
  'dsFlow.yes': 'Yes',
  'pluginDetail.backToList': 'Back to list',
  'pluginDetail.quickCommands': 'Quick commands',
  'pluginDetail.noQuickCommands': 'No quick commands available.',
  'pluginDetail.dataConnections': 'Data connections',
  'pluginDetail.noDataConnections': 'This suite does not require any external data connections.',
  'pluginDetail.knowledgeSkills': 'Knowledge skills',
  'pluginDetail.noKnowledgeSkills': 'This suite has no standalone knowledge skills yet.',
  'pluginDetail.officialBadge': 'OpenDesign official',
  'pluginDetail.loadFailed': 'Failed to load plugin: {error}',
  'pluginDetail.applyFailed': 'Apply failed. Make sure the daemon is reachable.',
  'pluginDetail.examples': 'Examples',
  'skillDetail.providedBy': 'provided by {author}',
  'skillDetail.markdownNotice': 'The following content is taken verbatim from this skill’s SKILL.md',
  'skillDetail.loadFailed': 'Couldn’t load this skill’s SKILL.md.',
  'skillDetail.previewAria': '{title} SKILL.md preview',
  'common.dismiss': 'Dismiss',
  'campaign.deepseekV4Flash.headline': 'This time, put top-tier intelligence to work. Unlimited.',
  'campaign.deepseekV4Flash.description': 'Landing pages, sites, decks, and images — make as much as you need until it feels right.',
  'campaign.deepseekV4Flash.benefit': 'Unlimited DeepSeek V4 Pro and V4 Flash',
  'campaign.deepseekV4Flash.timing': 'Aug 13–27: free to use during the campaign window',
  'campaign.deepseekV4Flash.ruleSummary': 'From Aug 13–27, paid users can use DeepSeek V4 Pro and V4 Flash for free in OpenDesign. Large-scale abuse may pause campaign access.',
  'campaign.deepseekV4Flash.windowLabel': 'Aug 13–27',
  'campaign.deepseekV4Flash.weekFreeSuffix': 'two weeks free',
  'campaign.deepseekV4Flash.boundary': 'Unlimited model quota and free generation counts in your plan apply only inside OpenDesign — not via MCP, CLI, API, or other surfaces. Final interpretation rests with OpenDesign. Some models may need to queue at peak hours.',
  'campaign.deepseekV4Flash.countdownLabel': 'Campaign countdown',
  'campaign.deepseekV4Flash.countdownEnded': 'Campaign ended',
  'campaign.deepseekV4Flash.countdownRemaining': '{days}d {hms}',
  'campaign.deepseekV4Flash.closeAria': 'Close',
  'campaign.deepseekV4Flash.unlocked': 'Unlocked',
  'campaign.deepseekV4Flash.locked': 'Locked',
  'campaign.deepseekV4Flash.later': 'Not now',
  'campaign.deepseekV4Flash.paid.eyebrow': 'Two weeks free',
  'campaign.deepseekV4Flash.paid.status': 'Unlocked · Aug 13–27',
  'campaign.deepseekV4Flash.paid.cta': 'Use now',
  'campaign.deepseekV4Flash.paid.modelBadge': 'Unlimited',
  'campaign.deepseekV4Flash.unpaid.eyebrow': 'Free for paid plans',
  'campaign.deepseekV4Flash.unpaid.status': 'Upgrade to unlock · through Aug 27',
  'campaign.deepseekV4Flash.unpaid.cta': 'Upgrade and use',
  'campaign.deepseekV4Flash.unpaid.modelBadge': 'Upgrade to use',
  'campaign.deepseekV4Flash.unpaid.tooltip': 'Subscribe during the campaign window to use it free; ends Aug 27.',
  'campaign.deepseekV4Flash.restricted.modelBadge': 'Paused',
  'campaign.deepseekV4Flash.restricted.tooltip': 'Unusual high-volume usage was detected, so campaign access is paused. Contact support if you need help.',
  'campaign.deepseekV4Flash.workbenchBadge': 'DeepSeek V4 Pro + V4 Flash unlimited free',
  'campaign.deepseekV4Flash.workbenchBadgeAria': 'DeepSeek V4 Pro and V4 Flash unlimited free — view Pricing',

  'experienceSurvey.tag': "We'd love your feedback — help improve OpenDesign",
  'experienceSurvey.close': "Close",
  'experienceSurvey.recommendation': "How likely are you to recommend OpenDesign to a colleague or friend?",
  'experienceSurvey.recommendationLow': "Not at all likely",
  'experienceSurvey.recommendationHigh': "Extremely likely",
  'experienceSurvey.improvement': "Which one should we improve first?",
  'experienceSurvey.improvement.wrongOutput': "Not what I asked for",
  'experienceSurvey.improvement.falseDone': "Claimed done, nothing changed",
  'experienceSurvey.improvement.hardToUse': "Hard to use",
  'experienceSurvey.improvement.upgradePrompts': "Too many upgrade prompts",
  'experienceSurvey.improvement.stuck': "Gets stuck or fails",
  'experienceSurvey.improvement.slow': "Too slow",
  'experienceSurvey.improvement.looks': "Doesn't look good",
  'experienceSurvey.improvement.regression': "Breaks other things",
  'experienceSurvey.improvement.other': "Something else",
  'experienceSurvey.otherPlaceholder': "Tell us in your own words",
  'experienceSurvey.submit': "Send",
  'experienceSurvey.skip': "Skip",
  'experienceSurvey.thanksTitle': "Thank you!",
  'experienceSurvey.thanksBody': "Your feedback goes straight to the team.",
  'chat.record.verb.read': "Read",
  'chat.record.verb.write': "Wrote",
  'chat.record.verb.edit': "Edited",
  'chat.record.verb.search': "Searched",
  'chat.record.verb.exec': "Ran",
  'chat.record.failed': "Failed",
  'chat.record.hits': "{count} hits",
  'chat.record.slowUpstream': 'The provider is slow to respond — waiting {seconds}s',
  'chat.record.running': "Working",
  'chat.record.thinking': "Thinking",
  'chat.record.thinkingTokens': "{count} tokens",
  'chat.record.thoughts': "Thoughts",
  'chat.record.done': "Done",
  'chat.record.failedTurn': "Run failed",
  'chat.record.plan': "Plan · {count} steps",
  'chat.record.planStep': "Step {current} of {total}",
  'chat.record.imageBatch': "Generating illustrations",
  'chat.record.imageCount': "{count} images",
  'chat.record.retry': "Retry",
  'chat.record.viewImage': "View image {index}",
  'chat.record.viewLarge': "View full size",
  'chat.record.imagePending': "Generating illustration…",
  'chat.record.audioBatch': "Generating audio",
  'chat.record.videoBatch': "Generating video",
  'chat.record.audioCount': "{count} clips",
  'chat.record.videoCount': "{count} videos",
  'chat.record.audioPending': "Generating audio…",
  'chat.record.videoPending': "Generating video…",
  'chat.record.viewAudio': "Open audio {index}",
  'chat.record.viewVideo': "Open video {index}",
  /* 设计稿 729fa43ce7:docs/design/chat-panel/src/body-components.html:50-51,逐字 */
  'chat.designSystemStatus.title': 'Creating design system workspace',
  'chat.designSystemStatus.description': 'Open Design is using the setup sources to generate this project.',
  'labs.title': "Open Design Labs",
  'labs.itemAbout': "About {name}",
  'labs.navHint': "Try capabilities before they ship.",
  'labs.pageDesc': "Get early access to capabilities that have not shipped yet. They are usually better than what you have today, and turning one off restores the current behaviour right away.",
  'labs.harnessName': "Design Harness",
  'labs.harnessHint': "Your next generation will use OpenDesign's latest strategy, with noticeably more polished results (beta)",
  'labs.harnessTooltip': "Switches to the agent harness Open Design built for design work. Output is noticeably better in layout, structure, and completeness.",
  'labs.harnessScope': "Covers prototypes, slides, marketing assets, and Hyperframes today. Some agents are not supported yet.",
  'labs.envOverrideNotice': "An environment variable is controlling this setting, so it cannot be changed here.",
  'labs.loadFailedNotice': "Could not read this setting. Check that the local daemon is running.",
  'labs.optOutPrompt': "Switched back to the previous approach. What did not work?",
  'labs.optOutWorseOutput': "Output got worse",
  'labs.optOutTooSlow': "Too slow",
  'labs.optOutNotWhatIWanted': "Not what I wanted",
  'labs.optOutOther': "Other",
  'labs.optOutSkip': "Skip",
  'labs.optOutOtherPlaceholder': "What specifically did not work?",
  'labs.optOutSubmit': "Submit",
  'chat.conversationsSearchPlaceholder': "Search conversations",
  'chat.conversationsNoMatches': "No conversations match.",
  'chat.attachments.preview': "Preview {name}",
  'chat.record.canceled': "Canceled",
  'chat.record.pending': "Not started",
  'chat.record.unfinished': "Unfinished",
};
